/* eslint-disable */
import React, { Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import {
	Grid,
	MenuItem,
	Paper,
	Checkbox,
	Select,
	Typography,
	AccordionDetails,
	Tooltip,
	AccordionSummary
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useHistory, useLocation } from "react-router-dom";
import {
	AuthContext,
	DependentsContext,
	EligibleDependentContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
	// PaycheckContext
} from "../../../contexts";
import { StandardPlanDependency, VEBPlanFormProps } from "../../../types/components/enrollmentProps.types";
import { Member } from "../../../types/employee.types";
import { LazyCustomFormDialog, LazyPlanActions } from "../../shared";
import EligiblityDialog from "./eligiblityDialogs/EligiblityDialog";
import VEBPlanHeader from "../../shared/enrollment/VEBPlanHeader/PlanHeader";
import ExistsDependentModelVEB from "../../shared/existsMemberModel/ExistsDependentModelVEB";
import { CustomSelectInput } from "../../shared/CustomInput";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import {
	generateActivateVEBEnrollmentPayload,
	generateBeamVisionWaiveEnrollmentPayload,
	generateCancerKemperWaiveEnrollmentPayload,
	generateWholeLifeActivateVEBEnrollmentPayload
} from "../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../utils/commonFunctions/groupEnrollment/enrollment";
import { VEB_TO_GENERAL_COVERAGE_CODE, VEBToGeneralCoverageCodeType } from "../../../constants/coverage";
import {
	getBeamVisionEligibleDependents,
	getCommonEligibleDependents
} from "../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CustomFormDialogType } from "../../../types/components/dialogProps.types";
import { CustomDisclaimerDialogPropsType } from "../../../types/dialogProps.types";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../constants/VEBYearlyOpenAndCurrentDate";
import { AddEnrollmentPayload, VEBEnrollmentPayload } from "../../../utils/api/enrollment/enrollment";
import { dynamicPremiumCalculation } from "./PremimumCalculation";
import { useGetActiveVEBPlansQuery } from "../../../features/VEBPlans/vebPlansApi";
import { Accordion, FormControlLabel } from "@material-ui/core";
import {
	CommonDetails,
	CoverageCode,
	StandardDetails,
	VEBEnrollments,
	VEBEnrollmentSchema,
	VEBWholeLifeEnrollments
} from "../../../types/enrollment.types";
import VEBBeneficiary from "./VEBBeneficiary/VEBBeneficiary";
import { BV2Beneficiery } from "../../../types/BV2Beneficiery.types";
import { VEBOpenEnrollment } from "../../../types/openEnrollment.types";
import { Paycheck } from "../../../types/paycheck.types";
import {
	DEPENDENCY_MESSAGE,
	ENROLLMENT_API_MAP,
	ENROLLMENT_DEPENDENCY_DIALOGPROP_LABEL,
	EnrollmentApiFn
} from "../../../constants/VEB/dependencyMessage";
import EnrollmentDependencyDialog from "./plans/kemper/cancer/dependencyDialog/EnrollmentDependencyDialog";
import { AccidentDocAndRxPlanDetails, PaycheckFrequency, VEBPlan } from "../../../types/plan.types";
import { VEBPlanSchema } from "../../../types/VEBPlanSchema";
import CustomEnrollmentDisclaimerDialog from "../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import { dateTimeZoneConverter, getCurrentDate, manualDateComparator } from "../../../utils/commonFunctions/date";
import { RELATIONSHIP } from "../../../constants/relationship";
import QuestionFlowModal, { IQuestion, IQuestionAnswer, QuestionFlowTrigger } from "./Questionflowmodal";
import SIQuestionsModal, { SIApplicantType, SIQuestionAnswer } from "./Siquestionsmodal";
import { SIStatusBadge } from "./SIStatusBadge";
import GeneralQuestionsForm from "./generalQuestionModel";
import GIQuestionsForm from "./generalQuestionModel";
import GEneralQuestionsModal from "./generalQuestionModel";
import { Padding } from "@mui/icons-material";
type DialogAction = {
	label: string;
	name: "cancel" | "waive";
	callback: () => void;
};
export interface QuestionAnswer {
	question_id: string;
	question_text: string;
	answer: string;
}
export interface ApplicantStore {
	role: "employee" | "spouse" | "child";
	answers: SIQuestionAnswer[];
	eligible: boolean;
	reducedToGI: boolean;
	member_object_id: string;
	member_SSN: string;
	child_name?: string;
	face_amount: number;
	gi_limit: number;
	exceeds_gi: boolean;
}
interface BeneficiaryState {
	employeePrimary: BV2Beneficiery[];
	employeeContingent: BV2Beneficiery[];
	spousePrimary: BV2Beneficiery[];
	spouseContingent: BV2Beneficiery[];
	childPrimary: BV2Beneficiery[];
	childContingent: BV2Beneficiery[];
}

const EMPTY_BENEFICIARIES: BeneficiaryState = {
	employeePrimary: [],
	employeeContingent: [],
	spousePrimary: [],
	spouseContingent: [],
	childPrimary: [],
	childContingent: []
};

function makeBeneficiary(planFor: Member, insuredSSN: string, relationship: string | null): BV2Beneficiery {
	return {
		first_name: planFor.first_name,
		last_name: planFor.last_name,
		middle_name: planFor.middle_name ?? "",
		type: "PRIMARY",
		insured_SSN: insuredSSN,
		relationship,
		address_line_1: planFor.address_line_1,
		address_line_2: planFor.address_line_2,
		state: planFor.state,
		ZIP: planFor.ZIP,
		SSN: planFor.SSN,
		date_of_birth: dateTimeZoneConverter(planFor.date_of_birth as string) as unknown as string,
		gender: planFor.gender,
		percentage: 100,
		phone_number: planFor.phone_number
	};
}

function buildAutoFillBeneficiaries(
	coverage: string,
	member: Member,
	spouse: Member | undefined,
	children: Member[]
): Partial<BeneficiaryState> {
	const reset: Partial<BeneficiaryState> = {
		employeePrimary: [],
		employeeContingent: [],
		spousePrimary: [],
		spouseContingent: [],
		childPrimary: [],
		childContingent: []
	};

	switch (coverage) {
		case "Employee Only": {
			if (spouse) {
				reset.employeePrimary = [makeBeneficiary(spouse, member.SSN, spouse.relationship)];
			}
			return reset;
		}

		case "Employee & Spouse": {
			if (spouse) {
				reset.employeePrimary = [makeBeneficiary(spouse, member.SSN, spouse.relationship)];
				reset.spousePrimary = [makeBeneficiary(member, spouse.SSN, null)];
			}
			return reset;
		}

		case "Employee & Children": {
			if (children.length > 0) {
				reset.employeePrimary = [makeBeneficiary(children[0], member.SSN, children[0].relationship)];
				reset.childPrimary = [makeBeneficiary(member, children[0].SSN, null)];
			}
			return reset;
		}

		case "Employee & Family": {
			if (spouse) {
				reset.employeePrimary = [makeBeneficiary(spouse, member.SSN, spouse.relationship)];
				reset.spousePrimary = [makeBeneficiary(member, spouse.SSN, null)];
			}
			if (children.length > 0) {
				reset.childPrimary = [makeBeneficiary(member, children[0].SSN, null)];
			}
			return reset;
		}
		case "Spouse Only": {
			if (spouse) {
				reset.spousePrimary = [makeBeneficiary(member, spouse.SSN, null)];
			}
			return reset;
		}

		case "Children Only": {
			if (children.length > 0) {
				reset.childPrimary = [makeBeneficiary(member, children[0].SSN, null)];
			}
			return reset;
		}

		case "Spouse & Children": {
			if (spouse) {
				reset.spousePrimary = [makeBeneficiary(member, spouse.SSN, null)];
			}
			if (children.length > 0) {
				reset.childPrimary = [makeBeneficiary(member, children[0].SSN, null)];
			}
			return reset;
		}

		default:
			return reset;
	}
}
const CommonForm = ({
	getVEBEnrollmentInitData,
	VEBOpenEnrollment,
	dependents,
	planname,
	planCode,
	isCore = false,
	corePlans = [],
	// ── Core-only props. All optional, so the VEB path is unaffected when they are absent. ──
	isActiveEnrollment = false,
	selectedPlan = null,
	getEnrollmentInitData,
	openEnrollment = null,
	setSubmittedEnrollment,
	previousEnrollments
}: VEBPlanFormProps) => {
	const history = useHistory();
	const location = useLocation();
	const urlSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	//all context
	const { member, setMember } = useContext(AuthContext);
	const { groupOwner } = useContext(GroupOwnerContext);
	const { paycheck } = useContext(PaycheckContext);
	const { setDependents } = useContext(DependentsContext);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const { setEligiblity } = useContext(EligibleDependentContext);
	const { theme } = useContext(ThemeContext);
	const [waiveReason, setWaiveReason] = useState("");
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [totalPremium, setTotalPremium] = useState(0);
	const [writingNumber] = useState(1408);
	const [Plan, setCurrentPlan] = useState<any>();
	const [selectedAction, setSelectedAction] = useState(false);
	const [expanded_panel, setExpandedPanel] = useState<string | false>("panel_beneficiary");
	const [hasCancerEnrollment, setHasAlreadyEnrollment] = useState<null | boolean>(null);
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [standardPremium, setStandardPremium] = useState(0);
	const [riderPremium, setRiderPremium] = useState(0);
	const [spousePremium, setSpousePremium] = useState(0);
	const [hasSelectedRider, setHasSelectedRider] = useState(false);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const [existsEnrollmentMeta, setExistsEnrollmentMeta] = useState<{
		newCoverageLabel: string | null;
		newTotalPremium: number | null;
	} | null>(null);
	const [questionFlowOpen, setQuestionFlowOpen] = useState(false);
	const siDataStoreRef = useRef<ApplicantStore[]>([]);
	const riderSiDataStoreRef = useRef<ApplicantStore[]>([]);
	const siSubmittedStatusRef = useRef({ EMPLOYEE: false, SPOUSE: false, CHILD: false });
	const riderSiSubmittedStatusRef = useRef({ EMPLOYEE: false, SPOUSE: false, CHILD: false });

	const autoFilledPlanCodeRef = useRef<string | null>(null);

	const [generalQuestionAnswers, setGeneralQuestionAnswers] = useState<QuestionAnswer[]>([]);
	// Dialog state
	const [enrollmentDependencyDialogProps, setEnrollmentDependencyDialogProps] = useState<{
		openDialog: boolean;
		content: string;
		actions: DialogAction[];
	}>({ openDialog: false, content: "", actions: [] });
	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"I represent to the best of my knowledge and belief that all information provided during enrollment or application is complete, true, and accurately recorded. I understand that insurers and plan administrators will rely on this information to determine eligibility, coverage, and claim outcomes, and may verify details such as medical or prescription history where applicable.I acknowledge that any material misrepresentation or omission may result in denial of claims, cancellation, or rescission of coverage in accordance with the policy terms. Coverage becomes effective only upon acceptance by the insurer, fulfillment of all applicable conditions, and receipt of the required premium.This Platform acts solely as a facilitation platform and does not underwrite, approve, or guarantee any insurance coverage, benefits, or claims",
			importantTitle: "NOTE",
			importantContent:
				"Any person who knowingly provides false, incomplete, or misleading information in an application for insurance may be subject to penalties, including potential civil or criminal liability, as per applicable laws. I certify that I have authorized my employer (where applicable) to deduct premiums from my payroll for myself and any enrolled dependents.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [{ label: "Email Disclaimer", callback: () => null }]
		});

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps((prev: any) => ({
				...prev,
				openDialog: false
			})),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: planname
	});
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);

	//the main RTK query
	let currentPlans = [];
	if (isCore) {
		currentPlans = corePlans;
	} else {
		const { currentPlans: currentVEBPlans } = useGetActiveVEBPlansQuery(member?.group_number, {
			skip: !member?.group_number,
			refetchOnMountOrArgChange: false,
			selectFromResult: ({ data }) => ({
				currentPlans: data?.currentPlans ?? []
			})
		});
		currentPlans = currentVEBPlans;
	}
	// console.log("currentPlans--", currentPlans);
	// Plan inputs
	const [planInputs, setPlanInputs] = useState<any>({});
	const [isEmployeeTobacco, setIsEmployeeTobacco] = useState<boolean>(member?.is_tobacco ?? false);
	const [currentRelation, setCurrentRelation] = useState<"EMPLOYEE" | "SPOUSE" | "CHILD" | null>(null);
	const [eligibelDependentChild, SetEligibleDependentChild] = useState<Member[] | null>(null);
	const [eligibelDependentSpouse, SetEligibleDependentSpouse] = useState<Member | null>(null);
	//spouse section
	const spouse = useMemo(
		() => dependents.find((d: Member) => d.relationship === "SPOUSE") as Member | undefined,
		[dependents]
	);
	const [SpouseBenefit, setSpouseBenefit] = useState<number[] | null>(null);

	const [isSpouseTobacco, setIsSpouseTobacco] = useState<boolean>(spouse?.is_tobacco ?? false);
	const [spousePlanInputs, setSpousePlanInputs] = useState<any>({});
	// const showSpouseSection = Plan?.coverage_for?.options?.includes("Spouse Only");
	//child secection
	const [childPlanInputs, setChildPlanInputs] = useState<any>({});
	const [childPremium, setChildPremium] = useState(0);
	const [childBenefit, setChildBenefit] = useState();
	//dependent section
	const [dependencyPlanInputs, setDependencyPlanInputs] = useState<Record<string, any>>({});
	const [dependencyPremiums, setDependencyPremiums] = useState<Record<string, number>>({});
	//rider plan inputs
	const [riderPlanInputs, setRiderPlanInputs] = useState<any>({});
	const [riderSpousePlanInputs, setRiderSpousePlanInputs] = useState<any>({});
	const [riderChildPlanInputs, setRiderChildPlanInputs] = useState<any>({});
	const [riderCoverageOptions, setRiderCoverageOptions] = useState<string[]>([]);
	const [riderCoverageVolumeOptions, setRiderCoverageVolumeOptions] = useState<string[]>([]);
	// Rider premiums
	const [riderEmployeePremium, setRiderEmployeePremium] = useState(0);
	const [riderSpousePremium, setRiderSpousePremium] = useState(0);
	const [riderChildPremium, setRiderChildPremium] = useState(0);
	//  Coverage option lists
	const [coverageOptioin, setCoverageOptioin] = useState<string[]>([]);
	const [coverageVolume, setCoverageVolume] = useState<string[]>([]);
	const [riderCoverage, setRiderCoverage] = useState<string[]>([]);
	const [ridercoveragevolume, setRiderCoverageVolume] = useState<string[]>([]);
	const [maxBenefitAmounts, setMaxBenefitAmounts] = useState<number[]>([]);
	const [siDataStore, setSiDataStore] = useState<ApplicantStore[]>([]);
	const [siModalOpen, setSiModalOpen] = useState(false);
	const [siQueue, setSiQueue] = useState<Array<"EMPLOYEE" | "SPOUSE" | "CHILD">>([]);
	const [riderSiQueue, setRiderSiQueue] = useState<Array<"EMPLOYEE" | "SPOUSE" | "CHILD">>([]);
	const [siSubmittedStatus, setSiSubmittedStatus] = useState<{
		EMPLOYEE: boolean;
		SPOUSE: boolean;
		CHILD: boolean;
	}>({
		EMPLOYEE: false,
		SPOUSE: false,
		CHILD: false
	});
	// Rider SI
	const [riderSiSubmittedStatus, setRiderSiSubmittedStatus] = useState<{
		EMPLOYEE: boolean;
		SPOUSE: boolean;
		CHILD: boolean;
	}>({ EMPLOYEE: false, SPOUSE: false, CHILD: false });
	const [docAndRx] = useState<AccidentDocAndRxPlanDetails>({
		standard_premium: { WEEKLY: 1.16, MONTHLY: 5.03 }
	});
	const [riderSiDataStore, setRiderSiDataStore] = useState<ApplicantStore[]>([]);
	const [riderCurrentRelation, setRiderCurrentRelation] = useState<"EMPLOYEE" | "SPOUSE" | "CHILD" | null>(null);
	const [riderSiModalOpen, setRiderSiModalOpen] = useState(false);
	// GI Questions state (add after riderSiSubmittedStatusRef)
	const giDataStoreRef = useRef<ApplicantStore[]>([]);
	const giSubmittedStatusRef = useRef(false);
	const [giDataStore, setGiDataStore] = useState<ApplicantStore[]>([]);
	const [giSubmittedStatus, setGiSubmittedStatus] = useState(false);
	// const [giModalOpen, setGiModalOpen] = useState(false);
	//benefit
	const [beneficiaries, setBeneficiaries] = useState<BeneficiaryState>(EMPTY_BENEFICIARIES);
	const [showSpouseSection, setShowSpouseSection] = useState(false);
	const [showChildSection, setShowChildSection] = useState(false);
	const [showRiderChildSection, setShowRiderChildSection] = useState(false);
	const [depSpouseCheckedMap, setDepSpouseCheckedMap] = useState<Record<string, boolean>>({});
	const [depChildCheckedMap, setDepChildCheckedMap] = useState<Record<string, boolean>>({});

	const children = useMemo(
		() =>
			dependents.filter(
				(d: Member) =>
					d.relationship === "CHILD" ||
					d.relationship === "STEP CHILD" ||
					d.relationship === "CORT-ORDER CHILD"
			) as Member[],
		[dependents]
	);

	const riderGI_LIMITS = useMemo(
		() => ({
			EMPLOYEE: Plan?.rider?.benefit_amount?.guaranteed_issue_amount ?? 0,
			SPOUSE: Plan?.rider?.benefit_amount?.spouse?.guaranteed_issue_amount ?? 0,
			CHILD: Plan?.rider?.benefit_amount?.child?.guaranteed_issue_amount ?? 0
		}),
		[Plan]
	);

	const hasRiderEmployeeSIQuestions = useMemo(
		() =>
			(Plan?.rider?.benefit_amount?.si_questions?.length ?? 0) > 0 ||
			(Plan?.rider?.benefit_amount?.employee?.si_questions?.length ?? 0) > 0,
		[Plan]
	);

	const hasRiderSpouseSIQuestions = useMemo(
		() =>
			Plan?.rider?.benefit_amount?.spouse?.has_si_questions === true &&
			(Plan?.rider?.benefit_amount?.spouse?.si_questions?.length ?? 0) > 0,
		[Plan]
	);

	const hasRiderChildSIQuestions = useMemo(
		() =>
			Plan?.rider?.benefit_amount?.child?.has_si_questions === true &&
			(Plan?.rider?.benefit_amount?.child?.si_questions?.length ?? 0) > 0,
		[Plan]
	);

	const riderEmployeeNeedsSI = useMemo(
		() =>
			hasRiderEmployeeSIQuestions &&
			riderGI_LIMITS.EMPLOYEE > 0 &&
			Number(riderPlanInputs.benefit_amount ?? 0) > riderGI_LIMITS.EMPLOYEE,
		[hasRiderEmployeeSIQuestions, riderGI_LIMITS.EMPLOYEE, riderPlanInputs.benefit_amount]
	);

	const riderSpouseNeedsSI = useMemo(
		() =>
			hasRiderSpouseSIQuestions &&
			riderGI_LIMITS.SPOUSE > 0 &&
			Number(riderSpousePlanInputs.benefit_amount ?? 0) > riderGI_LIMITS.SPOUSE,
		[hasRiderSpouseSIQuestions, riderGI_LIMITS.SPOUSE, riderSpousePlanInputs.benefit_amount]
	);

	const riderChildNeedsSI = useMemo(
		() =>
			hasRiderChildSIQuestions &&
			riderGI_LIMITS.CHILD > 0 &&
			Number(riderChildPlanInputs.benefit_amount ?? 0) > riderGI_LIMITS.CHILD,
		[hasRiderChildSIQuestions, riderGI_LIMITS.CHILD, riderChildPlanInputs.benefit_amount]
	);

	// Add this derived value — computed synchronously, no state lag
	const effectiveCoverage = useMemo(() => {
		const canEnrollIndependently = Plan?.can_each_relationship_enroll_indipendently_in_this_plan;

		const spouseCanEnrollAlone = Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;

		const childCanEnrollAlone = Plan?.benefit_amount?.child?.child_can_enroll_individually;

		const employeeRequired = Plan?.employee_required;

		if (!canEnrollIndependently) {
			return planInputs.coverage ?? null;
		}

		// Employee
		const hasEmployee = employeeRequired ? true : !!(planInputs.coverage_volume || planInputs.benefit_amount);

		// Spouse
		let hasSpouse = false;

		if (canEnrollIndependently && employeeRequired) {
			hasSpouse = !!(spousePlanInputs.coverage_volume || spousePlanInputs.benefit_amount);
		} else if (
			canEnrollIndependently &&
			!employeeRequired &&
			spouseCanEnrollAlone &&
			(spousePlanInputs.coverage_volume || spousePlanInputs.benefit_amount)
		) {
			hasSpouse = true;
		}

		// Child
		let hasChild = false;

		if (canEnrollIndependently && employeeRequired) {
			hasChild = !!(childPlanInputs.coverage_volume || childPlanInputs.benefit_amount);
		} else if (canEnrollIndependently && !employeeRequired && childCanEnrollAlone) {
			hasChild = true;
		}
		if (
			canEnrollIndependently &&
			!employeeRequired &&
			(childPlanInputs.benefit_amount || childPlanInputs.coverage_volume)
		) {
			hasChild = !!(childPlanInputs.coverage_volume || childPlanInputs.benefit_amount);
		} else if (canEnrollIndependently && !employeeRequired && childCanEnrollAlone) {
			hasChild = true;
		} else if (canEnrollIndependently && !employeeRequired && childPlanInputs.benefit_amount) {
			hasChild = true;
		}

		// Resolve coverage label
		if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";

		if (hasEmployee && hasSpouse) return "Employee & Spouse";

		if (hasEmployee && hasChild) return "Employee & Children";

		if (hasEmployee) return "Employee Only";

		if (hasSpouse && hasChild) return "Spouse & Children";

		if (hasSpouse) return "Spouse Only";

		if (hasChild) return "Children Only";

		return null;
	}, [
		Plan,
		planInputs.coverage,
		planInputs.coverage_volume,
		planInputs.benefit_amount,
		spousePlanInputs.coverage,
		spousePlanInputs.coverage_volume,
		spousePlanInputs.benefit_amount,
		childPlanInputs.coverage,
		childPlanInputs.coverage_volume,
		childPlanInputs.benefit_amount
	]);
	// console.log("effectiveCoverage1231464", effectiveCoverage);
	const effectiveRiderCoverage = useMemo(() => {
		const cov = riderPlanInputs.coverage;

		const hasEmployee = !!riderPlanInputs.coverage;
		const hasSpouse = !!(riderSpousePlanInputs.benefit_amount || riderSpousePlanInputs.coverage_volume);
		const hasChild = !!(riderChildPlanInputs.benefit_amount || riderChildPlanInputs.coverage_volume);

		if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
		if (hasEmployee && hasSpouse) return "Employee & Spouse";
		if (hasEmployee && hasChild) return "Employee & Children";
		if (hasEmployee) return riderPlanInputs.coverage;
		if (hasSpouse && hasChild) return "Spouse & Children";
		if (hasSpouse) return "Employee & Spouse";
		if (hasChild) return "Employee & Children";
		return null;
	}, [
		riderPlanInputs.coverage,
		riderSpousePlanInputs.benefit_amount,
		riderSpousePlanInputs.coverage_volume,
		riderChildPlanInputs.benefit_amount,
		riderChildPlanInputs.coverage_volume,
		planInputs.rider_present
	]);
	// console.log("effectiveRiderCoverage", effectiveRiderCoverage);

	// Coverage tier (EE / ES / EC / ECH …) the server now requires on every
	// GI/SI submission. This mirrors the exact derivation the enroll handler uses
	// for the enrollment rows (finalCoverageForCode + promotion), so the SI/GI
	// record carries the same coverage_code as the enrollment itself. Deriving it
	// from effectiveCoverage alone is not enough — that value is null/unmapped for
	// spouse/child-only selections.

	// When a plan allows independent enrollment and the employee is NOT required,
	// a spouse/child-only selection is recorded as an employee-inclusive tier
	// (Spouse Only -> ES, Children Only -> EC, Spouse & Children -> EF).
	const promoteForZeroEmployee =
		!!Plan?.can_each_relationship_enroll_indipendently_in_this_plan &&
		!Plan?.employee_required &&
		!planInputs?.coverage;

	const coverageCode = useMemo(() => {
		const finalCoverageForCode = (() => {
			if (!Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
				return effectiveCoverage;
			}

			const spouseEnrollingIndividually =
				Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually && !!spousePlanInputs?.benefit_amount;
			const childEnrollingIndividually =
				Plan?.benefit_amount?.child?.child_can_enroll_individually && !!childPlanInputs?.benefit_amount;

			const hasEmployee = !!planInputs?.coverage;
			const hasSpouse =
				spouseEnrollingIndividually ||
				!!spousePlanInputs?.coverage_volume ||
				!!spousePlanInputs?.benefit_amount;
			const hasChild =
				childEnrollingIndividually || !!childPlanInputs?.coverage_volume || !!childPlanInputs?.benefit_amount;

			if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
			if (hasEmployee && hasSpouse) return "Employee & Spouse";
			if (hasEmployee && hasChild) return "Employee & Children";
			if (hasEmployee) return "Employee Only";
			if (hasSpouse && hasChild) return "Spouse & Children";
			if (hasSpouse) return "Spouse Only";
			if (hasChild) return "Children Only";

			return effectiveCoverage;
		})();

		const promoted = promoteForZeroEmployee
			? {
					"Spouse Only": "Employee & Spouse",
					"Children Only": "Employee & Children",
					"Spouse & Children": "Employee & Family"
			  }[finalCoverageForCode as string] ?? finalCoverageForCode
			: finalCoverageForCode;

		return VEB_TO_GENERAL_COVERAGE_CODE[promoted as keyof VEBToGeneralCoverageCodeType];
	}, [Plan, planInputs?.coverage, spousePlanInputs, childPlanInputs, effectiveCoverage, promoteForZeroEmployee]);

	// The rider tier is always promoted to employee-inclusive (matching the enroll
	// handler's promoteRiderCoverageLabel), and derived from the rider inputs.
	const riderCoverageCode = useMemo(() => {
		const finalRiderCoverageForCode = (() => {
			// Same reasoning as effectiveRiderCoverage above: only a real benefit
			// amount / coverage volume selection counts as the spouse/child being
			// enrolled in the rider, not the auto-populated `.coverage` flag.
			const hasEmployee = !!riderPlanInputs?.coverage;
			const hasSpouse = !!(riderSpousePlanInputs?.benefit_amount || riderSpousePlanInputs?.coverage_volume);
			const hasChild = !!(riderChildPlanInputs?.benefit_amount || riderChildPlanInputs?.coverage_volume);

			if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
			if (hasEmployee && hasSpouse) return "Employee & Spouse";
			if (hasEmployee && hasChild) return "Employee & Children";
			if (hasEmployee) return "Employee Only";
			if (hasSpouse && hasChild) return "Spouse & Children";
			if (hasSpouse) return "Spouse Only";
			if (hasChild) return "Children Only";

			return effectiveRiderCoverage;
		})();

		const promoted =
			{
				"Spouse Only": "Employee & Spouse",
				"Children Only": "Employee & Children",
				"Spouse & Children": "Employee & Family"
			}[finalRiderCoverageForCode as string] ?? finalRiderCoverageForCode;

		return VEB_TO_GENERAL_COVERAGE_CODE[promoted as keyof VEBToGeneralCoverageCodeType];
	}, [
		riderPlanInputs?.coverage,
		riderSpousePlanInputs?.benefit_amount,
		riderSpousePlanInputs?.coverage_volume,
		riderChildPlanInputs?.benefit_amount,
		riderChildPlanInputs?.coverage_volume,
		effectiveRiderCoverage
	]);

	// Combined coverage tier = the UNION of who is covered across the standard plan
	// and the rider. Both codes are already promoted to employee-inclusive tiers, so
	// a member is covered for spouse/child if EITHER the standard plan OR the rider
	// covers them. Example: standard = Employee Only (EE) + rider = Spouse & Child
	// => combined = EF. Every enrollment row (standard + rider) and every SI/GI
	// section carries this one common code so they never disagree.
	const combinedCoverageCode = useMemo(() => {
		const riderActive = !!planInputs?.rider_present;
		const codes = [coverageCode, riderActive ? riderCoverageCode : undefined].filter(Boolean) as string[];
		if (codes.length === 0) return undefined;

		const hasSpouse = codes.some((c) => c === "ES" || c === "EF" || c === "ED");
		const hasChild = codes.some((c) => c === "ECH" || c === "EF" || c === "ED");

		if (hasSpouse && hasChild) return "EF";
		if (hasSpouse) return "ES";
		if (hasChild) return "ECH";
		return "EE";
	}, [coverageCode, riderCoverageCode, planInputs?.rider_present]);
	const [selectedRiderChildren, setSelectedRiderChildren] = useState<string[]>([]);

	const handleRiderChildToggle = (childId: string) => {
		setSelectedRiderChildren((prev) =>
			prev.includes(childId) ? prev.filter((id) => id !== childId) : [...prev, childId]
		);
	};
	const resolvedPlan = useMemo(() => {
		if (!currentPlans?.length) return undefined;

		let plan = currentPlans.find((p: any) => p.plan_name === planname);
		if (!plan) return undefined;

		if (selectedAction) {
			const depStandard = plan?.standard_plan_dependency?.[0];
			const depRider = plan?.rider_plan_dependency?.[0];
			plan =
				(depStandard && currentPlans.find((p: any) => p.plan_name === depStandard)) ||
				(depRider && currentPlans.find((p: any) => p.rider?.name === depRider)) ||
				plan;
		}

		return plan;
	}, [currentPlans, planname, selectedAction]);
	const GI_LIMITS = useMemo(
		() => ({
			EMPLOYEE: Plan?.guaranteed_issue_amount ?? 0,
			SPOUSE: Plan?.benefit_amount?.spouse?.guaranteed_issue_amount ?? 0,
			CHILD: Plan?.benefit_amount?.child?.guaranteed_issue_amount ?? 0
		}),
		[Plan]
	);
	const hasEmployeeSIQuestions = useMemo(
		() =>
			(Plan?.benefit_amount?.si_questions?.length ?? 0) > 0 ||
			(Plan?.benefit_amount?.employee?.si_questions?.length ?? 0) > 0 ||
			(Plan?.general_questions?.length ?? 0) > 0 ||
			(Plan?.si_questions?.length ?? 0) > 0,
		[Plan]
	);
	const hasSpouseSIQuestions = useMemo(
		() =>
			Plan?.benefit_amount?.spouse?.has_si_questions === true &&
			(Plan?.benefit_amount?.spouse?.si_questions?.length ?? 0) > 0,
		[Plan]
	);

	const hasChildSIQuestions = useMemo(
		() =>
			Plan?.benefit_amount?.child?.has_si_questions === true &&
			(Plan?.benefit_amount?.child?.si_questions?.length ?? 0) > 0,
		[Plan]
	);

	const employeeNeedsSI = useMemo(
		() =>
			hasEmployeeSIQuestions &&
			GI_LIMITS.EMPLOYEE > 0 &&
			Number(planInputs.benefit_amount ?? 0) > GI_LIMITS.EMPLOYEE,
		[hasEmployeeSIQuestions, GI_LIMITS.EMPLOYEE, planInputs.benefit_amount]
	);

	const spouseNeedsSI = useMemo(
		() =>
			hasSpouseSIQuestions &&
			GI_LIMITS.SPOUSE > 0 &&
			Number(spousePlanInputs.benefit_amount ?? 0) > GI_LIMITS.SPOUSE,
		[hasSpouseSIQuestions, GI_LIMITS.SPOUSE, spousePlanInputs.benefit_amount]
	);

	const childNeedsSI = useMemo(
		() =>
			hasChildSIQuestions && GI_LIMITS.CHILD > 0 && Number(childPlanInputs.benefit_amount ?? 0) > GI_LIMITS.CHILD,
		[hasChildSIQuestions, GI_LIMITS.CHILD, childPlanInputs.benefit_amount]
	);
	// Sync resolvedPlan → Plan state (child components read `Plan`)
	const setBV2EmployeePrimaryBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				employeePrimary: typeof v === "function" ? v(prev.employeePrimary) : v
			})),
		[]
	);
	const setBV2EmployeeContingentBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				employeeContingent: typeof v === "function" ? v(prev.employeeContingent) : v
			})),
		[]
	);

	const setBV2SpousePrimaryBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				spousePrimary: typeof v === "function" ? v(prev.spousePrimary) : v
			})),
		[]
	);
	const setBV2SpouseContingentBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				spouseContingent: typeof v === "function" ? v(prev.spouseContingent) : v
			})),
		[]
	);
	const setBV2ChildPrimaryBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				childPrimary: typeof v === "function" ? v(prev.childPrimary) : v
			})),
		[]
	);
	const setBV2ChildContingentBeneficiary = useCallback(
		(v: BV2Beneficiery[] | ((p: BV2Beneficiery[]) => BV2Beneficiery[])) =>
			setBeneficiaries((prev) => ({
				...prev,
				childContingent: typeof v === "function" ? v(prev.childContingent) : v
			})),
		[]
	);
	const setCoverageOption = useCallback(() => {
		const planOptions = Plan?.coverage_for?.options;

		if (!Array.isArray(planOptions)) {
			setCoverageOptioin([]);
			return;
		}

		const options: string[] = [];

		if (planOptions.includes("Employee Only")) {
			options.push("Employee Only");
		}

		if (eligibleDependents.length > 0) {
			const eligibleChildren = eligibleDependents.filter(
				(e) =>
					e.relationship === "CHILD" ||
					e.relationship === "STEP CHILD" ||
					e.relationship === "CORT-ORDER CHILD"
			);

			const eligibleSpouse = eligibleDependents.find((e) => e.relationship === "SPOUSE");

			/* store all eligible children */
			SetEligibleDependentChild(eligibleChildren);

			/* store eligible spouse */
			SetEligibleDependentSpouse(eligibleSpouse ?? null);

			const hasChild = eligibleChildren.length > 0;
			const hasSpouse = !!eligibleSpouse;

			if (hasSpouse && planOptions.includes("Employee & Spouse")) {
				options.push("Employee & Spouse");
			}

			if (hasChild && planOptions.includes("Employee & Children")) {
				options.push("Employee & Children");
			}

			if (hasChild && hasSpouse && planOptions.includes("Employee & Family")) {
				options.push("Employee & Family");
			}
		}

		setCoverageOptioin(options);

		setCoverageVolume(Plan?.coverage_volume?.options ?? []);
	}, [Plan, eligibleDependents]);

	// const getMaxBenefitAmounts = useCallback(() => {
	// 	if (!paycheck || (!Plan?.rider?.benefit_amount?.is_present && !Plan?.benefit_amount?.is_present)) return;

	// 	const calcAnnual = (): number => {
	// 		const { rate_type, pay_frequency, base_pay_rate, hourly_base_pay_rate } = paycheck;
	// 		if (rate_type === "FIXED") {
	// 			return pay_frequency === "MONTHLY" ? base_pay_rate * 12 : base_pay_rate * 52;
	// 		}
	// 		if (rate_type === "HOURLY RATE") {
	// 			return pay_frequency === "MONTHLY" ? hourly_base_pay_rate * 160 * 12 : hourly_base_pay_rate * 40 * 52;
	// 		}
	// 		return 0;
	// 	};

	// 	const annualSalary = calcAnnual();
	// 	const maxBenefitAmount = Math.floor((annualSalary * 0.6) / 52 / 50) * 50;

	// 	const rawOptions: number[] =
	// 		planname === "Short Term Disability"
	// 			? Plan?.benefit_amount?.options
	// 			: Plan?.benefit_amount?.options ?? Plan?.rider?.benefit_amount?.options;

	// 	const filtered: number[] = [];
	// 	if (rawOptions[0] > maxBenefitAmount) filtered.push(0);
	// 	rawOptions.forEach((v) => {
	// 		if (v <= maxBenefitAmount) filtered.push(v);
	// 	});

	// 	setMaxBenefitAmounts(filtered);
	// }, [paycheck, Plan, planname]);

	const getMaxBenefitAmounts = useCallback(() => {
		if (!paycheck || (!Plan?.rider?.benefit_amount?.is_present && !Plan?.benefit_amount?.is_present)) return;

		// Benefit caps are taken from the member's base pay rate for their pay period —
		// the figure is used as-is, with no annualising and no division back down.
		const calcBasePay = (): number => {
			const { rate_type, pay_frequency, base_pay_rate, hourly_base_pay_rate } = paycheck;
			if (rate_type === "FIXED") {
				return base_pay_rate;
			}
			if (rate_type === "HOURLY RATE") {
				// Hourly members have no base_pay_rate, so build the equivalent figure for
				// the same pay period (160 hrs/month, 40 hrs/week).
				return pay_frequency === "MONTHLY" ? hourly_base_pay_rate * 160 : hourly_base_pay_rate * 40;
			}
			return 0;
		};

		const benefitConfig = Plan?.benefit_amount;

		const rawOptions: number[] =
			planname === "Short Term Disability"
				? benefitConfig?.options
				: benefitConfig?.options ?? Plan?.rider?.benefit_amount?.options;

		if (!rawOptions?.length) return;

		// A plan is salary-based if it uses a flat salary basis, a yearly-salary
		// percentage (e.g. STD at 60% of annual salary), or a yearly-salary multiplier.
		const isSalaryBased =
			benefitConfig?.is_benefit_based_on_salary ||
			benefitConfig?.is_benefit_amount_based_on_yearly_salary_percentage ||
			benefitConfig?.is_benefit_amount_based_on_yearly_salary_multiplier;

		// Not salary based → show all original options
		if (!isSalaryBased) {
			setMaxBenefitAmounts(rawOptions);
			return;
		}

		const basePay = calcBasePay();
		// console.log("basePay", basePay);

		// Can't determine base pay → show all options
		if (!basePay) {
			setMaxBenefitAmounts(rawOptions);
			return;
		}

		const minBenefit = benefitConfig?.min_benefit ?? rawOptions[0];
		const maxBenefit = benefitConfig?.max_benefit ?? Infinity;

		let maxBenefitAmount: number;

		if (
			benefitConfig?.is_benefit_amount_based_on_yearly_salary_percentage &&
			benefitConfig?.salary_percentage != null
		) {
			// Percentage of base pay, e.g. salary_percentage = 60 → 60% of base pay.
			maxBenefitAmount = basePay * (benefitConfig.salary_percentage / 100);
			// console.log("maxBenefitAmount", maxBenefitAmount);
		} else if (
			benefitConfig?.is_benefit_amount_based_on_yearly_salary_multiplier &&
			benefitConfig?.yearly_salary_multiplier != null
		) {
			maxBenefitAmount = basePay * benefitConfig.yearly_salary_multiplier;
			// console.log("maxBenefitAmount", maxBenefitAmount);
		} else {
			setMaxBenefitAmounts(rawOptions);
			return;
		}

		maxBenefitAmount = Math.min(maxBenefitAmount, maxBenefit);

		// Round DOWN to the nearest selectable step. Plans that don't define an explicit
		// rounding value fall back to their benefit increment (e.g. STD steps of 50).
		const roundTo = benefitConfig?.benefit_amount_round_to_nearest ?? benefitConfig?.each_benefit_multiply_by;

		if (roundTo) {
			maxBenefitAmount = Math.floor(maxBenefitAmount / roundTo) * roundTo;
		}

		if (maxBenefitAmount < minBenefit) {
			setMaxBenefitAmounts([0]);
			return;
		}

		const filtered = rawOptions.filter((v) => v <= maxBenefitAmount);

		setMaxBenefitAmounts(filtered.length ? filtered : [0]);
	}, [paycheck, Plan, planname]);

	const spouseBenefitOptions: number[] = useMemo(() => {
		if (!Plan) return [];

		const allOptions: number[] = Plan?.benefit_amount?.spouse?.options || [];
		const canExceed = Plan?.benefit_amount?.spouse?.can_spouse_benefit_exceed_employee;

		// canExceed is true or undefined → no restriction, return all options
		if (
			canExceed === undefined ||
			canExceed === true ||
			Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually
		) {
			// console.log("spouseBenefitOptions (no cap):", allOptions);
			return allOptions;
		}

		const employeeAmount = Number(planInputs?.benefit_amount ?? 0);

		if (!employeeAmount) {
			// console.log("spouseBenefitOptions: employee amount not selected yet, returning []");
			return [];
		}

		const filtered = allOptions.filter((opt) => opt <= employeeAmount);
		// console.log("spouseBenefitOptions (capped at employee amount", employeeAmount, "):", filtered);
		return filtered;
	}, [Plan, planInputs?.benefit_amount]);
	const childBenefitOptions: number[] = useMemo(() => {
		if (!Plan) return [];

		const allOptions: number[] = Plan?.benefit_amount?.child?.options || [];
		const canExceed = Plan?.benefit_amount?.child?.can_child_benefit_exceed_employee;

		// canExceed is true or undefined → no restriction, return all options
		if (canExceed === undefined || canExceed === true) {
			// console.log("childBenefitOptions (no cap):", allOptions);
			return allOptions;
		}

		const employeeAmount = Number(planInputs?.benefit_amount ?? 0);
		const spouseAmount = Number(spousePlanInputs?.benefit_amount ?? 0);

		// Cap the child benefit by the enrolling "parent": the employee if they selected an
		// amount, otherwise fall back to the spouse (e.g. Spouse & Children with no employee).
		const capAmount = employeeAmount || spouseAmount;

		if (!capAmount) {
			// console.log("childBenefitOptions: no employee/spouse amount selected yet, returning []");
			return [];
		}

		const filtered = allOptions.filter((opt) => opt <= capAmount);
		// console.log("childBenefitOptions (capped at", capAmount, "):", filtered);
		return filtered;
	}, [Plan, planInputs?.benefit_amount, spousePlanInputs?.benefit_amount]);

	// const getExistingEnrollment = useCallback(async () => {
	// 	const planDependency = Plan?.standard_plan_dependency?.[0] || Plan?.rider_plan_dependency?.[0];
	// 	if (!planDependency) return;

	// 	const apiFn: EnrollmentApiFn | null = ENROLLMENT_API_MAP[planDependency.toLowerCase()] ?? null;

	// 	if (!apiFn) {
	// 		setHasAlreadyEnrollment(false);
	// 		return;
	// 	}

	// 	const enrollmentDocument = await trackPromise(apiFn());
	// 	const isActive =
	// 		enrollmentDocument?.enrollment_status === "ACTIVE" && enrollmentDocument?.termination_date === null;

	// 	if (!isActive) {
	// 		setHasAlreadyEnrollment(false);
	// 		return;
	// 	}

	// 	setHasAlreadyEnrollment(true);

	// 	if (Plan?.plan_name === "Critical Illness") {
	// 		setCoverageVolume(["Without Cancer"]);
	// 	} else {
	// 		setCoverageVolume(Plan?.coverage_volume?.options ?? []);
	// 	}

	// 	const content = DEPENDENCY_MESSAGE[planname.toLowerCase()] ?? "";
	// 	const actions: DialogAction[] = [];

	// 	const addCancelAction = (redirectStep?: string) => {
	// 		actions.push({
	// 			label: ENROLLMENT_DEPENDENCY_DIALOGPROP_LABEL[planname.toLowerCase()]?.cancel,
	// 			name: "cancel",
	// 			callback: () => {
	// 				setSelectedAction(false);
	// 				setEnrollmentDependencyDialogProps((prev) => ({
	// 					...prev,
	// 					openDialog: false
	// 				}));
	// 				if (redirectStep) history.push(`${location.pathname}?step=${redirectStep}&stage=0`);
	// 			}
	// 		});
	// 	};
	// 	const addWaiveAction = (redirectStep: string) => {
	// 		actions.push({
	// 			label: ENROLLMENT_DEPENDENCY_DIALOGPROP_LABEL[planname.toLowerCase()]?.waive,
	// 			name: "waive",
	// 			callback: () => {
	// 				setSelectedAction(true);
	// 				setEnrollmentDependencyDialogProps((prev) => ({
	// 					...prev,
	// 					openDialog: false
	// 				}));
	// 				history.push(`${location.pathname}?step=${redirectStep}&stage=1`);
	// 			}
	// 		});
	// 	};

	// 	if (Plan?.standard_plan_dependency?.length > 0) {
	// 		addCancelAction();
	// 		addWaiveAction(planDependency);
	// 	}
	// 	if (Plan?.rider_plan_dependency?.length > 0) {
	// 		addCancelAction(planname);
	// 		addWaiveAction("Accident");
	// 	}

	// 	setEnrollmentDependencyDialogProps({ openDialog: true, content, actions });
	// }, [Plan, planname, history, location.pathname]);
	const handleDependencyPlanChange = useCallback(
		async (
			depPlanName: string,
			depPlan: any,
			updates: Partial<{
				coverage: string;
				coverage_volume: string;
				benefit_amount: string;
				spouse_coverage: string;
				spouse_coverage_volume: string;
				spouse_benefit_amount: string;
				child_coverage: string;
				child_coverage_volume: string;
				child_benefit_amount: string;
			}>,
			planFor?: "spouse" | "child"
		) => {
			// Read from ref — always current, no stale closure
			const prevEntry = dependencyPlanInputsRef.current[depPlanName] ?? {};
			const merged: Record<string, any> = { ...prevEntry, ...updates };

			// Update the ref IMMEDIATELY before async work
			dependencyPlanInputsRef.current = {
				...dependencyPlanInputsRef.current,
				[depPlanName]: merged
			};

			setDependencyPlanInputs((prev) => ({
				...prev,
				[depPlanName]: merged
			}));

			if (!planFor && merged.coverage) {
				try {
					const premium = await dynamicPremiumCalculation(
						depPlan,
						merged.coverage,
						merged.coverage_volume,
						merged.benefit_amount,
						member,
						paycheck?.pay_frequency,
						false,
						true
					);
					// console.log(" dep premium calculated:", premium, "for", depPlanName);
					setDependencyPremiums((p) => ({ ...p, [depPlanName]: Number(premium) }));
				} catch (err) {
					// console.error(" dep premium calc failed:", err);
					setDependencyPremiums((p) => ({ ...p, [depPlanName]: 0 }));
				}
			}

			if (planFor === "spouse") {
				if (!merged.spouse_coverage) {
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_spouse`]: 0 }));
					return;
				}
				try {
					const premium = await dynamicPremiumCalculation(
						depPlan,
						merged.spouse_coverage,
						merged.spouse_coverage_volume,
						merged.spouse_benefit_amount,
						spouse,
						paycheck?.pay_frequency,
						isSpouseTobacco
					);
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_spouse`]: Number(premium) }));
				} catch {
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_spouse`]: 0 }));
				}
			}

			if (planFor === "child") {
				if (!merged.child_coverage) {
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_child`]: 0 }));
					return;
				}

				const firstChild =
					eligibleDependents.find((d) =>
						["CHILD", "STEP CHILD", "CORT-ORDER CHILD"].includes(d.relationship)
					) ?? children[0];

				if (!firstChild) {
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_child`]: 0 }));
					return;
				}

				try {
					const premium = await dynamicPremiumCalculation(
						depPlan,
						merged.child_coverage,
						merged.child_coverage_volume,
						merged.child_benefit_amount,
						firstChild,
						paycheck?.pay_frequency,
						false,
						true
					);
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_child`]: Number(premium) }));
				} catch {
					setDependencyPremiums((p) => ({ ...p, [`${depPlanName}_child`]: 0 }));
				}
			}
		},
		[member, paycheck, isSpouseTobacco, spouse, eligibleDependents, children]
	);
	const handleCoverageSelectChange = useCallback(
		async (
			updates: Partial<{
				coverage: string;
				coverage_volume: string;
				benefit_amount: string;
				rider_coverage: string;
				rider_coverage_volume: string;
				rider_benefit_amount: string;
				rider_present: boolean;
			}>
		) => {
			if (!Plan) return;

			if (updates.rider_present === false) {
				setRiderPremium(0);
				setPlanInputs((prev: any) => ({
					...prev,
					rider_present: false,
					rider_coverage: "",
					rider_coverage_volume: "",
					rider_benefit_amount: ""
				}));
				return;
			}

			const updated = { ...planInputs, ...updates };
			// Merge against the live state, not the render snapshot. Writing the whole
			// snapshot back dropped keys another effect had just set in the same
			// commit - rider_present is set from Plan.rider.is_required by its own
			// [Plan] effect, and the "Employee Only" lock effect below fires on the
			// same [Plan] change, so the snapshot write reverted the checkbox and took
			// the rider premiums out of the total with it.
			setPlanInputs((prev: any) => ({ ...prev, ...updates }));

			// Keep rider coverage in sync with base when required
			if (Plan?.rider?.is_present && (updates.coverage !== undefined || updates.coverage_volume !== undefined)) {
				if (updated.coverage !== riderCoverage[0] || updated.coverage_volume !== ridercoveragevolume[0]) {
					if (Plan?.rider?.is_rider_has_same_base_plan_coverage_for) {
						setRiderCoverage(updated.coverage ? [updated.coverage] : []);
					}
					if (Plan?.rider?.coverage_volume?.is_present) {
						setRiderCoverageVolume(updated.coverage_volume ? [updated.coverage_volume] : []);
					}
				}
			}

			// Standard premium
			if (updated.coverage) {
				try {
					const amount = await dynamicPremiumCalculation(
						Plan,
						updated.coverage,
						updated.coverage_volume,
						updated.benefit_amount,
						member,
						paycheck?.pay_frequency,
						isEmployeeTobacco,
						true
					);
					setStandardPremium(Number(amount));
				} catch {
					setStandardPremium(0);
				}
			}

			// Rider premium
			if (updated.rider_present && updated.rider_coverage) {
				try {
					const amount = await dynamicPremiumCalculation(
						Plan,
						updated.rider_coverage,
						updated.rider_coverage_volume,
						updated.rider_benefit_amount,
						member,
						paycheck?.pay_frequency,
						isEmployeeTobacco,
						false
					);
					setRiderPremium(Number(amount));
				} catch {
					setRiderPremium(0);
				}
			} else if (!updated.rider_present) {
				setRiderPremium(0);
			}
			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > GI_LIMITS.EMPLOYEE && hasEmployeeSIQuestions) {
					// ── Build full queue starting from EMPLOYEE ──
					const queue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = ["EMPLOYEE"];
					if (spouseNeedsSI && !siSubmittedStatus.SPOUSE) queue.push("SPOUSE");
					if (childNeedsSI && !siSubmittedStatus.CHILD) queue.push("CHILD");
					setSiQueue(queue);
					setCurrentRelation("EMPLOYEE");
					setSiModalOpen(true);
				} else if (selected <= GI_LIMITS.EMPLOYEE) {
					setSiSubmittedStatus((prev) => ({ ...prev, EMPLOYEE: false }));
					setSiDataStore((prev) => prev.filter((s) => s.role !== "employee"));
				}
			}
		},
		[
			Plan,
			planInputs,
			member,
			paycheck,
			riderCoverage,
			ridercoveragevolume,
			docAndRx,
			isEmployeeTobacco,
			GI_LIMITS,
			hasEmployeeSIQuestions
		]
	);

	const handleChildCoverageChange = useCallback(
		async (updates) => {
			if (!Plan) return;

			const updated = { ...childPlanInputs, ...updates };
			setChildPlanInputs(updated);

			if (!updated.coverage) {
				setChildPremium(0);
				return;
			}

			// Use eligibleDependents directly, with a fallback to raw children array
			const firstChild =
				eligibleDependents.find(
					(d) =>
						d.relationship === "CHILD" ||
						d.relationship === "STEP CHILD" ||
						d.relationship === "CORT-ORDER CHILD"
				) ?? children[0];
			if (!firstChild) {
				setChildPremium(0);
				return;
			}

			try {
				const premium = await dynamicPremiumCalculation(
					Plan,
					updated.coverage,
					// Plan?.coverage_volume_same_as_employee ? planInputs.coverage_volume : updated.coverage_volume,
					updated.coverage_volume,
					updated.benefit_amount,
					children[0],
					paycheck?.pay_frequency,
					false,
					true
				);
				setChildPremium(Number(premium));
			} catch {
				setChildPremium(0);
			}
			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > GI_LIMITS.CHILD && hasChildSIQuestions) {
					const queue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
					if (employeeNeedsSI && !siSubmittedStatusRef.current.EMPLOYEE) queue.push("EMPLOYEE");
					if (spouseNeedsSI && !siSubmittedStatusRef.current.SPOUSE) queue.push("SPOUSE");
					queue.push("CHILD");
					setSiQueue(queue);
					setCurrentRelation(queue[0]);
					setSiModalOpen(true); // ← standard modal, not rider
				} else if (selected <= GI_LIMITS.CHILD) {
					setSiSubmittedStatus((prev) => ({ ...prev, CHILD: false }));
					setSiDataStore((prev) => prev.filter((s) => s.role !== "child"));
				}
			}
		},
		[Plan, children, childPlanInputs, eligibleDependents, paycheck]
	);
	const handleSpouseCoverageChange = useCallback(
		async (updates: Partial<{ coverage: string; coverage_volume: string; benefit_amount: string }>) => {
			if (!Plan || !spouse) return;
			const updated = { ...spousePlanInputs, ...updates };
			setSpousePlanInputs(updated);

			if (!updated.coverage) {
				setSpousePremium(0);
				return;
			}

			try {
				const premium = await dynamicPremiumCalculation(
					Plan,
					updated.coverage,
					// Plan?.coverage_volume_same_as_employee ? planInputs.coverage_volume : updated.coverage_volume,
					updated.coverage_volume,
					updated.benefit_amount,
					spouse,
					paycheck?.pay_frequency,
					isSpouseTobacco,
					true
				);
				setSpousePremium(Number(premium));
			} catch {
				setSpousePremium(0);
			}
			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > GI_LIMITS.SPOUSE && hasSpouseSIQuestions) {
					// ── Build full queue starting from SPOUSE ──
					const queue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
					if (employeeNeedsSI && !siSubmittedStatus.EMPLOYEE) queue.push("EMPLOYEE");
					queue.push("SPOUSE");
					if (childNeedsSI && !siSubmittedStatus.CHILD) queue.push("CHILD");
					setSiQueue(queue);
					setCurrentRelation(queue[0]); // start from first pending
					setSiModalOpen(true);
				} else if (selected <= GI_LIMITS.SPOUSE) {
					setSiSubmittedStatus((prev) => ({ ...prev, SPOUSE: false }));
					setSiDataStore((prev) => prev.filter((s) => s.role !== "spouse"));
				}
			}
		},
		[Plan, spouse, spousePlanInputs, paycheck, isSpouseTobacco]
	);

	const handleRiderCoverageChange = useCallback(
		async (updates: Partial<{ coverage: string; coverage_volume: string; benefit_amount: string }>) => {
			if (!Plan) return;
			const updated = { ...riderPlanInputs, ...updates };
			setRiderPlanInputs(updated);

			// The spouse and child sections own their own coverage, exactly as they do
			// on the standard plan, where handleCoverageSelectChange never touches
			// spousePlanInputs / childPlanInputs. Clearing them from here emptied
			// riderSpousePlanInputs.coverage / riderChildPlanInputs.coverage, and both
			// dependent handlers bail out early on a missing coverage - so every
			// spouse and child benefit picked afterwards priced at 0, with nothing to
			// re-seed the coverage.

			if (!updated.coverage) {
				setRiderEmployeePremium(0);
				return;
			}

			try {
				const amount = await dynamicPremiumCalculation(
					Plan,
					updated.coverage,
					updated.coverage_volume,
					updated.benefit_amount,
					member,
					paycheck?.pay_frequency,
					isEmployeeTobacco,
					false
				);

				setRiderEmployeePremium(Number(amount));
			} catch {
				setRiderEmployeePremium(0);
			}

			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > riderGI_LIMITS.EMPLOYEE && hasRiderEmployeeSIQuestions) {
					setRiderCurrentRelation("EMPLOYEE");
					setRiderSiModalOpen(true);
				} else if (selected <= riderGI_LIMITS.EMPLOYEE) {
					setRiderSiSubmittedStatus((prev) => ({ ...prev, EMPLOYEE: false }));
					setRiderSiDataStore((prev) => prev.filter((s) => s.role !== "employee"));
				}
			}
		},
		[Plan, riderPlanInputs, member, paycheck, isEmployeeTobacco, riderGI_LIMITS, hasRiderEmployeeSIQuestions]
	);

	const handleRiderSpouseCoverageChange = useCallback(
		async (updates: Partial<{ coverage: string; coverage_volume: string; benefit_amount: string }>) => {
			if (!Plan) return;

			const updated = { ...riderSpousePlanInputs, ...updates };
			setRiderSpousePlanInputs(updated);

			if (!updated.coverage) {
				setRiderSpousePremium(0);
				return;
			}

			if (!spouse) {
				setRiderSpousePremium(0);
				return;
			}

			try {
				const premium = await dynamicPremiumCalculation(
					Plan,
					updated.coverage,
					updated.coverage_volume,
					updated.benefit_amount,
					spouse,
					paycheck?.pay_frequency,
					isSpouseTobacco,
					false
				);

				setRiderSpousePremium(Number(premium));
			} catch {
				setRiderSpousePremium(0);
			}

			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > riderGI_LIMITS.SPOUSE && hasRiderSpouseSIQuestions) {
					setRiderCurrentRelation("SPOUSE");
					setRiderSiModalOpen(true);
				} else if (selected <= riderGI_LIMITS.SPOUSE) {
					setRiderSiSubmittedStatus((prev) => ({ ...prev, SPOUSE: false }));
					setRiderSiDataStore((prev) => prev.filter((s) => s.role !== "spouse"));
				}
			}
		},
		[Plan, spouse, riderSpousePlanInputs, paycheck, isSpouseTobacco, riderGI_LIMITS, hasRiderSpouseSIQuestions]
	);

	const handleRiderChildCoverageChange = useCallback(
		async (updates: Partial<{ coverage: string; coverage_volume: string; benefit_amount: string }>) => {
			if (!Plan) return;

			const updated = { ...riderChildPlanInputs, ...updates };
			setRiderChildPlanInputs(updated);

			if (!updated.coverage) {
				setRiderChildPremium(0);
				return;
			}

			const firstChild =
				eligibleDependents.find(
					(d) =>
						d.relationship === "CHILD" ||
						d.relationship === "STEP CHILD" ||
						d.relationship === "CORT-ORDER CHILD"
				) ?? children[0];

			if (!firstChild) {
				setRiderChildPremium(0);
				return;
			}

			try {
				const premium = await dynamicPremiumCalculation(
					Plan,
					updated.coverage,
					updated.coverage_volume,
					updated.benefit_amount,
					firstChild,
					paycheck?.pay_frequency,
					false,
					false
				);
				setRiderChildPremium(Number(premium));
			} catch {
				setRiderChildPremium(0);
			}

			if (updates.benefit_amount !== undefined) {
				const selected = Number(updates.benefit_amount ?? 0);
				if (selected > riderGI_LIMITS.CHILD && hasRiderChildSIQuestions) {
					setRiderCurrentRelation("CHILD");
					setRiderSiModalOpen(true);
				} else if (selected <= riderGI_LIMITS.CHILD) {
					setRiderSiSubmittedStatus((prev) => ({ ...prev, CHILD: false }));
					setRiderSiDataStore((prev) => prev.filter((s) => s.role !== "child"));
				}
			}
		},
		[Plan, riderChildPlanInputs, eligibleDependents, children, paycheck, riderGI_LIMITS, hasRiderChildSIQuestions]
	);

	const submitRiderSIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			// console.log("submitRiderSIUnderwriting called, store:", store);
			if (store.length === 0) {
				// console.log("rider store is empty, skipping API call");
				return;
			}

			const planOE = VEBOpenEnrollment?.find(
				(oe) =>
					oe.open_enrollment.veb_plan_name === planname &&
					oe.open_enrollment.veb_plan_code === Plan?.plan_code
			);

			// The server derives si_required, requires_full_underwriting and every
			// status from the answers — we only report what was asked and answered.
			const siPayload: any = {
				section: "RIDER_SI",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE?.VEB_open_enrollment_id ? String(planOE.VEB_open_enrollment_id) : "",
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,
				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},
				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},
				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),
				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[
			riderSiDataStore,
			riderPlanInputs,
			riderSpousePlanInputs,
			riderChildPlanInputs,
			riderGI_LIMITS,
			VEBOpenEnrollment,
			planname,
			Plan,
			member,
			groupOwner,
			isActivelyWorking,
			combinedCoverageCode
		]
	);
	const submitSIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			// console.log("submitSIUnderwriting called, store:", store);
			if (store.length === 0) {
				// console.log("store is empty, skipping API call");
				return;
			}

			const planOE = VEBOpenEnrollment?.find(
				(oe) =>
					oe.open_enrollment.veb_plan_name === planname &&
					oe.open_enrollment.veb_plan_code === Plan?.plan_code
			);

			// The server derives si_required, requires_full_underwriting and every
			// status from the answers — we only report what was asked and answered.
			const siPayload: any = {
				section: "PLAN_SI",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE?.VEB_open_enrollment_id ? String(planOE.VEB_open_enrollment_id) : "",
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,

				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},

				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},

				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),

				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[
			siDataStore,
			planInputs,
			spousePlanInputs,
			childPlanInputs,
			GI_LIMITS,
			VEBOpenEnrollment,
			planname,
			Plan,
			member,
			groupOwner,
			isActivelyWorking,
			combinedCoverageCode
		]
	);

	const validateBeneficiary = useCallback(
		(list: BV2Beneficiery[]): number => list.reduce((sum, b) => sum + b.percentage, 0),
		[]
	);

	const handleBeneficiaryValidate = useCallback(() => {
		let isValid = true;
		const cov = effectiveCoverage;
		// console.log("effectiveCoverage", effectiveCoverage);

		const { employeePrimary, employeeContingent, spousePrimary, spouseContingent, childPrimary, childContingent } =
			beneficiaries;

		if (
			(cov === "Employee Only" ||
				cov === "Employee & Spouse" ||
				cov === "Employee & Children" ||
				cov === "Employee & Family") &&
			Plan?.beneficiaries_required
		) {
			if (employeePrimary.length === 0) {
				alert("Employee must have at least One Primary Beneficiary!");
				return false;
			}
			if (employeePrimary.length > 4) {
				alert("Employee can have at most Four Primary Beneficiaries!");
				return false;
			}
			const employeePrimaryPercentageSum = validateBeneficiary(employeePrimary);
			if (employeePrimaryPercentageSum !== 100 && employeePrimaryPercentageSum !== 0) {
				alert("Employee Primary Beneficiary Percentage must total 100%!");
				return false;
			}
			if (employeeContingent.length !== 0) {
				if (employeeContingent.length !== 1) {
					alert("Employee can have only One Contingent Beneficiary!");
					return false;
				}
				const employeeContingentPercentageSum = validateBeneficiary(employeeContingent);
				if (employeeContingentPercentageSum !== 100 && employeeContingentPercentageSum !== 0) {
					alert("Employee Contingent Beneficiary Percentage must total 100%!");
					return false;
				}
			}
		}

		if (
			cov === "Spouse Only" ||
			cov === "Employee & Spouse" ||
			cov === "Spouse & Children" ||
			cov === "Employee & Family"
		) {
			// console.log("this is the coverage", cov);
			if (spousePrimary.length === 0) {
				alert("Spouse must have at least one Primary Beneficiary!");
				return false;
			}
			if (spousePrimary.length !== 1) {
				alert("Spouse can have only One Primary Beneficiary!");
				return false;
			}
			const spousePrimaryPercentageSum = validateBeneficiary(spousePrimary);
			if (spousePrimaryPercentageSum !== 100 && spousePrimaryPercentageSum !== 0) {
				alert("Spouse Primary Beneficiary Percentage must total 100%!");
				return false;
			}
			if (spouseContingent.length !== 0) {
				if (spouseContingent.length !== 1) {
					alert("Spouse can have only One Contingent Beneficiary!");
					return false;
				}
				const spouseContingentPercentageSum = validateBeneficiary(spouseContingent);
				if (spouseContingentPercentageSum !== 100 && spouseContingentPercentageSum !== 0) {
					alert("Spouse Contingent Beneficiary Percentage must total 100%!");
					return false;
				}
			}
		}

		if (
			cov === "Employee & Children" ||
			cov === "Spouse & Children" ||
			cov === "Children Only" ||
			cov === "Employee & Family"
		) {
			if (childPrimary.length === 0) {
				alert("Child must have at least One Primary Beneficiary!");
				return false;
			}
			if (childPrimary.length !== 1) {
				alert("Child can have only One Primary Beneficiary!");
				return false;
			}
			const childPrimaryPercentageSum = validateBeneficiary(childPrimary);
			if (childPrimaryPercentageSum !== 100 && childPrimaryPercentageSum !== 0) {
				alert("Child Primary Beneficiary Percentage must total 100%!");
				return false;
			}
			if (childContingent.length !== 0) {
				if (childContingent.length !== 1) {
					alert("Child can have only One Contingent Beneficiary!");
					return false;
				}
				const childContingentPercentageSum = validateBeneficiary(childContingent);
				if (childContingentPercentageSum !== 100 && childContingentPercentageSum !== 0) {
					alert("Child Contingent Beneficiary Percentage must total 100%!");
					return false;
				}
			}
		}

		return isValid;
	}, [beneficiaries, effectiveCoverage, validateBeneficiary]);
	const submitGIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			if (store.length === 0) return;

			const planOE = VEBOpenEnrollment?.find(
				(oe) =>
					oe.open_enrollment.veb_plan_name === planname &&
					oe.open_enrollment.veb_plan_code === Plan?.plan_code
			);

			// The server derives eligibility and status from the answers — general
			// questions carry no face amount, so there is no GI comparison here.
			const siPayload: any = {
				section: "GENERAL_QUESTIONS",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE?.VEB_open_enrollment_id ? String(planOE.VEB_open_enrollment_id) : "",
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,
				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},
				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},
				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),
				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[VEBOpenEnrollment, planname, Plan, member, groupOwner, isActivelyWorking, combinedCoverageCode]
	);

	const submitCoreSIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			// console.log("submitSIUnderwriting called, store:", store);
			if (store.length === 0) {
				// console.log("store is empty, skipping API call");
				return;
			}

			const planOE = openEnrollment ? openEnrollment : null;
			if (!planOE) {
				return;
			}

			// The server derives si_required, requires_full_underwriting and every
			// status from the answers — we only report what was asked and answered.
			const siPayload: any = {
				section: "PLAN_SI",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE._id,
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,

				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},

				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},

				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),

				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[
			siDataStore,
			planInputs,
			spousePlanInputs,
			childPlanInputs,
			GI_LIMITS,
			VEBOpenEnrollment,
			planname,
			Plan,
			member,
			groupOwner,
			isActivelyWorking,
			combinedCoverageCode
		]
	);

	const submitCoreGIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			if (store.length === 0) return;
			// console.log("CoreOpenEnrollment--", VEBOpenEnrollment);

			const planOE = openEnrollment ? openEnrollment : null;
			if (!planOE) {
				return;
			}

			// The server derives eligibility and status from the answers — general
			// questions carry no face amount, so there is no GI comparison here.
			const siPayload: any = {
				section: "GENERAL_QUESTIONS",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE._id,
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,
				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},
				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},
				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),
				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[VEBOpenEnrollment, planname, Plan, member, groupOwner, isActivelyWorking, combinedCoverageCode]
	);

	const submitCoreRiderSIUnderwriting = useCallback(
		async (storeOverride: ApplicantStore[]) => {
			const store = storeOverride;
			// console.log("submitRiderSIUnderwriting called, store:", store);
			if (store.length === 0) {
				// console.log("rider store is empty, skipping API call");
				return;
			}

			const planOE = openEnrollment ? openEnrollment : null;
			if (!planOE) {
				return;
			}

			// The server derives si_required, requires_full_underwriting and every
			// status from the answers — we only report what was asked and answered.
			const siPayload: any = {
				section: "RIDER_SI",
				member_object_id: member?._id,
				member_SSN: member?.SSN,
				open_enrollment_id: planOE._id,
				plan_object_id: Plan?._id,
				plan_code: Plan?.plan_code,
				base_plan_name: Plan?.plan_name,
				coverage_code: combinedCoverageCode,
				plan_year: new Date().getFullYear(),
				group_number: member?.group_number,
				agent_id: groupOwner?._id,
				active_at_work: {
					employee_active_at_work: isActivelyWorking,
					spouse_active_at_work: null,
					spouse_able_to_work_full_time: null
				},
				policy_declarations: {
					authorize_reduced_benefit: true,
					authorize_premium_adjustment: true,
					has_existing_life_insurance: false,
					will_replace_existing_coverage: false
				},
				applicant_answers: store
					.filter((applicant) => ["employee", "spouse", "child"].includes(applicant.role?.toLowerCase()))
					.map((applicant) => ({
						applicant_role: applicant.role.toLowerCase() as "employee" | "spouse" | "child",
						member_object_id: applicant.member_object_id,
						member_SSN: applicant.member_SSN,
						child_name: applicant.child_name ?? null,
						face_amount: applicant.face_amount,
						gi_limit: applicant.gi_limit,
						exceeds_gi: applicant.exceeds_gi,
						eligible: applicant.eligible,
						reduced_to_gi: applicant.reducedToGI,
						answers: applicant.answers.map((a) => ({
							question_id: a.question_id,
							question_text: a.question_text,
							answer: a.answer.toLowerCase(),
							eligible_answer: a.eligible_answer ? a.eligible_answer.toLowerCase() : null,
							parent_question_id: a.parent_question_id ?? null
						}))
					})),
				submitted_at: new Date()
			};

			await trackPromise(api.enrollment.saveSIUnderwriting(siPayload));
		},
		[
			riderSiDataStore,
			riderPlanInputs,
			riderSpousePlanInputs,
			riderChildPlanInputs,
			riderGI_LIMITS,
			VEBOpenEnrollment,
			planname,
			Plan,
			member,
			groupOwner,
			isActivelyWorking,
			combinedCoverageCode
		]
	);

	const handleValidation = useCallback((): boolean => {
		if (!Plan) {
			alert("Plan data is not available.");
			return false;
		}

		const canEnrollIndependently = Plan?.can_each_relationship_enroll_indipendently_in_this_plan;

		const spouseCanEnrollAlone = Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;

		const childCanEnrollAlone = Plan?.benefit_amount?.child?.child_can_enroll_individually;

		const employeeRequired = Plan?.employee_required;

		const coverageIncludesEmployee =
			effectiveCoverage === "Employee Only" ||
			effectiveCoverage === "Employee & Spouse" ||
			effectiveCoverage === "Employee & Children" ||
			effectiveCoverage === "Employee & Family";

		const coverageIncludesSpouse =
			effectiveCoverage === "Employee & Spouse" ||
			effectiveCoverage === "Employee & Family" ||
			effectiveCoverage === "Spouse Only" ||
			effectiveCoverage === "Spouse & Children";

		const coverageIncludesChildren =
			effectiveCoverage === "Employee & Children" ||
			effectiveCoverage === "Employee & Family" ||
			effectiveCoverage === "Children Only" ||
			effectiveCoverage === "Spouse & Children";

		if (coverageIncludesEmployee) {
			if (!planInputs?.coverage) {
				alert("Please select employee coverage.");
				return false;
			}

			if (Plan?.coverage_volume?.is_present && !planInputs?.coverage_volume) {
				alert("Please select employee coverage volume.");
				return false;
			}

			if (Plan?.benefit_amount?.is_present && !Number(planInputs?.benefit_amount)) {
				alert("Please select employee benefit amount.");
				return false;
			}
		}

		// ── Spouse validation (runs whether or not the employee is required) ──
		if (coverageIncludesSpouse && canEnrollIndependently) {
			// If the spouse cannot enroll on their own, the employee must be part of the coverage
			// (unless the employee has already entered their own coverage inputs).
			if (
				!spouseCanEnrollAlone &&
				!coverageIncludesEmployee &&
				!(planInputs?.benefit_amount || planInputs?.coverage_volume)
			) {
				alert("Employee coverage is required before adding spouse coverage.");
				return false;
			}

			// if (Plan?.coverage_volume?.is_present && spousePlanInputs?.coverage_volume) {
			// 	alert("Please select spouse coverage volume.");
			// 	return false;
			// }

			// if (Plan?.benefit_amount?.spouse?.options?.length > 0 && !Number(spousePlanInputs?.benefit_amount)) {
			// 	alert("Please select spouse benefit amount.");
			// 	return false;
			// }

			// A spouse benefit that was touched but left at 0 (with no coverage volume) is invalid.
			if (
				spousePlanInputs?.benefit_amount &&
				!(Number(spousePlanInputs?.benefit_amount) > 0) &&
				!spousePlanInputs?.coverage_volume
			) {
				alert("Please select spouse enrollment benefit.");
				return false;
			}
		}

		// ── Child validation (runs whether or not the employee is required) ──
		if (coverageIncludesChildren && canEnrollIndependently) {
			// If the child cannot enroll on their own, the employee (or an independently-enrolling
			// spouse) must be part of the coverage.
			if (
				!childCanEnrollAlone &&
				!coverageIncludesEmployee &&
				!(planInputs?.benefit_amount || planInputs?.coverage_volume) &&
				!(spouseCanEnrollAlone && (spousePlanInputs?.benefit_amount || spousePlanInputs?.coverage_volume))
			) {
				alert("Employee coverage is required before adding child coverage.");
				return false;
			}

			if (Plan?.coverage_volume?.is_present && !childPlanInputs?.coverage_volume) {
				alert("Please select child coverage volume.");
				return false;
			}

			if (Plan?.benefit_amount?.child?.options?.length > 0 && !Number(childPlanInputs?.benefit_amount)) {
				alert("Please select child benefit amount.");
				return false;
			}
		}

		const liveStatus = siSubmittedStatusRef.current;
		const liveRiderStatus = riderSiSubmittedStatusRef.current;

		if (coverageIncludesEmployee && employeeNeedsSI && !liveStatus.EMPLOYEE) {
			alert("Please complete the underwriting questions for yourself before proceeding.");
			setCurrentRelation("EMPLOYEE");
			setSiModalOpen(true);
			return false;
		}

		if (coverageIncludesSpouse && spouseNeedsSI && !liveStatus.SPOUSE) {
			alert("Please complete the underwriting questions for your spouse before proceeding.");
			setCurrentRelation("SPOUSE");
			setSiModalOpen(true);
			return false;
		}

		if (coverageIncludesChildren && childNeedsSI && !liveStatus.CHILD) {
			alert("Please complete the underwriting questions for your child before proceeding.");
			setCurrentRelation("CHILD");
			setSiModalOpen(true);
			return false;
		}

		if (planInputs?.rider_present) {
			const riderIncludesEmployee =
				effectiveRiderCoverage === "Employee Only" ||
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family";

			const riderIncludesSpouse =
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Spouse Only" ||
				effectiveRiderCoverage === "Spouse & Children";

			const riderIncludesChildren =
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Children Only" ||
				effectiveRiderCoverage === "Spouse & Children";

			if (riderIncludesEmployee && riderEmployeeNeedsSI && !liveRiderStatus.EMPLOYEE) {
				alert("Please complete the rider underwriting questions for yourself before proceeding.");
				setRiderCurrentRelation("EMPLOYEE");
				setRiderSiModalOpen(true);
				return false;
			}

			if (riderIncludesSpouse && riderSpouseNeedsSI && !liveRiderStatus.SPOUSE) {
				alert("Please complete the rider underwriting questions for your spouse before proceeding.");
				setRiderCurrentRelation("SPOUSE");
				setRiderSiModalOpen(true);
				return false;
			}

			if (riderIncludesChildren && riderChildNeedsSI && !liveRiderStatus.CHILD) {
				alert("Please complete the rider underwriting questions for your child before proceeding.");
				setRiderCurrentRelation("CHILD");
				setRiderSiModalOpen(true);
				return false;
			}
		}

		if (!isActivelyWorking) {
			alert("You must be actively working at least 20 hours per week to be eligible for enrollment.");
			return false;
		}
		// ── GI Questions gate ──
		if (Plan?.general_questions?.length > 0) {
			if (!giSubmittedStatusRef.current) {
				alert("Please complete the eligibility questions before proceeding.");
				// setGiModalOpen(true);
				return false;
			}
			const giApplicant = giDataStoreRef.current.find((s) => s.role === "employee");
			if (giApplicant && !giApplicant.eligible) {
				alert("You are not eligible to enroll in this plan based on your answers.");
				return false;
			}
		}

		if (!hasReadTC) {
			alert("Please read and accept the disclaimer before proceeding.");
			return false;
		}

		return true;
	}, [
		Plan,
		planInputs,
		spousePlanInputs,
		childPlanInputs,
		riderPlanInputs,
		riderSpousePlanInputs,
		riderChildPlanInputs,
		effectiveCoverage,
		effectiveRiderCoverage,
		employeeNeedsSI,
		spouseNeedsSI,
		childNeedsSI,
		riderEmployeeNeedsSI,
		riderSpouseNeedsSI,
		riderChildNeedsSI,
		isActivelyWorking,
		hasReadTC,
		showSpouseSection
	]);
	const waitForModalToClose = () =>
		new Promise<void>((resolve) => {
			const check = () => {
				if (!isDependentExistsModelOpenRef.current) resolve();
				else setTimeout(check, 500);
			};
			check();
		});

	const handleEmployeeTobaccoToggle = useCallback(
		async (e: React.ChangeEvent<HTMLInputElement>) => {
			const checked = e.target.checked;
			setIsEmployeeTobacco(checked);

			try {
				if (!planInputs?.coverage) {
					setStandardPremium(0);
					return;
				}

				const amount = await dynamicPremiumCalculation(
					Plan,
					planInputs.coverage,
					planInputs.coverage_volume,
					planInputs.benefit_amount,
					member,
					paycheck?.pay_frequency,
					checked,
					true
				);
				setStandardPremium(Number(amount) || 0);
			} catch (error) {
				// console.error("Employee tobacco toggle error:", error);
				setIsEmployeeTobacco(!checked);
				setStandardPremium(0);
			}
		},
		[member, Plan, planInputs, paycheck]
	);
	const handleSpouseTobaccoToggle = useCallback(
		async (e: React.ChangeEvent<HTMLInputElement>) => {
			const checked = e.target.checked;
			setIsSpouseTobacco(checked);

			try {
				if (!spouse) return;

				const currentCoverage = spousePlanInputs?.coverage || planInputs?.coverage;
				if (!currentCoverage) {
					setSpousePremium(0);
					return;
				}

				const premium = await dynamicPremiumCalculation(
					Plan,
					currentCoverage,
					spousePlanInputs?.coverage_volume || planInputs?.coverage_volume,
					spousePlanInputs?.benefit_amount,
					{ ...spouse, is_tobacco: checked },
					paycheck?.pay_frequency,
					checked,
					true
				);

				setSpousePremium(Number(premium) || 0);
			} catch (error) {
				// console.error("Spouse tobacco toggle error:", error);
				setIsSpouseTobacco(!checked);
				setSpousePremium(0);
			}
		},
		[Plan, spousePlanInputs, planInputs, spouse, paycheck]
		// removed: eligibleDependents, setDependents, dependents — no longer needed here
	);

	const generatePayload = useCallback(
		(
			VEBEnrollments: VEBWholeLifeEnrollments[],
			VEBOpenEnrollment: VEBOpenEnrollment[],
			paycheck: Paycheck,
			isRider: boolean,
			overridePlanName?: string,
			overridePlanCode?: string | null,
			riderPlanName?: String | null
		): VEBEnrollmentPayload => {
			const targetPlanName = overridePlanName ?? planname;
			const targetPlanCode = overridePlanCode;
			// console.log("riderPlanName", riderPlanName);
			const planOpenEnrollment = VEBOpenEnrollment.find(
				(oe) =>
					oe.open_enrollment.veb_plan_name === targetPlanName &&
					oe.open_enrollment.veb_plan_code === targetPlanCode
			);
			const openid = planOpenEnrollment?.VEB_open_enrollment_id
				? String(planOpenEnrollment.VEB_open_enrollment_id)
				: "";

			const payload: VEBEnrollmentPayload = {
				isRider,
				standard_details: [],
				common_details: {
					agent_id: groupOwner?._id as unknown as string,
					location_number: 0,
					location_name: "",
					group_number: 0,
					group_name: "",
					plan_object_id: "",
					plan_code: "",
					plan_name: "",
					base_plan_name: "",
					sub_plan: null,
					insured_object_id: "",
					insured_SSN: "",
					enrollment_status: null,
					unenrolled_reason: null,
					waive_reason: null,
					termination_reason: null,
					writing_number: 0,
					enrollment_date: null,
					effective_date: null,
					termination_date: null,
					open_enrollment_id: null,
					total_premium: 0,
					enrollment_paycheck_id: undefined
				}
			};

			for (const enrollment of VEBEnrollments) {
				const {
					plan,
					premiumAmount,
					VEB_primary_beneficiary,
					VEB_contingent_beneficiary,
					totalPremium,
					coverageCode,
					benefitAmount,
					planName,
					subPlan,
					planFor
				} = enrollment;

				if (!planFor?.SSN) continue;

				const resolvedPlanName = isRider ? targetPlanName : planName;

				const resolvedBasePlanName = isRider
					? planName // rider name → "Child Term Life Insurance"
					: targetPlanName; // same as plan name for standard

				const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
					generateWholeLifeActivateVEBEnrollmentPayload(
						plan,
						groupOwner,
						member,
						planFor,
						benefitAmount,
						coverageCode,
						premiumAmount,
						resolvedBasePlanName,
						totalPremium,
						resolvedPlanName,
						subPlan,
						openid,
						paycheck,
						VEB_primary_beneficiary,
						VEB_contingent_beneficiary,
						writingNumber
					);
				// console.log("VEBEnrollmentCommonDetails", VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails);

				// ── common_details is now correct directly from the function ──
				// No need to override anymore
				payload.common_details = VEBEnrollmentCommonDetails;
				payload.standard_details.push(VEBEnrollmentStandardDetails);
			}

			return payload;
		},
		[groupOwner, member, planname, writingNumber, planCode]
	);
	const getMinContributionByPayFrequency = (
		contributions?: { pay_frequency: string; min_limit: number }[],
		payFrequency?: string
	): number => {
		if (!contributions || !Array.isArray(contributions) || !payFrequency) return 0;

		const match = contributions.find((c) => c.pay_frequency.toUpperCase() === payFrequency.toUpperCase());

		return match?.min_limit ?? 0;
	};

	const handleActivateButtonClick = useCallback(async () => {
		try {
			if (!member || !paycheck || !VEBOpenEnrollment) return;

			const liveSubmittedStatus = siSubmittedStatusRef.current;
			const liveRiderSubmittedStatus = riderSiSubmittedStatusRef.current;
			const liveSiStore = siDataStoreRef.current;
			const liveRiderSiStore = riderSiDataStoreRef.current;
			const liveGiStore = giDataStoreRef.current;

			// console.log("SI Store:", JSON.stringify(liveSiStore));
			// console.log("Rider SI Store:", JSON.stringify(liveRiderSiStore));
			// console.log("GI Store:", JSON.stringify(liveGiStore));

			// ── Step 1: Check standard SI queue ──
			const standardQueue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
			if (employeeNeedsSI && !liveSubmittedStatus.EMPLOYEE) standardQueue.push("EMPLOYEE");
			if (spouseNeedsSI && !liveSubmittedStatus.SPOUSE) standardQueue.push("SPOUSE");
			if (childNeedsSI && !liveSubmittedStatus.CHILD) standardQueue.push("CHILD");

			if (standardQueue.length > 0) {
				setSiQueue(standardQueue);
				setCurrentRelation(standardQueue[0]);
				setSiModalOpen(true);
				return;
			}

			// ── Step 2: Check rider SI queue ──
			if (planInputs?.rider_present) {
				const riderQueue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
				if (riderEmployeeNeedsSI && !liveRiderSubmittedStatus.EMPLOYEE) riderQueue.push("EMPLOYEE");
				if (riderSpouseNeedsSI && !liveRiderSubmittedStatus.SPOUSE) riderQueue.push("SPOUSE");
				if (riderChildNeedsSI && !liveRiderSubmittedStatus.CHILD) riderQueue.push("CHILD");

				if (riderQueue.length > 0) {
					setRiderSiQueue(riderQueue);
					setRiderCurrentRelation(riderQueue[0]);
					setRiderSiModalOpen(true);
					return;
				}
			}

			if (!handleValidation()) return;
			if (!handleBeneficiaryValidate()) return;

			if (liveGiStore.length > 0) {
				try {
					// console.log("Submitting GI store:", liveGiStore);
					await submitGIUnderwriting(liveGiStore);
				} catch (err) {
					// console.error("Failed to save GI underwriting", err);
					alert("Failed to submit eligibility answers. Please try again.");
					return;
				}
			}

			if (liveSiStore.length > 0) {
				try {
					await submitSIUnderwriting(liveSiStore);
				} catch (err) {
					// console.error("Failed to save SI underwriting", err);
					alert("Failed to submit underwriting answers. Please try again.");
					return;
				}
			}

			// ── Step 6: Submit rider SI underwriting ──
			if (liveRiderSiStore.length > 0) {
				try {
					await submitRiderSIUnderwriting(liveRiderSiStore);
				} catch (err) {
					console.error("Failed to save Rider SI underwriting", err);
					alert("Failed to submit rider underwriting answers. Please try again.");
					return;
				}
			}

			// ── Submit SI underwriting using live ref values only ──
			// if (liveSiStore.length > 0) {
			// 	try {
			// 		await submitSIUnderwriting(liveSiStore);
			// 	} catch (err) {
			// 		console.error("Failed to save SI underwriting", err);
			// 		alert("Failed to submit underwriting answers. Please try again.");
			// 		return;
			// 	}
			// }

			// if (liveRiderSiStore.length > 0) {
			// 	try {
			// 		await submitRiderSIUnderwriting(liveRiderSiStore);
			// 	} catch (err) {
			// 		console.error("Failed to save Rider SI underwriting", err);
			// 		alert("Failed to submit rider underwriting answers. Please try again.");
			// 		return;
			// 	}
			// }

			// console.log("effectiveCoverage123456=====================>>>", effectiveCoverage);

			const spouseEnrollingIndividually =
				Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually && !!spousePlanInputs?.benefit_amount;

			const childEnrollingIndividually =
				Plan?.benefit_amount?.child?.child_can_enroll_individually && !!childPlanInputs?.benefit_amount;

			const finalCoverageForCode = (() => {
				if (!Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
					return effectiveCoverage;
				}

				const hasEmployee = !!planInputs?.coverage;
				const hasSpouse =
					spouseEnrollingIndividually ||
					!!spousePlanInputs?.coverage_volume ||
					!!spousePlanInputs?.benefit_amount;
				const hasChild =
					childEnrollingIndividually ||
					!!childPlanInputs?.coverage_volume ||
					!!childPlanInputs?.benefit_amount;

				if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
				if (hasEmployee && hasSpouse) return "Employee & Spouse";
				if (hasEmployee && hasChild) return "Employee & Children";
				if (hasEmployee) return "Employee Only";
				if (hasSpouse && hasChild) return "Spouse & Children";
				if (hasSpouse) return "Spouse Only";
				if (hasChild) return "Children Only";

				return effectiveCoverage;
			})();

			// When a plan allows independent enrollment and the employee is NOT required,
			// spouse/child can enroll on their own. In that case we still treat the group as an
			// employee-inclusive coverage (Spouse Only -> ES, Children Only -> ECH, Spouse & Children -> EF)
			// and add the employee as a $0 placeholder row.
			const employeeNotEnrolling = !planInputs?.coverage;
			const promoteForZeroEmployee =
				!!Plan?.can_each_relationship_enroll_indipendently_in_this_plan &&
				!Plan?.employee_required &&
				employeeNotEnrolling;

			const promoteCoverageLabel = (label: string | null | undefined): string | null | undefined => {
				if (!promoteForZeroEmployee) return label;
				switch (label) {
					case "Spouse Only":
						return "Employee & Spouse";
					case "Children Only":
						return "Employee & Children";
					case "Spouse & Children":
						return "Employee & Family";
					default:
						return label;
				}
			};

			// Validate by the keys: a spouse/child-only enrollment may only be promoted when the
			// matching "can enroll individually" flag is turned on for the plan.
			if (promoteForZeroEmployee) {
				const spouseAlone = !!Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;
				const childAlone = !!Plan?.benefit_amount?.child?.child_can_enroll_individually;
				if (finalCoverageForCode === "Spouse Only" && !spouseAlone) {
					alert("Spouse is not allowed to enroll individually in this plan.");
					return;
				}
				if (finalCoverageForCode === "Children Only" && !childAlone) {
					alert("Child is not allowed to enroll individually in this plan.");
					return;
				}
				if (finalCoverageForCode === "Spouse & Children" && !(spouseAlone && childAlone)) {
					alert("Spouse and child are not both allowed to enroll individually in this plan.");
					return;
				}
			}

			const codeCoverageLabel = promoteCoverageLabel(finalCoverageForCode);
			const coverage_code = VEB_TO_GENERAL_COVERAGE_CODE[codeCoverageLabel as keyof VEBToGeneralCoverageCodeType];
			// console.log("Coverage code", coverage_code, "from", codeCoverageLabel);
			if (!coverage_code) {
				// console.error(`No coverage code mapped for: ${codeCoverageLabel ?? effectiveCoverage}`);
				alert("Invalid coverage selection. Please try again.");
				return;
			}

			const totalCombinedPremium = Number(
				(
					standardPremium +
					spousePremium +
					childPremium +
					(planInputs?.rider_present ? riderEmployeePremium : 0) +
					(planInputs?.rider_present ? riderSpousePremium : 0) +
					(planInputs?.rider_present ? riderChildPremium : 0)
				).toFixed(2)
			);

			const {
				employeePrimary,
				employeeContingent,
				spousePrimary,
				spouseContingent,
				childPrimary,
				childContingent
			} = beneficiaries;

			const mainEnrollments: VEBWholeLifeEnrollments[] = [];
			const riderEnrollments: VEBWholeLifeEnrollments[] = [];

			const spouseDep = eligibleDependents.find((d) => d.relationship === "SPOUSE") as Member | undefined;
			const childDeps = eligibleDependents.filter(
				(d) =>
					d.relationship === "CHILD" ||
					d.relationship === "STEP CHILD" ||
					d.relationship === "CORT-ORDER CHILD"
			) as Member[];

			// Promote the row-driving label the same way as the code, so the employee $0 row is
			// created for spouse/child-only enrollments (non-promoted plans keep their original label).
			const coverageForRows = promoteCoverageLabel(effectiveCoverage);

			const includeEmployee =
				coverageForRows === "Employee Only" ||
				coverageForRows === "Employee & Spouse" ||
				coverageForRows === "Employee & Children" ||
				coverageForRows === "Employee & Family";

			const includeSpouse =
				coverageForRows === "Employee & Spouse" ||
				coverageForRows === "Employee & Family" ||
				coverageForRows === "Spouse Only" ||
				coverageForRows === "Spouse & Children";

			const includeChildren =
				coverageForRows === "Employee & Children" ||
				coverageForRows === "Employee & Family" ||
				coverageForRows === "Spouse & Children";

			const riderIncludeEmployee =
				effectiveRiderCoverage === "Employee Only" ||
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family";

			const riderIncludeSpouse =
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Spouse Only" ||
				effectiveRiderCoverage === "Spouse & Children";

			const riderIncludeChildren =
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Spouse & Children" ||
				effectiveRiderCoverage === "Children Only";

			// Derive a single combined coverage code for the rider the same way the
			// standard plan derives `coverage_code`, and reuse it across every rider row
			// (employee/spouse/child) instead of looking each one up separately. This is
			// required because VEB_TO_GENERAL_COVERAGE_CODE only has employee-inclusive keys
			// ("Employee Only" / "Employee & Spouse" / "Employee & Children" / "Employee & Family"),
			// so a spouse-only or children-only rider selection must be promoted to its
			// employee-inclusive equivalent before lookup, exactly like promoteCoverageLabel does.
			const finalRiderCoverageForCode = (() => {
				const hasEmployee = !!riderPlanInputs?.coverage;
				const hasSpouse = !!(riderSpousePlanInputs?.benefit_amount || riderSpousePlanInputs?.coverage_volume);
				const hasChild = !!(riderChildPlanInputs?.benefit_amount || riderChildPlanInputs?.coverage_volume);

				if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
				if (hasEmployee && hasSpouse) return "Employee & Spouse";
				if (hasEmployee && hasChild) return "Employee & Children";
				if (hasEmployee) return "Employee Only";
				if (hasSpouse && hasChild) return "Spouse & Children";
				if (hasSpouse) return "Spouse Only";
				if (hasChild) return "Children Only";

				return effectiveRiderCoverage;
			})();

			const promoteRiderCoverageLabel = (label: string | null | undefined): string | null | undefined => {
				switch (label) {
					case "Spouse Only":
						return "Employee & Spouse";
					case "Children Only":
						return "Employee & Children";
					case "Spouse & Children":
						return "Employee & Family";
					default:
						return label;
				}
			};

			const riderCodeCoverageLabel = promoteRiderCoverageLabel(finalRiderCoverageForCode);
			const riderCoverageCode =
				VEB_TO_GENERAL_COVERAGE_CODE[riderCodeCoverageLabel as keyof VEBToGeneralCoverageCodeType];

			if (
				planInputs.rider_present &&
				(riderIncludeEmployee || riderIncludeSpouse || riderIncludeChildren) &&
				!riderCoverageCode
			) {
				// console.error(`No coverage code mapped for rider: ${riderCodeCoverageLabel}`);
				alert("Invalid rider coverage selection. Please try again.");
				return;
			}

			// Combined coverage tier = the UNION of who is covered across the standard
			// plan and the rider. Both `coverage_code` and `riderCoverageCode` are already
			// promoted to employee-inclusive tiers, so the member is covered for a
			// spouse/child if EITHER side covers them. Example: standard = Employee Only
			// (EE) + rider = Spouse & Child => combined = EF. Every standard and rider
			// enrollment row below is stamped with this one common code (and the SI/GI
			// records use the same combinedCoverageCode), so they never disagree.
			const combinedCodes = [coverage_code, planInputs.rider_present ? riderCoverageCode : undefined].filter(
				Boolean
			) as string[];
			const combinedHasSpouse = combinedCodes.some((c) => c === "ES" || c === "EF");
			const combinedHasChild = combinedCodes.some((c) => c === "ECH" || c === "EF");
			const combinedCoverageCode =
				combinedHasSpouse && combinedHasChild
					? "EF"
					: combinedHasSpouse
					? "ES"
					: combinedHasChild
					? "ECH"
					: "EE";

			// console.log("effectiveCoverage=================...>>>", effectiveCoverage);

			if (
				(includeEmployee && planInputs.coverage) ||
				promoteForZeroEmployee ||
				Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually ||
				Plan?.benefit_amount?.child_can_enroll_individually
			) {
				mainEnrollments.push({
					plan: Plan,
					premiumAmount: !planInputs.coverage ? 0 : Number(standardPremium.toFixed(2)),
					totalPremium: totalCombinedPremium,
					coverageCode: combinedCoverageCode,
					benefitAmount: planInputs.benefit_amount ?? 0,
					planName: Plan.plan_name,
					subPlan: planInputs.coverage_volume || null,
					planFor: { ...member, is_tobacco: isEmployeeTobacco },
					VEB_primary_beneficiary: Plan?.beneficiaries_required ? employeePrimary : [],
					VEB_contingent_beneficiary: Plan?.beneficiaries_required ? employeeContingent : []
				});
			}

			const spouseCanEnrollAloneForPush = Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;
			const spouseHasOwnSelection = !!(spousePlanInputs?.coverage_volume || spousePlanInputs?.benefit_amount);

			if (includeSpouse && spouseDep && (!spouseCanEnrollAloneForPush || spouseHasOwnSelection)) {
				mainEnrollments.push({
					plan: Plan,
					premiumAmount: spousePremium > 0 ? Number(spousePremium.toFixed(2)) : 0,
					totalPremium: totalCombinedPremium,
					coverageCode: combinedCoverageCode,
					benefitAmount: spousePlanInputs.benefit_amount ?? 0,
					planName: Plan.plan_name,
					subPlan: spousePlanInputs?.coverage_volume || planInputs?.coverage_volume || null,
					planFor: { ...spouseDep, is_tobacco: isSpouseTobacco },
					VEB_primary_beneficiary: Plan?.beneficiaries_required ? spousePrimary : [],
					VEB_contingent_beneficiary: Plan?.beneficiaries_required ? spouseContingent : []
				});
			}
			// console.log("includeChildren", includeChildren);
			if (includeChildren && childDeps.length > 0) {
				childDeps.forEach((child) =>
					mainEnrollments.push({
						plan: Plan,
						premiumAmount:
							Plan?.can_each_relationship_enroll_indipendently_in_this_plan && childPremium > 0
								? Number(childPremium.toFixed(2))
								: 0,
						totalPremium: totalCombinedPremium,
						coverageCode: combinedCoverageCode,
						benefitAmount: childPlanInputs.benefit_amount ?? 0,
						planName: Plan.plan_name,
						subPlan: childPlanInputs.coverage_volume || planInputs?.coverage_volume || null,
						planFor: child,
						VEB_primary_beneficiary: Plan?.beneficiaries_required ? childPrimary : [],
						VEB_contingent_beneficiary: Plan?.beneficiaries_required ? childContingent : []
					})
				);
			}

			if (planInputs.rider_present) {
				if (riderIncludeEmployee && riderPlanInputs.coverage) {
					riderEnrollments.push({
						plan: Plan,
						premiumAmount: riderEmployeePremium,
						totalPremium: totalCombinedPremium,
						coverageCode: combinedCoverageCode,
						benefitAmount: riderPlanInputs.benefit_amount ?? 0,
						planName: Plan.rider?.name,
						subPlan: null,
						planFor: { ...member, is_tobacco: isEmployeeTobacco },
						VEB_primary_beneficiary: Plan?.beneficiaries_required ? employeePrimary : [],
						VEB_contingent_beneficiary: Plan?.beneficiaries_required ? employeeContingent : []
					});
				}

				if (riderIncludeSpouse && spouseDep && riderSpousePlanInputs.coverage) {
					riderEnrollments.push({
						plan: Plan,
						premiumAmount: riderSpousePremium,
						totalPremium: totalCombinedPremium,
						coverageCode: combinedCoverageCode,
						benefitAmount: riderSpousePlanInputs.benefit_amount ?? 0,
						planName: Plan.rider?.name,
						subPlan: Plan?.rider?.plan_name ?? null,
						planFor: { ...spouseDep, is_tobacco: isSpouseTobacco },
						VEB_primary_beneficiary: Plan?.beneficiaries_required ? spousePrimary : [],
						VEB_contingent_beneficiary: Plan?.beneficiaries_required ? spouseContingent : []
					});
				}

				if (riderIncludeChildren && childDeps.length > 0 && riderChildPlanInputs.coverage) {
					const childrenToEnroll =
						selectedRiderChildren.length > 0
							? childDeps.filter((child) => {
									const childId = (child as any)._id || (child as any).id;
									return selectedRiderChildren.includes(childId);
							  })
							: childDeps;

					childrenToEnroll.forEach((child) =>
						riderEnrollments.push({
							plan: Plan,
							premiumAmount: riderChildPremium,
							totalPremium: totalCombinedPremium,
							coverageCode: combinedCoverageCode,
							benefitAmount: riderChildPlanInputs.benefit_amount ?? 0,
							planName: Plan?.rider?.name,
							subPlan: null,
							planFor: child,
							VEB_primary_beneficiary: Plan?.beneficiaries_required ? childPrimary : [],
							VEB_contingent_beneficiary: Plan?.beneficiaries_required ? childContingent : []
						})
					);
				}
			}

			// ── Validate all rows ──
			const invalidRow = mainEnrollments.findIndex((e) => !e.coverageCode);
			if (invalidRow !== -1) {
				// console.error(`mainEnrollments[${invalidRow}] missing coverageCode`, mainEnrollments[invalidRow]);
				alert(`Enrollment row ${invalidRow} is missing a coverage code.`);
				return;
			}

			const invalidRiderRow = riderEnrollments.findIndex((e) => !e.coverageCode);
			if (invalidRiderRow !== -1) {
				// console.error(
				// 	`riderEnrollments[${invalidRiderRow}] missing coverageCode`,
				// 	riderEnrollments[invalidRiderRow]
				// );
				alert(`Rider enrollment row ${invalidRiderRow} is missing a coverage code.`);
				return;
			}

			// ── Build initial payload ──
			const mainPayload = generatePayload(
				mainEnrollments,
				VEBOpenEnrollment,
				paycheck,
				false,
				Plan?.plan_name,
				Plan?.plan_code
			);

			const riderPayload =
				riderEnrollments.length > 0
					? generatePayload(
							riderEnrollments,
							VEBOpenEnrollment,
							paycheck,
							true,
							Plan?.plan_name,
							Plan?.plan_code,
							Plan?.rider?.name
					  )
					: null;

			// ── Check for already-enrolled members ──
			const existEnrollmentData = await trackPromise(api.enrollment.existsVEBEnrollment(mainPayload));

			let finalMainPayload = mainPayload;

			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNsPreview = existEnrollmentData.map((e: any) => e?.member?.SSN).filter(Boolean);

				const filteredForPreview = mainEnrollments.filter((e) => !existingSSNsPreview.includes(e.planFor?.SSN));

				// ── Resolve new coverage label ──
				const previewHasEmployee = filteredForPreview.some((e) => e.planFor?.SSN === member?.SSN);
				const previewHasSpouse = filteredForPreview.some((e) => e.planFor?.SSN === spouseDep?.SSN);
				const previewHasChildren = filteredForPreview.some((e) =>
					childDeps.some((c) => c.SSN === e.planFor?.SSN)
				);

				// ── Check if spouse and ALL children are already enrolled ──
				const spouseAlreadyEnrolled = spouseDep?.SSN ? existingSSNsPreview.includes(spouseDep.SSN) : false;
				const allChildrenAlreadyEnrolled =
					childDeps.length > 0 && childDeps.every((c) => existingSSNsPreview.includes(c.SSN));

				const resolveCoverageLabel = (
					hasEmployee: boolean,
					hasSpouse: boolean,
					hasChildren: boolean,
					forceEmployeeOnly: boolean
				): string | null => {
					const options: string[] = Plan?.coverage_for?.options ?? [];

					// ── If spouse and all children already enrolled → Employee Only ──
					if (forceEmployeeOnly && hasEmployee) {
						if (Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
							return "Employee Only";
						}
						if (options.includes("Employee Only")) return "Employee Only";
						return null;
					}

					// ── Independent enrollment: use full combined coverage label directly ──
					if (Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
						if (hasEmployee && hasSpouse && hasChildren) return "Employee & Family";
						if (hasEmployee && hasSpouse) return "Employee & Spouse";
						if (hasEmployee && hasChildren) return "Employee & Children";
						if (hasEmployee) return "Employee Only";
						if (hasSpouse && hasChildren) return "Spouse & Children";
						if (hasSpouse) return "Spouse Only";
						if (hasChildren) return "Children Only";
						return null;
					}

					// ── Not independent: check against plan's available options with fallback ──
					if (hasEmployee && hasSpouse && hasChildren) {
						if (options.includes("Employee & Family")) return "Employee & Family";
						if (options.includes("Employee & Spouse")) return "Employee & Spouse";
						if (options.includes("Employee & Children")) return "Employee & Children";
						if (options.includes("Employee Only")) return "Employee Only";
					}

					if (hasEmployee && hasSpouse) {
						if (options.includes("Employee & Spouse")) return "Employee & Spouse";
						if (options.includes("Employee Only")) return "Employee Only";
					}

					if (hasEmployee && hasChildren) {
						if (options.includes("Employee & Children")) return "Employee & Children";
						if (options.includes("Employee Only")) return "Employee Only";
					}

					if (hasEmployee) {
						if (options.includes("Employee Only")) return "Employee Only";
					}

					if (hasSpouse && hasChildren) {
						if (options.includes("Spouse & Children")) return "Spouse & Children";
						if (options.includes("Spouse Only")) return "Spouse Only";
					}

					if (hasSpouse) {
						if (options.includes("Spouse Only")) return "Spouse Only";
					}

					if (hasChildren) {
						if (options.includes("Children Only")) return "Children Only";
					}

					return null;
				};

				// ── forceEmployeeOnly = spouse already enrolled AND all children already enrolled ──
				const forceEmployeeOnly = spouseAlreadyEnrolled && allChildrenAlreadyEnrolled;

				const previewCoverageLabel = resolveCoverageLabel(
					previewHasEmployee,
					previewHasSpouse,
					previewHasChildren,
					forceEmployeeOnly
				);

				const filteredForPremiumCalc = filteredForPreview.filter((e) => !e.planFor?.SSN?.includes("@"));

				let previewTotalPremium = 0;

				// ── Pre-calculate employee premium separately ──
				let previewEmployeePremium = 0;
				const previewEmployeeEnrollment = filteredForPremiumCalc.find((e) => e.planFor?.SSN === member?.SSN);

				if (previewEmployeeEnrollment && previewCoverageLabel) {
					try {
						previewEmployeePremium = Number(
							await dynamicPremiumCalculation(
								Plan,
								Plan?.can_each_relationship_enroll_indipendently_in_this_plan
									? "Employee Only"
									: previewCoverageLabel,
								planInputs.coverage_volume,
								planInputs.benefit_amount,
								member,
								paycheck?.pay_frequency,
								isEmployeeTobacco,
								true
							)
						);
					} catch {
						previewEmployeePremium = previewEmployeeEnrollment.premiumAmount;
					}
					previewTotalPremium += previewEmployeePremium;
				}

				// ── Calculate spouse/child premiums only if independent enrollment and not forced to Employee Only ──
				if (Plan?.can_each_relationship_enroll_indipendently_in_this_plan && !forceEmployeeOnly) {
					for (const enrollment of filteredForPremiumCalc) {
						const isEmployee = enrollment.planFor?.SSN === member?.SSN;
						const isSpouseMember = enrollment.planFor?.SSN === spouseDep?.SSN;
						const isChild = childDeps.some((c) => c.SSN === enrollment.planFor?.SSN);

						if (isEmployee) continue;

						let recalcPremium = enrollment.premiumAmount;

						try {
							if (isSpouseMember && spouseDep && previewCoverageLabel) {
								recalcPremium = Number(
									await dynamicPremiumCalculation(
										Plan,
										spousePlanInputs.coverage ?? previewCoverageLabel,
										spousePlanInputs.coverage_volume ?? planInputs.coverage_volume,
										spousePlanInputs.benefit_amount,
										spouseDep,
										paycheck?.pay_frequency,
										isSpouseTobacco,
										true
									)
								);
							} else if (isChild) {
								const firstChild =
									filteredForPremiumCalc.find((e) => childDeps.some((c) => c.SSN === e.planFor?.SSN))
										?.planFor ?? childDeps[0];

								recalcPremium = Number(
									await dynamicPremiumCalculation(
										Plan,
										childPlanInputs.coverage ?? "Children Only",
										childPlanInputs.coverage_volume,
										childPlanInputs.benefit_amount,
										firstChild,
										paycheck?.pay_frequency,
										false,
										true
									)
								);
							}
						} catch {
							recalcPremium = enrollment.premiumAmount;
						}

						previewTotalPremium += recalcPremium;
					}
				}

				previewTotalPremium = Number(previewTotalPremium.toFixed(2));

				setExistsEnrollmentMeta({
					newCoverageLabel: previewCoverageLabel,
					newTotalPremium: previewTotalPremium
				});

				setIsDependentExistsModelOpen(true);
				setExistsDependentData(existEnrollmentData.map((item: any) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();

				const filteredMainEnrollments = mainEnrollments.filter(
					(e) => !existingSSNsPreview.includes(e.planFor?.SSN) && !e.planFor?.SSN?.includes("@")
				);

				if (filteredMainEnrollments.length === 0) {
					// console.warn("All enrollments already exist. Nothing to submit.");
					return;
				}

				const remainingHasEmployee = filteredMainEnrollments.some((e) => e.planFor?.SSN === member?.SSN);
				const remainingHasSpouse = filteredMainEnrollments.some((e) => e.planFor?.SSN === spouseDep?.SSN);
				const remainingHasChildren = filteredMainEnrollments.some((e) =>
					childDeps.some((c) => c.SSN === e.planFor?.SSN)
				);

				const updatedCoverageLabel = resolveCoverageLabel(
					remainingHasEmployee,
					remainingHasSpouse,
					remainingHasChildren,
					forceEmployeeOnly
				);

				if (!updatedCoverageLabel) {
					// console.warn("Could not resolve updated coverage label after filtering.");
					return;
				}

				const updatedCoverageCode =
					VEB_TO_GENERAL_COVERAGE_CODE[updatedCoverageLabel as keyof VEBToGeneralCoverageCodeType];

				if (!updatedCoverageCode) {
					// console.error(`No coverage code mapped for updated coverage: ${updatedCoverageLabel}`);
					alert("Could not resolve coverage after excluding existing enrollments. Please try again.");
					return;
				}

				const recalculatedEnrollments: VEBWholeLifeEnrollments[] = [];

				let recalculatedEmployeePremium = 0;
				const employeeEnrollment = filteredMainEnrollments.find((e) => e.planFor?.SSN === member?.SSN);

				if (employeeEnrollment) {
					try {
						recalculatedEmployeePremium = Number(
							await dynamicPremiumCalculation(
								Plan,
								Plan?.can_each_relationship_enroll_indipendently_in_this_plan
									? "Employee Only"
									: updatedCoverageLabel,
								planInputs.coverage_volume,
								planInputs.benefit_amount,
								member,
								paycheck?.pay_frequency,
								isEmployeeTobacco,
								true
							)
						);
					} catch {
						recalculatedEmployeePremium = employeeEnrollment.premiumAmount;
					}
					setStandardPremium(recalculatedEmployeePremium);
				}

				for (const enrollment of filteredMainEnrollments) {
					const isEmployee = enrollment.planFor?.SSN === member?.SSN;
					const isSpouseMember = enrollment.planFor?.SSN === spouseDep?.SSN;
					const isChild = childDeps.some((c) => c.SSN === enrollment.planFor?.SSN);

					// ── Skip spouse/child if forced to Employee Only ──
					if (forceEmployeeOnly && (isSpouseMember || isChild)) continue;

					// ── Skip spouse/child if coverage resolved to Employee Only ──
					if (updatedCoverageLabel === "Employee Only" && (isSpouseMember || isChild)) continue;

					// ── Skip spouse if coverage does not include spouse ──
					if (
						isSpouseMember &&
						!updatedCoverageLabel?.includes("Spouse") &&
						!updatedCoverageLabel?.includes("Family")
					)
						continue;

					// ── Skip child if coverage does not include children ──
					if (
						isChild &&
						!updatedCoverageLabel?.includes("Children") &&
						!updatedCoverageLabel?.includes("Family")
					)
						continue;

					let recalculatedPremium = enrollment.premiumAmount;

					try {
						if (isEmployee) {
							recalculatedPremium = recalculatedEmployeePremium;
						} else if (Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
							if (isSpouseMember && spouseDep) {
								recalculatedPremium = Number(
									await dynamicPremiumCalculation(
										Plan,
										spousePlanInputs.coverage ?? updatedCoverageLabel,
										spousePlanInputs.coverage_volume ?? planInputs.coverage_volume,
										spousePlanInputs.benefit_amount,
										spouseDep,
										paycheck?.pay_frequency,
										isSpouseTobacco,
										true
									)
								);
							} else if (isChild) {
								const firstRemainingChild =
									filteredMainEnrollments.find((e) => childDeps.some((c) => c.SSN === e.planFor?.SSN))
										?.planFor ?? childDeps[0];

								recalculatedPremium = Number(
									await dynamicPremiumCalculation(
										Plan,
										childPlanInputs.coverage ?? "Children Only",
										childPlanInputs.coverage_volume,
										childPlanInputs.benefit_amount,
										firstRemainingChild,
										paycheck?.pay_frequency,
										false,
										true
									)
								);
							}
						}
					} catch {
						recalculatedPremium = enrollment.premiumAmount;
					}

					recalculatedEnrollments.push({
						...enrollment,
						premiumAmount: recalculatedPremium,
						coverageCode: updatedCoverageCode
					});
				}

				const recalculatedTotalPremium = Number(
					recalculatedEnrollments.reduce((sum, e) => sum + (e.premiumAmount ?? 0), 0).toFixed(2)
				);

				const recalcEmployee = recalculatedEnrollments.find((e) => e.planFor?.SSN === member?.SSN);
				const recalcSpouse = recalculatedEnrollments.find((e) => e.planFor?.SSN === spouseDep?.SSN);
				const recalcChild = recalculatedEnrollments.find((e) =>
					childDeps.some((c) => c.SSN === e.planFor?.SSN)
				);

				if (recalcEmployee) setStandardPremium(recalcEmployee.premiumAmount ?? 0);
				if (recalcSpouse) setSpousePremium(recalcSpouse.premiumAmount ?? 0);
				if (recalcChild) setChildPremium(recalcChild.premiumAmount ?? 0);

				setTotalPremium(recalculatedTotalPremium);

				const updatedEnrollments = recalculatedEnrollments.map((e) => ({
					...e,
					totalPremium: recalculatedTotalPremium
				}));

				finalMainPayload = generatePayload(
					updatedEnrollments,
					VEBOpenEnrollment,
					paycheck,
					false,
					Plan?.plan_name,
					Plan?.plan_code
				);
			} else {
				setExistsDependentData(null);
				setExistsEnrollmentMeta(null);
			}
			// console.log();
			const standardResponse = await trackPromise(api.enrollment.addVEBEnrollment(finalMainPayload));

			if (standardResponse && riderPayload) {
				await trackPromise(api.enrollment.addVEBEnrollment(riderPayload));
			}

			const dependencies: StandardPlanDependency[] = (Plan?.standard_plan_dependency ?? []).filter(Boolean);
			for (const dep of dependencies) {
				const depPlanName = dep.plan;
				if (!depPlanName) continue;

				const isSameCoverage = dep.same_coverage === true || dep.same_coverage === "true";
				const isRequired = dep.required === true || dep.required === "true";

				const depPlan = currentPlans.find((p: any) => p.plan_name === depPlanName);
				if (!depPlan) continue;

				const depInputs = dependencyPlanInputs[depPlanName] ?? {};
				const depPremium = dependencyPremiums[depPlanName] ?? 0;

				// If same_coverage flag is true, inherit coverage from the main plan
				const resolvedCoverage = isSameCoverage
					? depInputs.coverage || finalCoverageForCode
					: depInputs.coverage;

				if (!resolvedCoverage) continue;

				const depCoverageCode =
					VEB_TO_GENERAL_COVERAGE_CODE[resolvedCoverage as keyof VEBToGeneralCoverageCodeType];

				if (!depCoverageCode) {
					// console.error(`No coverage code for dep plan: ${depPlanName} coverage: ${resolvedCoverage}`);
					if (isRequired) {
						alert(`Required dependency plan "${depPlanName}" has an invalid coverage. Please try again.`);
						return; // block submission if required dep fails
					}
					continue;
				}

				const depEnrollments: VEBWholeLifeEnrollments[] = [];

				depEnrollments.push({
					plan: depPlan,
					premiumAmount: depPremium,
					totalPremium: depPremium,
					coverageCode: depCoverageCode,
					benefitAmount: depInputs.benefit_amount ?? 0,
					planName: depPlan.plan_name,
					subPlan: depInputs.coverage_volume ?? null,
					planFor: { ...member, is_tobacco: false },
					VEB_primary_beneficiary: depPlan?.beneficiaries_required ? employeePrimary : [],
					VEB_contingent_beneficiary: employeeContingent
				});

				const depIncludeSpouse =
					resolvedCoverage === "Employee & Spouse" ||
					resolvedCoverage === "Employee & Family" ||
					resolvedCoverage === "Spouse Only" ||
					resolvedCoverage === "Spouse & Children";

				if (spouseDep && depIncludeSpouse) {
					const depSpouseCoverageCode =
						VEB_TO_GENERAL_COVERAGE_CODE[resolvedCoverage as keyof VEBToGeneralCoverageCodeType];

					if (depSpouseCoverageCode) {
						depEnrollments.push({
							plan: depPlan,
							premiumAmount: dependencyPremiums[`${depPlanName}_spouse`] ?? 0,
							totalPremium: depPremium,
							coverageCode: depSpouseCoverageCode,
							benefitAmount: depInputs.spouse_benefit_amount,
							planName: depPlan.plan_name,
							subPlan: depInputs.spouse_coverage_volume ?? null,
							planFor: { ...spouseDep, is_tobacco: isSpouseTobacco },
							VEB_primary_beneficiary: spousePrimary,
							VEB_contingent_beneficiary: spouseContingent
						});
					}
				}

				const depSupportsChildren =
					depPlan?.coverage_for?.options?.includes("Employee & Children") ||
					depPlan?.coverage_for?.options?.includes("Employee & Family");

				if (
					depSupportsChildren &&
					childDeps.length > 0 &&
					(resolvedCoverage.includes("Employee & Children") || resolvedCoverage.includes("Employee & Family"))
				) {
					const depChildCoverageCode =
						VEB_TO_GENERAL_COVERAGE_CODE[resolvedCoverage as keyof VEBToGeneralCoverageCodeType];
					childDeps.forEach((child) =>
						depEnrollments.push({
							plan: depPlan,
							premiumAmount: 0,
							totalPremium: depPremium,
							coverageCode: depChildCoverageCode,
							benefitAmount: depInputs.child_benefit_amount,
							planName: depPlan.plan_name,
							subPlan: null,
							planFor: child,
							VEB_primary_beneficiary: childPrimary,
							VEB_contingent_beneficiary: childContingent
						})
					);
				}

				const depPayload = generatePayload(
					depEnrollments,
					VEBOpenEnrollment,
					paycheck,
					false,
					depPlanName,
					depPlan.plan_code
				);
				await trackPromise(api.enrollment.addVEBEnrollment(depPayload));
			}

			if (member?._id) {
				try {
					await api.enrollment.updateVebEnrollment({ is_tobacco: isEmployeeTobacco }, "member", member._id);
					setMember({ ...member, is_tobacco: isEmployeeTobacco });
				} catch (err) {
					// console.error("Failed to update employee tobacco status", err);
				}
			}
			const spouseDetails = eligibleDependents?.find((d) => d.relationship === "SPOUSE");
			if (spouseDetails?._id) {
				try {
					const updatedSpouse = await api.enrollment.updateVebEnrollment(
						{ is_tobacco: isSpouseTobacco },
						"member",
						spouseDetails._id
					);
					if (updatedSpouse) {
						setDependents(
							dependents.map((d: Member) =>
								d._id === spouseDetails._id ? { ...d, is_tobacco: isSpouseTobacco } : d
							)
						);
					}
				} catch (err) {
					// console.error("Failed to update spouse tobacco status", err);
				}
			}

			if (standardResponse) {
				deleteCurrentEnrollment();
				getVEBEnrollmentInitData();
				history.push(`?step=${urlSearchParams.get("step")}&stage=2`);
			}
		} catch (error) {
			// console.error("handleActivateButtonClick error:", error);
		}
	}, [
		handleValidation,
		handleBeneficiaryValidate,
		member,
		VEBOpenEnrollment,
		paycheck,
		planInputs,
		spousePlanInputs,
		childPlanInputs,
		riderPlanInputs,
		riderSpousePlanInputs,
		riderChildPlanInputs,
		eligibleDependents,
		currentPlans,
		dependencyPlanInputs,
		dependencyPremiums,
		effectiveRiderCoverage,
		effectiveCoverage,
		generatePayload,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		urlSearchParams,
		history,
		Plan,
		standardPremium,
		spousePremium,
		childPremium,
		riderEmployeePremium,
		riderSpousePremium,
		riderChildPremium,
		beneficiaries,
		isEmployeeTobacco,
		isSpouseTobacco,
		selectedRiderChildren,
		isEmployeeTobacco,
		isSpouseTobacco,
		dependents,
		setDependents,
		submitSIUnderwriting,
		submitRiderSIUnderwriting,
		submitGIUnderwriting
	]);

	const handleActivateCoreButtonClick = useCallback(async () => {
		try {
			if (!member) {
				alert("Your member record could not be loaded. Please refresh the page and try again.");
				return;
			}
			if (!paycheck) {
				alert("No paycheck record was found for you. Please contact your administrator.");
				return;
			}
			if (!openEnrollment || !selectedPlan) {
				alert("This plan's enrollment details could not be loaded. Please contact your administrator.");
				return;
			}

			const liveSubmittedStatus = siSubmittedStatusRef.current;
			const liveRiderSubmittedStatus = riderSiSubmittedStatusRef.current;
			const liveSiStore = siDataStoreRef.current;
			const liveRiderSiStore = riderSiDataStoreRef.current;
			const liveGiStore = giDataStoreRef.current;

			// ── Step 1: Check standard SI queue ──
			const standardQueue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
			if (employeeNeedsSI && !liveSubmittedStatus.EMPLOYEE) standardQueue.push("EMPLOYEE");
			if (spouseNeedsSI && !liveSubmittedStatus.SPOUSE) standardQueue.push("SPOUSE");
			if (childNeedsSI && !liveSubmittedStatus.CHILD) standardQueue.push("CHILD");

			if (standardQueue.length > 0) {
				setSiQueue(standardQueue);
				setCurrentRelation(standardQueue[0]);
				setSiModalOpen(true);
				return;
			}

			// ── Step 2: Check rider SI queue ──
			if (planInputs?.rider_present) {
				const riderQueue: Array<"EMPLOYEE" | "SPOUSE" | "CHILD"> = [];
				if (riderEmployeeNeedsSI && !liveRiderSubmittedStatus.EMPLOYEE) riderQueue.push("EMPLOYEE");
				if (riderSpouseNeedsSI && !liveRiderSubmittedStatus.SPOUSE) riderQueue.push("SPOUSE");
				if (riderChildNeedsSI && !liveRiderSubmittedStatus.CHILD) riderQueue.push("CHILD");

				if (riderQueue.length > 0) {
					setRiderSiQueue(riderQueue);
					setRiderCurrentRelation(riderQueue[0]);
					setRiderSiModalOpen(true);
					return;
				}
			}

			if (!handleValidation()) return;
			if (!handleBeneficiaryValidate()) return;

			if (liveGiStore.length > 0) {
				try {
					await submitCoreGIUnderwriting(liveGiStore);
				} catch (err) {
					alert("Failed to submit eligibility answers. Please try again.");
					return;
				}
			}

			if (liveSiStore.length > 0) {
				try {
					await submitCoreSIUnderwriting(liveSiStore);
				} catch (err) {
					alert("Failed to submit underwriting answers. Please try again.");
					return;
				}
			}

			if (liveRiderSiStore.length > 0) {
				try {
					await submitCoreRiderSIUnderwriting(liveRiderSiStore);
				} catch (err) {
					console.error("Failed to save Rider SI underwriting", err);
					alert("Failed to submit rider underwriting answers. Please try again.");
					return;
				}
			}

			// ── Coverage resolution: identical to the VEB handler ──
			const spouseEnrollingIndividually =
				Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually && !!spousePlanInputs?.benefit_amount;

			const childEnrollingIndividually =
				Plan?.benefit_amount?.child?.child_can_enroll_individually && !!childPlanInputs?.benefit_amount;

			const finalCoverageForCode = (() => {
				if (!Plan?.can_each_relationship_enroll_indipendently_in_this_plan) {
					return effectiveCoverage;
				}

				const hasEmployee = !!planInputs?.coverage;
				const hasSpouse =
					spouseEnrollingIndividually ||
					!!spousePlanInputs?.coverage_volume ||
					!!spousePlanInputs?.benefit_amount;
				const hasChild =
					childEnrollingIndividually ||
					!!childPlanInputs?.coverage_volume ||
					!!childPlanInputs?.benefit_amount;

				if (hasEmployee && hasSpouse && hasChild) return "Employee & Family";
				if (hasEmployee && hasSpouse) return "Employee & Spouse";
				if (hasEmployee && hasChild) return "Employee & Children";
				if (hasEmployee) return "Employee Only";
				if (hasSpouse && hasChild) return "Spouse & Children";
				if (hasSpouse) return "Spouse Only";
				if (hasChild) return "Children Only";

				return effectiveCoverage;
			})();

			const employeeNotEnrolling = !planInputs?.coverage;
			const promoteForZeroEmployee =
				!!Plan?.can_each_relationship_enroll_indipendently_in_this_plan &&
				!Plan?.employee_required &&
				employeeNotEnrolling;

			const promoteCoverageLabel = (label: string | null | undefined): string | null | undefined => {
				if (!promoteForZeroEmployee) return label;
				switch (label) {
					case "Spouse Only":
						return "Employee & Spouse";
					case "Children Only":
						return "Employee & Children";
					case "Spouse & Children":
						return "Employee & Family";
					default:
						return label;
				}
			};

			if (promoteForZeroEmployee) {
				const spouseAlone = !!Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;
				const childAlone = !!Plan?.benefit_amount?.child?.child_can_enroll_individually;
				if (finalCoverageForCode === "Spouse Only" && !spouseAlone) {
					alert("Spouse is not allowed to enroll individually in this plan.");
					return;
				}
				if (finalCoverageForCode === "Children Only" && !childAlone) {
					alert("Child is not allowed to enroll individually in this plan.");
					return;
				}
				if (finalCoverageForCode === "Spouse & Children" && !(spouseAlone && childAlone)) {
					alert("Spouse and child are not both allowed to enroll individually in this plan.");
					return;
				}
			}

			const codeCoverageLabel = promoteCoverageLabel(finalCoverageForCode);
			if (!VEB_TO_GENERAL_COVERAGE_CODE[codeCoverageLabel as keyof VEBToGeneralCoverageCodeType]) {
				alert("Invalid coverage selection. Please try again.");
				return;
			}

			const totalCombinedPremium = Number(
				(
					standardPremium +
					spousePremium +
					childPremium +
					(planInputs?.rider_present ? riderEmployeePremium : 0) +
					(planInputs?.rider_present ? riderSpousePremium : 0) +
					(planInputs?.rider_present ? riderChildPremium : 0)
				).toFixed(2)
			);

			const { employeePrimary, employeeContingent } = beneficiaries;

			const spouseDep = eligibleDependents.find((d) => d.relationship === "SPOUSE") as Member | undefined;
			const childDeps = eligibleDependents.filter(
				(d) =>
					d.relationship === "CHILD" ||
					d.relationship === "STEP CHILD" ||
					d.relationship === "CORT-ORDER CHILD"
			) as Member[];

			const coverageForRows = promoteCoverageLabel(effectiveCoverage);

			const includeEmployee =
				coverageForRows === "Employee Only" ||
				coverageForRows === "Employee & Spouse" ||
				coverageForRows === "Employee & Children" ||
				coverageForRows === "Employee & Family";

			const includeSpouse =
				coverageForRows === "Employee & Spouse" ||
				coverageForRows === "Employee & Family" ||
				coverageForRows === "Spouse Only" ||
				coverageForRows === "Spouse & Children";

			const includeChildren =
				coverageForRows === "Employee & Children" ||
				coverageForRows === "Employee & Family" ||
				coverageForRows === "Spouse & Children" ||
				coverageForRows === "Children Only";

			const riderIncludeEmployee =
				effectiveRiderCoverage === "Employee Only" ||
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family";

			const riderIncludeSpouse =
				effectiveRiderCoverage === "Employee & Spouse" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Spouse Only" ||
				effectiveRiderCoverage === "Spouse & Children";

			const riderIncludeChildren =
				effectiveRiderCoverage === "Employee & Children" ||
				effectiveRiderCoverage === "Employee & Family" ||
				effectiveRiderCoverage === "Spouse & Children" ||
				effectiveRiderCoverage === "Children Only";

			// Per-relationship child code: single child is EC, two or more are ECH.
			const childCoverageCode: CoverageCode = childDeps.length === 1 ? "EC" : "ECH";

			// ── Build the core standard_details rows ──
			const coreStandardDetails: StandardDetails[] = [];

			if (
				(includeEmployee && planInputs.coverage) ||
				promoteForZeroEmployee ||
				Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually ||
				Plan?.benefit_amount?.child?.child_can_enroll_individually
			) {
				coreStandardDetails.push({
					member_object_id: member._id,
					member_SSN: member.SSN,
					coverage_code: "EE",
					premium_amount: !planInputs.coverage ? 0 : Number(standardPremium.toFixed(2)),
					benefit_amount: Number(planInputs?.benefit_amount ?? 0),
					is_tobacco: isEmployeeTobacco
				});
			}

			const spouseCanEnrollAloneForPush = Plan?.benefit_amount?.spouse?.spouse_can_enroll_individually;
			const spouseHasOwnSelection = !!(spousePlanInputs?.coverage_volume || spousePlanInputs?.benefit_amount);

			if (includeSpouse && spouseDep && (!spouseCanEnrollAloneForPush || spouseHasOwnSelection)) {
				coreStandardDetails.push({
					member_object_id: spouseDep._id,
					member_SSN: spouseDep.SSN,
					coverage_code: "ES",
					premium_amount: spousePremium > 0 ? Number(spousePremium.toFixed(2)) : 0,
					benefit_amount: Number(spousePlanInputs?.benefit_amount ?? 0),
					is_tobacco: isSpouseTobacco
				});
			}

			if (includeChildren && childDeps.length > 0) {
				childDeps.forEach((child) =>
					coreStandardDetails.push({
						member_object_id: child._id,
						member_SSN: child.SSN,
						coverage_code: childCoverageCode,
						premium_amount:
							Plan?.can_each_relationship_enroll_indipendently_in_this_plan && childPremium > 0
								? Number(childPremium.toFixed(2))
								: 0,
						benefit_amount: Number(childPlanInputs?.benefit_amount ?? 0),
						is_tobacco: false
					})
				);
			}

			// ── Rider rows: their OWN array, posted as a separate request, exactly like the
			// VEB handler's second addVEBEnrollment call. They cannot ride along in the base
			// payload: dynamicEnrollment.service.ts splits rows by `plan_name` and then looks
			// the rider up in `internal_dependencies`, which a VEB-shaped plan does not have. ──
			const riderStandardDetails: StandardDetails[] = [];

			if (planInputs.rider_present && Plan?.rider?.name) {
				if (riderIncludeEmployee && riderPlanInputs.coverage) {
					riderStandardDetails.push({
						member_object_id: member._id,
						member_SSN: member.SSN,
						coverage_code: "EE",
						premium_amount: Number(riderEmployeePremium.toFixed(2)),
						benefit_amount: Number(riderPlanInputs?.benefit_amount ?? 0),
						is_tobacco: isEmployeeTobacco
					});
				}

				if (riderIncludeSpouse && spouseDep && riderSpousePlanInputs.coverage) {
					riderStandardDetails.push({
						member_object_id: spouseDep._id,
						member_SSN: spouseDep.SSN,
						coverage_code: "ES",
						premium_amount: Number(riderSpousePremium.toFixed(2)),
						benefit_amount: Number(riderSpousePlanInputs?.benefit_amount ?? 0),
						is_tobacco: isSpouseTobacco
					});
				}

				if (riderIncludeChildren && childDeps.length > 0 && riderChildPlanInputs.coverage) {
					const childrenToEnroll =
						selectedRiderChildren.length > 0
							? childDeps.filter((child) => {
									const childId = (child as any)._id || (child as any).id;
									return selectedRiderChildren.includes(childId);
							  })
							: childDeps;

					const riderChildCode: CoverageCode = childrenToEnroll.length === 1 ? "EC" : "ECH";

					childrenToEnroll.forEach((child) =>
						riderStandardDetails.push({
							member_object_id: child._id,
							member_SSN: child.SSN,
							coverage_code: riderChildCode,
							premium_amount: Number(riderChildPremium.toFixed(2)),
							benefit_amount: Number(riderChildPlanInputs?.benefit_amount ?? 0),
							is_tobacco: false
						})
					);
				}
			}

			if (coreStandardDetails.length === 0) {
				alert("No members were selected for this enrollment. Please review your selections and try again.");
				return;
			}

			// ── common_details: the core payload shape, unchanged ──
			const currentDate = new Date() as unknown as string;
			const planDateComparison: number = manualDateComparator(selectedPlan.start_date, currentDate);

			const effectiveDate = selectedPlan.auto_approve
				? planDateComparison === -1 || planDateComparison === 0
					? getCurrentDate()
					: null
				: null;

			// Map CommonForm's BV2Beneficiery rows onto the core BeneficieryPayload shape.
			// Only the employee buckets are used: the core payload carries a single set, and
			// each CommonForm bucket sums to 100% on its own.
			const toCoreBeneficiaries = (rows: BV2Beneficiery[]) =>
				(rows ?? []).map((b) => ({
					name: `${b.first_name ?? ""} ${b.middle_name ?? ""} ${b.last_name ?? ""}`
						.replace(/\s+/g, " ")
						.trim(),
					date_of_birth: b.date_of_birth ?? "",
					relationship: b.relationship ?? "",
					SSN: b.SSN ?? "",
					address: `${b.address_line_1 ?? ""} ${b.address_line_2 ?? ""}`.replace(/\s+/g, " ").trim(),
					percentage: Number(b.percentage ?? 0)
				}));

			const buildCoreCommonDetails = (
				plan: any,
				openEnrollmentId: string,
				premium: number,
				subPlan: string | null,
				// Rider enrollments keep the parent plan's identity but carry the rider's own
				// name — the same split the VEB payload makes via resolvedPlanName /
				// resolvedBasePlanName.
				planNameOverride?: string,
				basePlanNameOverride?: string
			): CommonDetails => ({
				agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
				location_number: member.location?.location_number as number,
				location_name: member.location?.location_name as string,
				group_number: member.group_number,
				group_name: member.group?.name as string,
				plan_object_id: plan._id,
				plan_code: plan.plan_code,
				plan_name: planNameOverride ?? plan.plan_name,
				base_plan_name: basePlanNameOverride ?? plan.plan_name,
				insured_object_id: member._id,
				insured_SSN: member.SSN,
				writing_number: 0,
				unenrolled_reason: null,
				waive_reason: null,
				termination_reason: null,
				enrollment_date: getCurrentDate(),
				effective_date: effectiveDate,
				termination_date: null,
				open_enrollment_id: openEnrollmentId,
				total_premium: premium.toFixed(2) as unknown as number,
				// CommonForm has no "another group insurance" question.
				another_group_insurance: "",
				enrollment_status: plan.auto_approve ? "ACTIVE" : "SUBMITTED",
				sub_plan: subPlan,
				primary_beneficiery: plan?.beneficiaries_required ? toCoreBeneficiaries(employeePrimary) : [],
				contingent_beneficiery: plan?.beneficiaries_required ? toCoreBeneficiaries(employeeContingent) : []
			});

			const enrollmentPayload: AddEnrollmentPayload = {
				common_details: buildCoreCommonDetails(
					selectedPlan,
					(openEnrollment as any)._id,
					totalCombinedPremium,
					planInputs?.coverage_volume ?? null
				),
				standard_details: coreStandardDetails
			};

			const resp: any = await trackPromise(api.enrollment.addDynamicEnrollments(enrollmentPayload));

			// ── Rider: a second request, gated on the base one succeeding — mirrors
			// `if (standardResponse && riderPayload)` in the VEB handler. ──
			if (resp && riderStandardDetails.length > 0) {
				const riderPayload: AddEnrollmentPayload = {
					common_details: buildCoreCommonDetails(
						selectedPlan,
						(openEnrollment as any)._id,
						totalCombinedPremium,
						Plan?.rider?.plan_name ?? null,
						Plan?.rider?.name as string,
						selectedPlan.plan_name
					),
					standard_details: riderStandardDetails
				};

				await trackPromise(api.enrollment.addDynamicEnrollments(riderPayload));
			}

			// ── Plan dependencies: same conditions as the VEB handler, core payload ──
			const dependencies: StandardPlanDependency[] = (Plan?.standard_plan_dependency ?? []).filter(Boolean);
			for (const dep of dependencies) {
				const depPlanName = dep.plan;
				if (!depPlanName) continue;

				const isSameCoverage = dep.same_coverage === true || dep.same_coverage === "true";
				const isRequired = dep.required === true || dep.required === "true";

				const depPlan = currentPlans.find((p: any) => p.plan_name === depPlanName);
				if (!depPlan) continue;

				const depInputs = dependencyPlanInputs[depPlanName] ?? {};
				const depPremium = dependencyPremiums[depPlanName] ?? 0;

				const resolvedCoverage = isSameCoverage
					? depInputs.coverage || finalCoverageForCode
					: depInputs.coverage;

				if (!resolvedCoverage) continue;

				if (!VEB_TO_GENERAL_COVERAGE_CODE[resolvedCoverage as keyof VEBToGeneralCoverageCodeType]) {
					if (isRequired) {
						alert(`Required dependency plan "${depPlanName}" has an invalid coverage. Please try again.`);
						return;
					}
					continue;
				}

				const depIncludeSpouse =
					resolvedCoverage === "Employee & Spouse" ||
					resolvedCoverage === "Employee & Family" ||
					resolvedCoverage === "Spouse Only" ||
					resolvedCoverage === "Spouse & Children";

				const depSupportsChildren =
					depPlan?.coverage_for?.options?.includes("Employee & Children") ||
					depPlan?.coverage_for?.options?.includes("Employee & Family");

				const depStandardDetails: StandardDetails[] = [
					{
						member_object_id: member._id,
						member_SSN: member.SSN,
						coverage_code: "EE",
						premium_amount: depPremium,
						benefit_amount: Number(depInputs.benefit_amount ?? 0),
						is_tobacco: false
					}
				];

				if (spouseDep && depIncludeSpouse) {
					depStandardDetails.push({
						member_object_id: spouseDep._id,
						member_SSN: spouseDep.SSN,
						coverage_code: "ES",
						premium_amount: dependencyPremiums[`${depPlanName}_spouse`] ?? 0,
						benefit_amount: Number(depInputs.spouse_benefit_amount ?? 0),
						is_tobacco: isSpouseTobacco
					});
				}

				if (
					depSupportsChildren &&
					childDeps.length > 0 &&
					(resolvedCoverage.includes("Employee & Children") || resolvedCoverage.includes("Employee & Family"))
				) {
					const depChildCode: CoverageCode = childDeps.length === 1 ? "EC" : "ECH";
					childDeps.forEach((child) =>
						depStandardDetails.push({
							member_object_id: child._id,
							member_SSN: child.SSN,
							coverage_code: depChildCode,
							premium_amount: 0,
							benefit_amount: Number(depInputs.child_benefit_amount ?? 0),
							is_tobacco: false
						})
					);
				}

				const depPayload: AddEnrollmentPayload = {
					common_details: buildCoreCommonDetails(
						depPlan,
						(openEnrollment as any)._id,
						depPremium,
						depInputs.coverage_volume ?? null
					),
					standard_details: depStandardDetails
				};

				await trackPromise(api.enrollment.addDynamicEnrollments(depPayload));
			}

			// ── Tobacco sync: unchanged from the VEB handler ──
			if (member?._id) {
				try {
					await api.enrollment.updateVebEnrollment({ is_tobacco: isEmployeeTobacco }, "member", member._id);
					setMember({ ...member, is_tobacco: isEmployeeTobacco });
				} catch (err) {
					// non-fatal
				}
			}

			const spouseDetails = eligibleDependents?.find((d) => d.relationship === "SPOUSE");
			if (spouseDetails?._id) {
				try {
					const updatedSpouse = await api.enrollment.updateVebEnrollment(
						{ is_tobacco: isSpouseTobacco },
						"member",
						spouseDetails._id
					);
					if (updatedSpouse) {
						setDependents(
							dependents.map((d: Member) =>
								d._id === spouseDetails._id ? { ...d, is_tobacco: isSpouseTobacco } : d
							)
						);
					}
				} catch (err) {
					// non-fatal
				}
			}

			// `getEnrollmentInitData` returns early when passed false, so it must be called with true.
			if (getEnrollmentInitData) {
				await getEnrollmentInitData(true);
			} else {
				await getVEBEnrollmentInitData();
			}
			// Optional call: CommonForm mounts on two routes, and EnrollmentContext is only
			// provided where the route is wrapped in EnrollmentContextProvider.
			deleteCurrentEnrollment?.();

			// PlanAcknowledgement renders from submittedEnrollment[planName] until the refetched
			// enrollment arrives — without this, stage 2 shows an empty page.
			setSubmittedEnrollment?.((prev: any) => ({ ...prev, [selectedPlan.plan_name]: resp?.[0] }));

			history.push(`?step=${urlSearchParams.get("step")}&stage=2`);
		} catch (error) {
			console.error("handleActivateCoreButtonClick error:", error);
			alert(
				`Something went wrong while activating your enrollment: ${
					error instanceof Error ? error.message : String(error)
				}. Please try again, or contact your administrator if it keeps happening.`
			);
		}
	}, [
		member,
		paycheck,
		selectedPlan,
		openEnrollment,
		Plan,
		groupOwner,
		handleValidation,
		handleBeneficiaryValidate,
		submitGIUnderwriting,
		submitSIUnderwriting,
		submitRiderSIUnderwriting,
		employeeNeedsSI,
		spouseNeedsSI,
		childNeedsSI,
		riderEmployeeNeedsSI,
		riderSpouseNeedsSI,
		riderChildNeedsSI,
		beneficiaries,
		eligibleDependents,
		effectiveCoverage,
		effectiveRiderCoverage,
		planInputs,
		spousePlanInputs,
		childPlanInputs,
		riderPlanInputs,
		riderSpousePlanInputs,
		riderChildPlanInputs,
		selectedRiderChildren,
		currentPlans,
		dependencyPlanInputs,
		dependencyPremiums,
		standardPremium,
		spousePremium,
		childPremium,
		riderEmployeePremium,
		riderSpousePremium,
		riderChildPremium,
		isEmployeeTobacco,
		isSpouseTobacco,
		dependents,
		setDependents,
		setMember,
		getEnrollmentInitData,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		setSubmittedEnrollment,
		urlSearchParams,
		history
	]);
	const handleWaiveEnrollment = useCallback(async () => {
		// ── Core waive: the shared health-plan payload to `dynamic-add-enrollment`,
		// the same way DynamicEnrollmentPlanForm waives a core plan. The VEB path
		// below is unchanged. ──
		if (isCore) {
			if (!member || !openEnrollment) return;

			const { standardDetails, commonDetails } = generateHealthPlanWaiveEnrollmentPayload(
				member,
				openEnrollment,
				waiveReason
			);

			// Waiving out of an enrollment that is already active needs approval
			// rather than taking effect straight away.
			if (isActiveEnrollment) {
				commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			}

			const enrollmentPayload: AddEnrollmentPayload = {
				standard_details: standardDetails,
				common_details: {
					...commonDetails,
					agent_id: groupOwner && groupOwner._id ? groupOwner._id : null,
					total_premium: 0,
					premium_amount: 0
				}
			};

			const response: any = await trackPromise(api.enrollment.addDynamicEnrollments(enrollmentPayload));

			// PlanAcknowledgement renders from submittedEnrollment[planName] until the
			// refetched enrollment arrives — without this, stage 2 shows an empty page.
			if (selectedPlan) {
				setSubmittedEnrollment?.((prev: any) => ({ ...prev, [selectedPlan.plan_name]: response?.[0] }));
			}

			// `getEnrollmentInitData` returns early when passed false, so it must be
			// called with true.
			if (getEnrollmentInitData) {
				await getEnrollmentInitData(true);
			} else {
				await getVEBEnrollmentInitData();
			}
			// Optional call: CommonForm mounts on two routes, and EnrollmentContext is
			// only provided where the route is wrapped in EnrollmentContextProvider.
			deleteCurrentEnrollment?.();

			history.push(`?step=${urlSearchParams.get("step")}&stage=2`);
			return;
		}

		if (!member || !VEBOpenEnrollment) return;

		const currentPlan = currentPlans.find((p: any) => p.plan_name === planname && p.plan_code === planCode);
		if (!currentPlan) return;

		const planOpenEnrollment = VEBOpenEnrollment.find(
			(oe) => oe.open_enrollment.veb_plan_name === planname || oe.open_enrollment.veb_plan_code === planCode
		);
		const openid = planOpenEnrollment ? String(planOpenEnrollment.VEB_open_enrollment_id) : "";

		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateCancerKemperWaiveEnrollmentPayload(
			Plan,
			Plan.plan_name,
			Plan.plan_name,
			null,
			groupOwner,
			member,
			waiveReason,
			openid,
			false
		);

		const waivePayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};

		const result = await trackPromise(api.enrollment.addVEBEnrollment(waivePayload));
		if (result) {
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
		}
		history.push(`?step=${urlSearchParams.get("step")}&stage=2`);
	}, [
		member,
		VEBOpenEnrollment,
		Plan,
		groupOwner,
		waiveReason,
		currentPlans,
		planname,
		planCode,
		urlSearchParams,
		deleteCurrentEnrollment,
		getVEBEnrollmentInitData,
		history,
		// core branch
		isCore,
		openEnrollment,
		selectedPlan,
		isActiveEnrollment,
		getEnrollmentInitData,
		setSubmittedEnrollment
	]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps((prev) => ({
			...(prev ?? {
				openDialog: false,
				title: "",
				textfields: [],
				actions: []
			}),
			openDialog: true,
			title: "Are you sure want to waive this enrollment?",
			textfields: [
				{
					label: "Waive Reason",
					onChange: (e: React.ChangeEvent<HTMLInputElement>) => setWaiveReason(e.target.value),
					value: waiveReason,
					placeholder: "Enter your reason for waive"
				}
			],
			actions: [
				{
					label: "Cancel",
					callback: () =>
						setCustomFormDialogProps((p) => ({
							...(p ?? {
								openDialog: false,
								title: "",
								textfields: [],
								actions: []
							}),
							openDialog: false
						}))
				},
				{
					label: "Yes",
					callback: () => {
						setCustomFormDialogProps((p) => ({
							...(p ?? {
								openDialog: false,
								title: "",
								textfields: [],
								actions: []
							}),
							openDialog: false
						}));
						handleWaiveEnrollment();
					}
				}
			]
		}));
	}, [handleWaiveEnrollment, waiveReason]);

	const handleOpenDisclaimerDialogClick = useCallback(
		() =>
			setEnrollmentDisclaimerDialogProps((prev) => ({
				...prev,
				openDialog: true
			})),
		[]
	);
	const handleCloseDisclaimerDialog = useCallback(
		() =>
			setEnrollmentDisclaimerDialogProps((prev) => ({
				...prev,
				openDialog: false
			})),
		[]
	);
	const handleEscapeCloseDisclaimerDialog = useCallback((e: React.KeyboardEvent) => {
		if (e.key === "Escape")
			setEnrollmentDisclaimerDialogProps((prev) => ({
				...prev,
				openDialog: false
			}));
	}, []);

	const getRelationData = useCallback(() => {
		const firstNonEmpty = (...arrays: (any[] | undefined | null)[]): any[] => {
			for (const arr of arrays) {
				if (Array.isArray(arr) && arr.length > 0) return arr;
			}
			return [];
		};

		switch (currentRelation) {
			case "EMPLOYEE":
				return {
					questions: firstNonEmpty(
						Plan?.benefit_amount?.si_questions,
						Plan?.benefit_amount?.employee?.si_questions,
						Plan?.general_questions,
						Plan?.si_questions
					),
					selectedAmount: Number(planInputs.benefit_amount ?? 0),
					giLimit: GI_LIMITS.EMPLOYEE,
					siLimit: Plan?.benefit_amount?.simplified_issue_amount ?? 0
				};
			case "SPOUSE":
				return {
					questions: firstNonEmpty(Plan?.benefit_amount?.spouse?.si_questions, Plan?.si_questions),
					selectedAmount: Number(spousePlanInputs.benefit_amount ?? 0),
					giLimit: GI_LIMITS.SPOUSE,
					siLimit: Plan?.benefit_amount?.spouse?.simplified_issue_amount ?? 0
				};
			case "CHILD":
				return {
					questions: firstNonEmpty(Plan?.benefit_amount?.child?.si_questions, Plan?.si_questions),
					selectedAmount: Number(childPlanInputs.benefit_amount ?? 0),
					giLimit: GI_LIMITS.CHILD,
					siLimit: Plan?.benefit_amount?.child?.simplified_issue_amount ?? 0
				};
			default:
				return { questions: [], selectedAmount: 0, giLimit: 0, siLimit: 0 };
		}
	}, [currentRelation, Plan, planInputs, spousePlanInputs, childPlanInputs, GI_LIMITS]);
	useEffect(() => {
		if (!resolvedPlan) return;
		setCurrentPlan(resolvedPlan);
		setHasSelectedRider(resolvedPlan?.rider?.is_required ?? false);
	}, [resolvedPlan]);
	useEffect(() => {
		if (!Plan) return;
		const depTotal = Object.values(dependencyPremiums).reduce((sum, v) => sum + v, 0);
		setTotalPremium(
			standardPremium +
				spousePremium +
				childPremium +
				(planInputs?.rider_present ? riderEmployeePremium : 0) +
				(planInputs?.rider_present ? riderSpousePremium : 0) +
				(planInputs?.rider_present ? riderChildPremium : 0) +
				depTotal
		);
	}, [
		standardPremium,
		spousePremium,
		childPremium,
		riderEmployeePremium,
		riderSpousePremium,
		riderChildPremium,
		dependencyPremiums,
		planInputs?.rider_present
	]);

	useEffect(() => {
		if (
			eligiblityDialogProps.eligibleDependents.length > 0 ||
			eligiblityDialogProps.ineligibleRelationshipDependents.length > 0 ||
			dependents.length === 0
		) {
			setCoverageOption();
		}
	}, [Plan, eligibleDependents, setCoverageOption]);
	useEffect(() => {
		if (!Plan) return;
		setPlanInputs((prev: any) => ({
			...prev,
			rider_present: Plan?.rider?.is_required ?? false
		}));
	}, [Plan, selectedAction]);

	useEffect(() => {
		if (!dependents) return;
		const dependentCoverage = getCommonEligibleDependents(dependents, Plan);

		setEligibleDependents([...dependentCoverage.dependents]);
		setEligiblityDialogProps((prev: any) => ({
			...prev,
			openDialog: true,
			eligibleDependents: [...dependentCoverage.dependents],
			ineligibleRelationshipDependents: [...dependentCoverage.ineligibleRelationshipDependents],
			ineligibleDependents: [...dependentCoverage.ineligibleDependents]
		}));
		setEligiblity({
			eligibleDependents: [...dependentCoverage.dependents],
			ineligibleRelationshipDependents: [...dependentCoverage.ineligibleRelationshipDependents],
			ineligibleDependents: [...dependentCoverage.ineligibleDependents]
		});
	}, [dependents, Plan, setEligiblity]);
	useEffect(() => {
		if (!member) return;

		setBeneficiaries((prev) => {
			let next = { ...prev };

			if (effectiveCoverage) {
				const autoFill = buildAutoFillBeneficiaries(effectiveCoverage, member, spouse, children);

				if (prev.employeePrimary.length === 0) {
					next.employeePrimary = autoFill.employeePrimary ?? [];
					next.employeeContingent = autoFill.employeeContingent ?? [];
				}
				if (prev.spousePrimary.length === 0) {
					next.spousePrimary = autoFill.spousePrimary ?? [];
					next.spouseContingent = autoFill.spouseContingent ?? [];
				}
				if (prev.childPrimary.length === 0) {
					next.childPrimary = autoFill.childPrimary ?? [];
					next.childContingent = autoFill.childContingent ?? [];
				}
			}

			if (effectiveRiderCoverage) {
				const riderAutoFill = buildAutoFillBeneficiaries(effectiveRiderCoverage, member, spouse, children);

				const standardIncludesEmployee = [
					"Employee Only",
					"Employee & Spouse",
					"Employee & Children",
					"Employee & Family"
				].includes(effectiveCoverage ?? "");
				const standardIncludesSpouse = [
					"Employee & Spouse",
					"Spouse Only",
					"Spouse & Children",
					"Employee & Family"
				].includes(effectiveCoverage ?? "");
				const standardIncludesChildren = [
					"Employee & Children",
					"Spouse & Children",
					"Employee & Family",
					"Children Only"
				].includes(effectiveCoverage ?? "");

				const riderIncludesEmployee = [
					"Employee Only",
					"Employee & Spouse",
					"Employee & Children",
					"Employee & Family"
				].includes(effectiveRiderCoverage);
				const riderIncludesSpouse = [
					"Employee & Spouse",
					"Spouse Only",
					"Spouse & Children",
					"Employee & Family"
				].includes(effectiveRiderCoverage);
				const riderIncludesChildren = [
					"Employee & Children",
					"Spouse & Children",
					"Employee & Family",
					"Children Only"
				].includes(effectiveRiderCoverage);

				if (riderIncludesEmployee && !standardIncludesEmployee && next.employeePrimary.length === 0) {
					next.employeePrimary = riderAutoFill.employeePrimary ?? [];
					next.employeeContingent = riderAutoFill.employeeContingent ?? [];
				}
				if (riderIncludesSpouse && !standardIncludesSpouse && next.spousePrimary.length === 0) {
					next.spousePrimary = riderAutoFill.spousePrimary ?? [];
					next.spouseContingent = riderAutoFill.spouseContingent ?? [];
				}
				if (riderIncludesChildren && !standardIncludesChildren && next.childPrimary.length === 0) {
					next.childPrimary = riderAutoFill.childPrimary ?? [];
					next.childContingent = riderAutoFill.childContingent ?? [];
				}
			}

			return next;
		});
	}, [effectiveCoverage, effectiveRiderCoverage, member, spouse, children]);
	useEffect(() => {
		getMaxBenefitAmounts();
	}, [getMaxBenefitAmounts]);
	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);

	// useEffect(() => {
	// 	getExistingEnrollment();
	// }, [getExistingEnrollment]);
	useEffect(() => {
		const spouseFromDependents = dependents.find((d: Member) => d.relationship === "SPOUSE");
		if (spouseFromDependents) {
			setIsSpouseTobacco(spouseFromDependents.is_tobacco ?? false);
		}
	}, [dependents]);
	// Auto-set spouse coverage to "Spouse Only" when spouse section becomes visible
	useEffect(() => {
		if (
			eligibelDependentSpouse &&
			Plan?.can_each_relationship_enroll_indipendently_in_this_plan &&
			!spousePlanInputs.coverage
		) {
			// setShowSpouseSection(true);
			handleSpouseCoverageChange({ coverage: "Spouse Only" });
		}
	}, [Plan, eligibelDependentSpouse]);
	useEffect(() => {
		if (!Plan) return;
		if (Plan?.can_each_relationship_enroll_indipendently_in_this_plan && planInputs.coverage !== "Employee Only") {
			handleCoverageSelectChange({ coverage: "Employee Only" });
		}
	}, [Plan]);
	useEffect(() => {
		if (!Plan) return;
		if (
			Plan?.rider?.can_each_relationship_enroll_indipendently_in_this_plan &&
			riderPlanInputs.coverage !== "Employee Only"
		) {
			handleRiderCoverageChange({ coverage: "Employee Only" });
		}
	}, [Plan]);
	useEffect(() => {
		if (
			Plan?.coverage_for?.options?.includes("Children Only") &&
			children.length > 0 &&
			planInputs.coverage &&
			!childPlanInputs.coverage
		) {
			handleChildCoverageChange({ coverage: "Children Only" });
		}
	}, [Plan, planInputs.coverage, children]);
	useEffect(() => {
		if (
			eligibelDependentChild &&
			eligibelDependentChild.length > 0 &&
			Plan?.rider?.coverage_for?.options?.includes("Children Only") &&
			!riderChildPlanInputs.coverage
		) {
			handleRiderChildCoverageChange({ coverage: "Children Only" });
		}
	}, [Plan, eligibelDependentChild]);
	useEffect(() => {
		if (
			eligibelDependentSpouse &&
			Plan?.rider?.coverage_for?.options?.includes("Spouse Only") &&
			!riderSpousePlanInputs.coverage
		) {
			handleRiderSpouseCoverageChange({ coverage: "Spouse Only" });
		}
	}, [Plan, eligibelDependentSpouse]);
	useEffect(() => {
		const riderOpts = Plan?.rider?.coverage_for?.options;
		if (!Array.isArray(riderOpts)) {
			setRiderCoverageOptions([]);
			return;
		}
		const options: string[] = [];
		if (riderOpts.includes("Employee Only")) options.push("Employee Only");
		if (eligibleDependents.length > 0) {
			const hasChild = eligibleDependents.some((e) =>
				["CHILD", "STEP CHILD", "CORT-ORDER CHILD"].includes(e.relationship)
			);
			const hasSpouse = eligibleDependents.some((e) => e.relationship === "SPOUSE");
			if (hasSpouse && riderOpts.includes("Employee & Spouse")) options.push("Employee & Spouse");
			if (hasChild && riderOpts.includes("Employee & Children")) options.push("Employee & Children");
			if (hasChild && hasSpouse && riderOpts.includes("Employee & Family")) options.push("Employee & Family");
		}
		setRiderCoverageOptions(options);
		setRiderCoverageVolumeOptions(Plan?.rider?.coverage_volume?.options ?? []);
	}, [Plan, eligibleDependents]);

	// Add this useEffect wherever your other effects are
	// ── Add this ref near your other refs ──
	const dependencyPlanInputsRef = useRef<Record<string, any>>({});

	// ── Keep it in sync ──

	useEffect(() => {
		if (!planInputs?.coverage || !Plan?.standard_plan_dependency?.length) return;

		(Plan.standard_plan_dependency ?? []).filter(Boolean).forEach((dep: StandardPlanDependency) => {
			const isSameCoverage = dep.same_coverage === true || dep.same_coverage === "true";

			if (!isSameCoverage) return;

			const depPlan = currentPlans.find((p: any) => p.plan_name === dep.plan);
			if (!depPlan) return;

			handleDependencyPlanChange(dep.plan, depPlan, { coverage: planInputs.coverage });
		});
	}, [planInputs?.coverage, Plan, currentPlans, handleDependencyPlanChange]);


	/* ========================= PREVIOUS-ENROLLMENT AUTOFILL =========================
	 * If the household has an ACTIVE enrollment for THIS plan_code in previousEnrollments (any open
	 * enrollment window), restore what they enrolled with: "Coverage for", coverage volume and benefit
	 * amount, the rider (checkbox, benefit amounts, which children), the beneficiaries, and price them.
	 * ============================================================================== */
	useEffect(() => {
		if (!previousEnrollments?.length) return;
		if (!Plan || Plan.plan_code !== planCode) return;
		if (!member || !paycheck) return;
		if (autoFilledPlanCodeRef.current === planCode) return;


		const employeeBenefitListExpected =
			(Plan?.benefit_amount?.options?.length ?? 0) > 0 &&
			!!(Plan?.benefit_amount?.is_present || Plan?.rider?.benefit_amount?.is_present);
		if (employeeBenefitListExpected && maxBenefitAmounts.length === 0) return;

		autoFilledPlanCodeRef.current = planCode;

		const planRows: any[] = previousEnrollments.filter(
			(row: any) =>
				row.plan_code === planCode &&
				row.enrollment_status === "ACTIVE" &&
				!row.termination_date &&
				(row.is_latest ?? true)
		);

		const standardRows = planRows.filter((row: any) => row.plan_name === row.base_plan_name);

		const riderName: string = Plan?.is_this_plan_has_riders ? Plan?.rider?.name ?? "" : "";
		const riderPlanRows = riderName
			? planRows.filter(
				(row: any) =>
					row.plan_name !== row.base_plan_name &&
					(row.plan_name === riderName || row.base_plan_name === riderName)
			)
			: [];
		if (standardRows.length === 0 && riderPlanRows.length === 0) return;

		const latestRow = (rows: any[]) =>
			rows.reduce((latest: any, row: any) => (!latest || String(row._id) > String(latest._id) ? row : latest), null);

		const anchorRow =
			latestRow(standardRows.filter((row: any) => row.member_SSN === member.SSN)) ??
			latestRow(standardRows) ??
			latestRow(riderPlanRows);

		const inAnchorEnrollment = (row: any) =>
			String(row.open_enrollment_id ?? "") === String(anchorRow.open_enrollment_id ?? "");
		const enrollmentRows = standardRows.filter(inAnchorEnrollment);


		const riderRows = riderPlanRows.filter(inAnchorEnrollment);

		const empRow = latestRow(enrollmentRows.filter((row: any) => row.member_SSN === member.SSN));
		const spouseRow = spouse ? latestRow(enrollmentRows.filter((row: any) => row.member_SSN === spouse.SSN)) : null;


		const eligibleNow: Member[] = getCommonEligibleDependents(dependents, Plan)?.dependents ?? [];

		const isChildRelationship = (d: Member) =>
			d.relationship === "CHILD" || d.relationship === "STEP CHILD" || d.relationship === "CORT-ORDER CHILD";
		const spouseEligible = !!spouse && eligibleNow.some((d) => d.relationship === "SPOUSE" && d.SSN === spouse.SSN);
		const eligibleChildSSNs = new Set(eligibleNow.filter(isChildRelationship).map((d) => d.SSN));


		const childRow = enrollmentRows.find((row: any) => eligibleChildSSNs.has(row.member_SSN)) ?? null;


		const pick = (options: any[] | undefined, stored: any) => {
			if (stored === null || stored === undefined || stored === "" || stored === 0 || stored === "0") {
				return undefined;
			}
			return (options ?? []).find((opt: any) => String(opt) === String(stored));
		};

		const canEnrollIndependently = !!Plan?.can_each_relationship_enroll_indipendently_in_this_plan;
		const coverageForOptions: string[] = Plan?.coverage_for?.options ?? [];
		const volumeOptions: any[] = Plan?.coverage_volume?.options ?? [];


		const isEmployeePlaceholderRow =
			!!empRow &&
			Plan?.employee_required === false &&
			canEnrollIndependently &&
			Number(empRow.premium_amount ?? 0) === 0 &&
			Number(empRow.total_premium ?? 0) > 0 &&
			!Number(empRow.benefit_amount ?? 0);
		const realEmpRow = isEmployeePlaceholderRow ? null : empRow;


		const empVolume = realEmpRow && volumeOptions.length > 0 ? pick(volumeOptions, realEmpRow.sub_plan) : undefined;
		const empBenefit =
			realEmpRow && (Plan?.benefit_amount?.options?.length ?? 0) > 0
				? pick(maxBenefitAmounts, realEmpRow.benefit_amount)
				: undefined;

		let tierCoverage: string | undefined;
		if (!canEnrollIndependently && realEmpRow) {
			const withSpouse = !!spouseRow && spouseEligible;
			const withChildren = !!childRow;
			const label = withSpouse && withChildren
				? "Employee & Family"
				: withSpouse
					? "Employee & Spouse"
					: withChildren
						? "Employee & Children"
						: "Employee Only";
			if (coverageForOptions.includes(label)) tierCoverage = label;
		}


		const employeeAmountAfter = Number(empBenefit ?? planInputs?.benefit_amount ?? 0);
		const employeeHasSelection = !!(empVolume ?? planInputs?.coverage_volume) || employeeAmountAfter > 0;
		const employeeRequired = Plan?.employee_required === true;


		let spouseVolume: any;
		let spouseBenefit: any;
		const spouseSectionShown =
			canEnrollIndependently &&
			spouseEligible &&
			coverageForOptions.some((opt: string) =>
				["Employee & Spouse", "Employee & Family", "Spouse Only", "Spouse & Children"].includes(opt)
			);

		if (spouseRow && spouseSectionShown && (!employeeRequired || employeeHasSelection)) {
			spouseVolume = volumeOptions.length > 0 ? pick(volumeOptions, spouseRow.sub_plan) : undefined;
			const spouseConfig = Plan?.benefit_amount?.spouse;
			const spouseOptions: any[] = spouseConfig?.options ?? [];

			const spouseCanExceed = spouseConfig?.can_spouse_benefit_exceed_employee;
			const spouseAllowed =
				spouseCanExceed === undefined || spouseCanExceed === true || spouseConfig?.spouse_can_enroll_individually
					? spouseOptions
					: employeeAmountAfter
						? spouseOptions.filter((opt: any) => opt <= employeeAmountAfter)
						: [];
			spouseBenefit = spouseOptions.length > 0 ? pick(spouseAllowed, spouseRow.benefit_amount) : undefined;
		}
		const restoreSpouse = spouseVolume !== undefined || spouseBenefit !== undefined;


		let childVolume: any;
		let childBenefit: any;
		const childSectionShown =
			canEnrollIndependently &&
			eligibleChildSSNs.size > 0 &&
			(coverageForOptions.includes("Children Only") || coverageForOptions.includes("Spouse & Children"));

		const spouseHasSelection =
			!!(spouseVolume ?? spousePlanInputs?.coverage_volume) || !!(spouseBenefit ?? spousePlanInputs?.benefit_amount);
		if (childRow && childSectionShown && (!employeeRequired || employeeHasSelection || spouseHasSelection)) {
			childVolume = volumeOptions.length > 0 ? pick(volumeOptions, childRow.sub_plan) : undefined;
			const childConfig = Plan?.benefit_amount?.child;
			const childOptions: any[] = childConfig?.options ?? [];


			const childCanExceed = childConfig?.can_child_benefit_exceed_employee;
			const childCap = employeeAmountAfter || Number(spouseBenefit ?? spousePlanInputs?.benefit_amount ?? 0);
			const childAllowed =
				childCanExceed === undefined || childCanExceed === true
					? childOptions
					: childCap
						? childOptions.filter((opt: any) => opt <= childCap)
						: [];
			childBenefit = childOptions.length > 0 ? pick(childAllowed, childRow.benefit_amount) : undefined;
		}
		const restoreChild = childVolume !== undefined || childBenefit !== undefined;


		const riderOptions: string[] = Plan?.rider?.coverage_for?.options ?? [];
		const riderOffers = (labels: string[]) => riderOptions.some((opt: string) => labels.includes(opt));
		const riderEmployeeOptions = riderOptions.filter((opt: string) =>
			["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"].includes(opt)
		);
		const riderIndependent = !!Plan?.rider?.can_each_relationship_enroll_indipendently_in_this_plan;

		const riderEmpRow = latestRow(riderRows.filter((row: any) => row.member_SSN === member.SSN));
		const riderSpouseRow = spouse ? latestRow(riderRows.filter((row: any) => row.member_SSN === spouse.SSN)) : null;

		const riderChildRows = riderRows.filter((row: any) => eligibleChildSSNs.has(row.member_SSN));


		let riderEmpCoverage: string | undefined;
		let riderEmpBenefit: any;
		if (riderEmpRow && riderEmployeeOptions.length > 0) {
			if (!riderIndependent && riderEmployeeOptions.length === 1) riderEmpCoverage = riderEmployeeOptions[0];
			riderEmpBenefit = pick(Plan?.rider?.benefit_amount?.options, riderEmpRow.benefit_amount);
		}
		const restoreRiderEmployee = riderEmpCoverage !== undefined || riderEmpBenefit !== undefined;


		const riderSpouseBenefit =
			riderSpouseRow &&
				spouseEligible &&
				riderOffers(["Employee & Spouse", "Employee & Family", "Spouse Only", "Spouse & Children"])
				? pick(Plan?.rider?.benefit_amount?.spouse?.options, riderSpouseRow.benefit_amount)
				: undefined;
		const restoreRiderSpouse = riderSpouseBenefit !== undefined;


		const riderChildBenefit =
			riderChildRows.length > 0 &&
				riderOffers(["Employee & Children", "Employee & Family", "Spouse & Children", "Children Only"])
				? pick(Plan?.rider?.benefit_amount?.child?.options, riderChildRows[0].benefit_amount)
				: undefined;
		const restoreRiderChild = riderChildBenefit !== undefined;
		// Child cards to tick: the eligible children who were on the rider, by the id the cards and Activate use.
		const riderChildIds: string[] = restoreRiderChild
			? eligibleNow
				.filter((d: Member) => isChildRelationship(d) && riderChildRows.some((row: any) => row.member_SSN === d.SSN))
				.map((d: any) => d._id || d.id)
				.filter(Boolean)
			: [];

		const restoreRider = restoreRiderEmployee || restoreRiderSpouse || restoreRiderChild;



		const savedBeneficiaries = (...rows: any[]) => {
			const row = rows.find((r: any) => (r?.VEB_primary_beneficiary?.length ?? 0) > 0);
			return row
				? {
					primary: row.VEB_primary_beneficiary as BV2Beneficiery[],
					contingent: (row.VEB_contingent_beneficiary ?? []) as BV2Beneficiery[]
				}
				: null;
		};
		const restoredBeneficiaries: Partial<BeneficiaryState> = {};

		const employeeBeneficiaries = savedBeneficiaries(realEmpRow, riderEmpRow);
		if (employeeBeneficiaries) {
			restoredBeneficiaries.employeePrimary = employeeBeneficiaries.primary;
			restoredBeneficiaries.employeeContingent = employeeBeneficiaries.contingent;
		}

		const spouseBeneficiaries = spouseEligible ? savedBeneficiaries(spouseRow, riderSpouseRow) : null;
		if (spouseBeneficiaries) {
			restoredBeneficiaries.spousePrimary = spouseBeneficiaries.primary;
			restoredBeneficiaries.spouseContingent = spouseBeneficiaries.contingent;
		}
		const childBeneficiaries = savedBeneficiaries(childRow, riderChildRows[0]);
		if (childBeneficiaries) {
			restoredBeneficiaries.childPrimary = childBeneficiaries.primary;
			restoredBeneficiaries.childContingent = childBeneficiaries.contingent;
		}
		const restoreBeneficiaries = Object.keys(restoredBeneficiaries).length > 0;


		const employeeInputs: Record<string, any> = {};
		if (tierCoverage) employeeInputs.coverage = tierCoverage;
		if (empVolume !== undefined) employeeInputs.coverage_volume = empVolume;
		if (empBenefit !== undefined) employeeInputs.benefit_amount = empBenefit;
		const restoreEmployee = Object.keys(employeeInputs).length > 0;
		if (restoreEmployee) {
			setPlanInputs((prev: any) => ({ ...prev, ...employeeInputs }));
		}
		if (restoreSpouse) {
			setSpousePlanInputs((prev: any) => ({
				...prev,
				coverage: prev.coverage || "Spouse Only",
				...(spouseVolume !== undefined ? { coverage_volume: spouseVolume } : {}),
				...(spouseBenefit !== undefined ? { benefit_amount: spouseBenefit } : {})
			}));
		}
		if (restoreChild) {
			setChildPlanInputs((prev: any) => ({
				...prev,
				coverage: prev.coverage || "Children Only",
				...(childVolume !== undefined ? { coverage_volume: childVolume } : {}),
				...(childBenefit !== undefined ? { benefit_amount: childBenefit } : {})
			}));
		}

		if (restoreRider) {

			setPlanInputs((prev: any) => ({ ...prev, rider_present: true }));
		}
		if (restoreRiderEmployee) {
			setRiderPlanInputs((prev: any) => ({
				...prev,
				...(riderEmpCoverage !== undefined ? { coverage: riderEmpCoverage } : {}),
				...(riderEmpBenefit !== undefined ? { benefit_amount: riderEmpBenefit } : {})
			}));
		}
		if (restoreRiderSpouse) {
			setRiderSpousePlanInputs((prev: any) => ({
				...prev,
				coverage: prev.coverage || "Spouse Only",
				benefit_amount: riderSpouseBenefit
			}));
		}
		if (restoreRiderChild) {
			setRiderChildPlanInputs((prev: any) => ({
				...prev,
				coverage: prev.coverage || "Children Only",
				benefit_amount: riderChildBenefit
			}));
			if (riderChildIds.length > 0) setSelectedRiderChildren(riderChildIds);
		}

		if (restoreBeneficiaries) {
			setBeneficiaries((prev) => ({ ...prev, ...restoredBeneficiaries }));
		}

		// premium re calculate
		const payFrequency = paycheck?.pay_frequency;
		const employeeCoverage = canEnrollIndependently ? "Employee Only" : tierCoverage ?? planInputs?.coverage;
		const riderEmployeeCoverage = riderIndependent ? "Employee Only" : riderEmpCoverage ?? riderPlanInputs?.coverage;
		// handleRiderChildCoverageChange prices with the first eligible child.
		const riderChildPerson = eligibleNow.find(isChildRelationship) ?? children[0];

		(async () => {
			// = handleCoverageSelectChange (standard premium)
			if (restoreEmployee && employeeCoverage) {
				try {
					const amount = await dynamicPremiumCalculation(
						Plan,
						employeeCoverage,
						empVolume ?? planInputs?.coverage_volume,
						empBenefit ?? planInputs?.benefit_amount,
						member,
						payFrequency,
						isEmployeeTobacco,
						true
					);
					setStandardPremium(Number(amount));
				} catch {
					setStandardPremium(0);
				}
			}

			// = handleSpouseCoverageChange
			if (restoreSpouse && spouse) {
				try {
					const premium = await dynamicPremiumCalculation(
						Plan,
						spousePlanInputs?.coverage || "Spouse Only",
						spouseVolume ?? spousePlanInputs?.coverage_volume,
						spouseBenefit ?? spousePlanInputs?.benefit_amount,
						spouse,
						payFrequency,
						isSpouseTobacco,
						true
					);
					setSpousePremium(Number(premium));
				} catch {
					setSpousePremium(0);
				}
			}

			// = handleChildCoverageChange (prices with children[0], never as a smoker)
			if (restoreChild && children[0]) {
				try {
					const premium = await dynamicPremiumCalculation(
						Plan,
						childPlanInputs?.coverage || "Children Only",
						childVolume ?? childPlanInputs?.coverage_volume,
						childBenefit ?? childPlanInputs?.benefit_amount,
						children[0],
						payFrequency,
						false,
						true
					);
					setChildPremium(Number(premium));
				} catch {
					setChildPremium(0);
				}
			}


			// = handleRiderCoverageChange
			if (restoreRiderEmployee && riderEmployeeCoverage) {
				try {
					const amount = await dynamicPremiumCalculation(
						Plan,
						riderEmployeeCoverage,
						riderPlanInputs?.coverage_volume,
						riderEmpBenefit ?? riderPlanInputs?.benefit_amount,
						member,
						payFrequency,
						isEmployeeTobacco,
						false
					);
					setRiderEmployeePremium(Number(amount));
				} catch {
					setRiderEmployeePremium(0);
				}
			}

			// = handleRiderSpouseCoverageChange
			if (restoreRiderSpouse && spouse) {
				try {
					const premium = await dynamicPremiumCalculation(
						Plan,
						riderSpousePlanInputs?.coverage || "Spouse Only",
						riderSpousePlanInputs?.coverage_volume,
						riderSpouseBenefit,
						spouse,
						payFrequency,
						isSpouseTobacco,
						false
					);
					setRiderSpousePremium(Number(premium));
				} catch {
					setRiderSpousePremium(0);
				}
			}

			// = handleRiderChildCoverageChange (never as a smoker)
			if (restoreRiderChild && riderChildPerson) {
				try {
					const premium = await dynamicPremiumCalculation(
						Plan,
						riderChildPlanInputs?.coverage || "Children Only",
						riderChildPlanInputs?.coverage_volume,
						riderChildBenefit,
						riderChildPerson,
						payFrequency,
						false,
						false
					);
					setRiderChildPremium(Number(premium));
				} catch {
					setRiderChildPremium(0);
				}
			}
		})();
	}, [previousEnrollments, Plan, planCode, member, paycheck, maxBenefitAmounts, dependents, spouse]);


	// ↑ Remove dependencyPlanInputs — only re-run when coverage actually changes
	// useEffect(() => {
	// 	giDataStoreRef.current = giDataStore;
	// }, [giDataStore]);

	// useEffect(() => {
	// 	giSubmittedStatusRef.current = giSubmittedStatus;
	// }, [giSubmittedStatus]);
	// useEffect(() => {
	// 	siDataStoreRef.current = siDataStore;
	// }, [siDataStore]);
	// useEffect(() => {
	// 	riderSiDataStoreRef.current = riderSiDataStore;
	// }, [riderSiDataStore]);

	// useEffect(() => {
	// 	siSubmittedStatusRef.current = siSubmittedStatus;
	// }, [siSubmittedStatus]);
	// useEffect(() => {
	// 	riderSiSubmittedStatusRef.current = riderSiSubmittedStatus;
	// }, [riderSiSubmittedStatus]);

	return (
		<>
			<Suspense fallback={<div />}>
				<Suspense fallback={<div />}>
					<CustomEnrollmentDisclaimerDialog
						enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
						handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
						handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
						emailDisclaimer={emailDisclaimer}
						setEmailDisclaimer={setEmailDisclaimer}
						plan_code={Plan?.plan_code}
					/>
				</Suspense>
				{customFormDialogProps && <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />}
				<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			</Suspense>
			<Suspense fallback={<div />}>
				<EnrollmentDependencyDialog dialogProps={enrollmentDependencyDialogProps} />
			</Suspense>
			{(() => {
				const { questions, selectedAmount, giLimit, siLimit } = getRelationData();
				return (
					<SIQuestionsModal
						open={siModalOpen}
						questions={questions}
						relation={currentRelation || "EMPLOYEE"}
						selectedAmount={selectedAmount}
						siLimit={siLimit}
						giLimit={giLimit}
						onSubmit={(answers, hasAnyYes, eligible) => {
							const spouseDep = eligibleDependents.find((d) => d.relationship === "SPOUSE");
							const firstChild =
								eligibleDependents.find((d) =>
									["CHILD", "STEP CHILD", "CORT-ORDER CHILD"].includes(d.relationship)
								) ?? children[0];

							const memberForRole =
								currentRelation === "EMPLOYEE"
									? member
									: currentRelation === "SPOUSE"
									? spouseDep
									: firstChild;

							const faceAmount =
								currentRelation === "EMPLOYEE"
									? Number(planInputs.benefit_amount ?? 0)
									: currentRelation === "SPOUSE"
									? Number(spousePlanInputs.benefit_amount ?? 0)
									: Number(childPlanInputs.benefit_amount ?? 0);

							const giLimit = GI_LIMITS[currentRelation ?? "EMPLOYEE"];

							const newEntry: ApplicantStore = {
								role: currentRelation?.toLowerCase() as "employee" | "spouse" | "child",
								answers,
								eligible,
								reducedToGI: false,
								member_object_id: memberForRole?._id ?? "",
								member_SSN: memberForRole?.SSN ?? "",
								child_name:
									currentRelation === "CHILD"
										? `${firstChild?.first_name ?? ""} ${firstChild?.last_name ?? ""}`.trim()
										: undefined,
								face_amount: faceAmount,
								gi_limit: giLimit,
								exceeds_gi: faceAmount > giLimit
							};

							//  Update ref synchronously
							siDataStoreRef.current = [
								...siDataStoreRef.current.filter((s) => s.role !== currentRelation?.toLowerCase()),
								newEntry
							];

							// Sync state for UI only
							setSiDataStore([...siDataStoreRef.current]);

							//  Update submitted status synchronously
							siSubmittedStatusRef.current = {
								...siSubmittedStatusRef.current,
								[currentRelation ?? "EMPLOYEE"]: true
							};
							setSiSubmittedStatus({ ...siSubmittedStatusRef.current });

							// Advance queue
							const remainingQueue = siQueue.slice(1);
							setSiQueue(remainingQueue);

							if (remainingQueue.length > 0) {
								setCurrentRelation(remainingQueue[0]);
								setSiModalOpen(true);
							} else {
								setSiModalOpen(false);
							}
						}}
						onClose={() => setSiModalOpen(false)}
						onReduceToGI={() => {
							setSiModalOpen(false);
							const giLimit = GI_LIMITS[currentRelation ?? "EMPLOYEE"];
							if (currentRelation === "EMPLOYEE") {
								const options: number[] = Plan?.benefit_amount?.options ?? [];
								const highest = options
									.filter((v) => v <= giLimit)
									.reduce((max, v) => Math.max(max, v), 0);
								handleCoverageSelectChange({ benefit_amount: highest > 0 ? String(highest) : "" });
							} else if (currentRelation === "SPOUSE") {
								const options: number[] = Plan?.benefit_amount?.spouse?.options ?? [];
								const highest = options
									.filter((v) => v <= giLimit)
									.reduce((max, v) => Math.max(max, v), 0);
								handleSpouseCoverageChange({ benefit_amount: highest > 0 ? String(highest) : "" });
							} else if (currentRelation === "CHILD") {
								const options: number[] = Plan?.benefit_amount?.child?.options ?? [];
								const highest = options
									.filter((v) => v <= giLimit)
									.reduce((max, v) => Math.max(max, v), 0);
								handleChildCoverageChange({ benefit_amount: highest > 0 ? String(highest) : "" });
							}
						}}
					/>
				);
			})()}
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => {
						setIsDependentExistsModelOpen(false);
						isDependentExistsModelOpenRef.current = false;
					}}
					dependentData={existsDependentData}
					newCoverageLabel={existsEnrollmentMeta?.newCoverageLabel ?? null}
					newTotalPremium={existsEnrollmentMeta?.newTotalPremium ?? null}
					payFrequency={paycheck?.pay_frequency ?? ""}
				/>
			)}
			<div className="kemper-cancer-form plan-form">
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						{/* ── Plan Header ── */}
						<div style={{ paddingBottom: "10px" }}>
							<VEBPlanHeader
								planName={selectedAction ? Plan?.plan_name ?? "" : planname}
								effectiveDate={
									VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY || "N/A"
								}
								planCode={Plan?.plan_code ?? "NA"}
							/>
						</div>

						<div
							style={{
								border: "1px solid #e5e7eb",
								borderRadius: "12px",
								marginBottom: "16px",
								backgroundColor: "#fff",
								overflow: "hidden"
							}}
						>
							<div
								className="plan-content"
								style={{
									position: "relative",
									marginTop: "-10px",
									paddingBottom: employeeNeedsSI ? "26px" : undefined
								}}
							>
								<div className="theme-plan-section-margin" />
								<div className="header-container">
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "10px",
											marginBottom: "4px",
											marginTop: "-6px"
										}}
									>
										<div>
											{Plan?.employee_required &&
											!Plan?.can_each_relationship_enroll_indipendently_in_this_plan ? (
												<>
													<div className="theme-plan-header" style={{ marginBottom: 2 }}>
														Standered Benefits
													</div>
													<div
														className="theme-plan-sub-header plan-text"
														style={{ borderLeftColor: theme.primary_color }}
													>
														In addition to yourself, who would you like to cover under this
														plan?
													</div>
												</>
											) : (
												<>
													<div className="theme-plan-header" style={{ marginBottom: 2 }}>
														{`Employee Benefits (${member?.first_name} ${member?.last_name})`}
													</div>
													<div style={{ fontSize: 12, color: "#6b7280", fontWeight: 400 }}>
														Select your personal coverage details
													</div>
												</>
											)}
											{/* {
												<div className="theme-plan-header" style={{ marginBottom: 2 }}>
													{`Employee Benefits (${member?.first_name} ${member?.last_name})`}
												</div>
											} */}
										</div>
									</div>

									{/* <div
										className="member-name"
										style={{
											marginBottom: "12px",
											fontWeight: 700,
											fontSize: "14px",
											color: "#555"
										}}
									>
										{member?.first_name} {member?.last_name} (SELF)
									</div> */}

									{Plan?.is_premium_depends_on_smoke === true && (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "flex-end",
												gap: "10px",
												marginBottom: "8px",
												marginTop: "4px"
											}}
										>
											<span className="is-smoker-label" style={{ float: "none" }}>
												Used nicotine or tobacco products in the last 12 months?
											</span>
											<label className="switch" style={{ marginLeft: 0 }}>
												<input
													type="checkbox"
													name="member-tobacco"
													checked={isEmployeeTobacco}
													onChange={handleEmployeeTobaccoToggle}
												/>
												<span className="slider round"></span>
											</label>
										</div>
									)}
								</div>

								<div style={{ paddingLeft: "8px" }}>
									<Grid
										container
										columnSpacing={2}
										rowSpacing={2}
										className="grid-container"
										sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start" }}
									>
										{!currentPlans?.length ? (
											<div>Loading...</div>
										) : (
											<>
												{Plan?.coverage_for?.options?.length > 0 && (
													<Grid
														item
														xl={5}
														lg={5}
														md={5}
														sm={5}
														xs={12}
														sx={{ flex: "1 1 45%" }}
													>
														<div className="details-form-row">
															<div className="details-form-label required">
																Coverage for
															</div>
															{Plan?.can_each_relationship_enroll_indipendently_in_this_plan ? (
																<Select
																	fullWidth
																	input={<CustomSelectInput />}
																	value="Employee Only"
																	disabled
																	sx={{
																		"& .MuiSelect-select.Mui-disabled": {
																			"-webkit-text-fill-color": "inherit",
																			opacity: 1,
																			cursor: "default"
																		},
																		"& .Mui-disabled": { opacity: 1 }
																	}}
																>
																	<MenuItem value="Employee Only">Employee</MenuItem>
																</Select>
															) : (
																<Select
																	fullWidth
																	input={<CustomSelectInput />}
																	value={planInputs.coverage || ""}
																	onChange={(e: any) =>
																		handleCoverageSelectChange({
																			coverage:
																				dependents.length === 0
																					? "Employee Only"
																					: e.target.value
																		})
																	}
																>
																	{coverageOptioin.map((opt, idx) => (
																		<MenuItem key={idx} value={opt}>
																			{opt}
																		</MenuItem>
																	))}
																</Select>
															)}
														</div>
													</Grid>
												)}

												{Plan?.coverage_volume?.options?.length > 0 && (
													<Grid
														item
														xl={5}
														lg={5}
														md={5}
														sm={5}
														xs={12}
														sx={{ flex: "1 1 45%" }}
													>
														<div className="details-form-row">
															<div className="details-form-label required">
																Coverage Volume
															</div>
															<Select
																fullWidth
																input={<CustomSelectInput />}
																value={planInputs.coverage_volume || ""}
																onChange={(e: any) =>
																	handleCoverageSelectChange({
																		coverage_volume: e.target.value
																	})
																}
															>
																{coverageVolume.map((opt, idx) => (
																	<MenuItem key={idx} value={opt}>
																		{opt}
																	</MenuItem>
																))}
															</Select>
														</div>
													</Grid>
												)}

												{/* {Plan?.benefit_amount?.options?.length > 0 && (
													<Grid
														item
														xl={5}
														lg={5}
														md={5}
														sm={5}
														xs={12}
														sx={{ flex: "1 1 45%" }}
													>
														<div className="details-form-row">
															<div className="details-form-label required">
																Benefit amount
															</div>
															<Select
																fullWidth
																input={<CustomSelectInput />}
																value={planInputs.benefit_amount || ""}
																onChange={(e: any) =>
																	handleCoverageSelectChange({
																		benefit_amount: e.target.value
																	})
																}
															>
																{(planname === "Short Term Disability"
																	? maxBenefitAmounts
																	: Plan?.benefit_amount?.options ?? []
																).map((opt: any, idx: number) => (
																	<MenuItem key={idx} value={opt}>
																		{opt}
																	</MenuItem>
																))}
															</Select>
														</div>
													</Grid>
												)} */}
												{Plan?.benefit_amount?.options?.length > 0 && (
													<Grid
														item
														xl={5}
														lg={5}
														md={5}
														sm={5}
														xs={12}
														sx={{ flex: "1 1 45%" }}
													>
														<div className="details-form-row">
															<div className="details-form-label required">
																Benefit amount
															</div>
															<Select
																fullWidth
																input={<CustomSelectInput />}
																value={planInputs.benefit_amount || ""}
																onChange={(e: any) =>
																	handleCoverageSelectChange({
																		benefit_amount: e.target.value
																	})
																}
															>
																{maxBenefitAmounts.map((opt: any, idx: number) => (
																	<MenuItem key={idx} value={opt}>
																		{opt}
																	</MenuItem>
																))}
															</Select>
														</div>
													</Grid>
												)}
												<Grid
													item
													xl={2}
													lg={2}
													md={2}
													sm={2}
													xs={12}
													sx={{
														position: "absolute",
														top: 0,
														right: 0,
														display: "flex",
														justifyContent: "flex-end",
														alignItems: "flex-start",
														padding: "8px 8px",
														pointerEvents: "none"
													}}
												>
													<div className="details-form-row" style={{ textAlign: "right" }}>
														<div className="details-form-label required align-center">
															Premium
														</div>
														<div className="show-premium">
															${standardPremium.toFixed(2)}
														</div>
													</div>
												</Grid>
											</>
										)}
									</Grid>
								</div>

								{employeeNeedsSI && (
									<SIStatusBadge
										submitted={siSubmittedStatus.EMPLOYEE}
										eligible={siDataStore.find((s) => s.role === "employee")?.eligible}
										onEdit={() => {
											setCurrentRelation("EMPLOYEE");
											setSiModalOpen(true);
										}}
										label="Employee SI"
										bottomOffset={4}
									/>
								)}
							</div>
						</div>
						{eligibelDependentSpouse &&
							Plan?.can_each_relationship_enroll_indipendently_in_this_plan &&
							Plan?.coverage_for?.options?.some((opt: string) =>
								["Employee & Spouse", "Employee & Family", "Spouse Only", "Spouse & Children"].includes(
									opt
								)
							) && (
								<>
									{Plan?.employee_required === true &&
										!planInputs?.benefit_amount &&
										!planInputs?.coverage_volume && (
											<div
												style={{
													display: "flex",
													alignItems: "end",
													gap: 6,
													marginBottom: 6,
													justifyContent: "flex-end",
													width: "fit-content"
												}}
											>
												<Tooltip
													title="Complete Employee coverage selections first to unlock spouse benefits."
													placement="top"
													arrow
												>
													<InfoOutlinedIcon
														style={{
															fontSize: 18,
															color: "#1a1510",
															cursor: "pointer"
														}}
													/>
												</Tooltip>
												<span style={{ fontSize: 12, color: "#6b7280" }}>Spouse benefits</span>
											</div>
										)}
									<div
										style={{
											border: "1px solid #e5e7eb",
											borderRadius: "12px",
											marginBottom: "16px",
											backgroundColor: "#fff",
											overflow: "hidden",
											position: "relative",
											opacity:
												Plan?.employee_required === true &&
												!planInputs?.benefit_amount &&
												!planInputs?.coverage_volume
													? 0.6
													: 1,
											pointerEvents:
												Plan?.employee_required === true &&
												!planInputs?.benefit_amount &&
												!planInputs?.coverage_volume
													? "none"
													: "auto"
										}}
									>
										<div className="plan-content" style={{ position: "relative" }}>
											<div className="theme-plan-section-margin" />
											<div className="header-container">
												{Plan?.benefit_amount.spouse.spouse_can_enroll_individually && (
													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "10px",
															marginBottom: "4px"
														}}
													>
														<div
															style={{
																display: "flex",
																alignItems: "center",
																gap: "8px",
																backgroundColor: "#ffffff",
																border: "1px solid #ffffff",
																borderRadius: "8px",
																padding: "6px 12px",
																width: "fit-content"
															}}
														>
															<div>
																<div
																	className="theme-plan-header"
																	style={{ marginBottom: 2 }}
																>
																	{`Spouse Benefits (${spouse?.first_name} ${spouse?.last_name})`}
																</div>
															</div>
														</div>

														<Tooltip
															title="Your spouse is eligible to enroll in this plan independently, without requiring employee coverage."
															placement="top"
															arrow
														>
															<InfoOutlinedIcon
																style={{
																	fontSize: 16,
																	color: "#6b7280",
																	cursor: "pointer"
																}}
															/>
														</Tooltip>
													</div>
												)}

												{!Plan?.benefit_amount.spouse.spouse_can_enroll_individually && (
													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "10px",
															marginBottom: "4px"
														}}
													>
														<div>
															<div
																className="theme-plan-header"
																style={{ marginBottom: 2 }}
															>
																{`Spouse Benefits (${spouse?.first_name} ${spouse?.last_name})`}
															</div>

															<div
																style={{
																	fontSize: 12,
																	color: "#6b7280",
																	fontWeight: 400
																}}
															>
																Select your spouse coverage details
															</div>
														</div>
													</div>
												)}

												{/* <div
											className="member-name"
											style={{
												marginBottom: "12px",
												fontWeight: 700,
												fontSize: "14px",
												color: "#555"
											}}
										>
											{spouse?.first_name} {spouse?.last_name} (SPOUSE)
										</div> */}

												{Plan?.is_premium_depnends_on_spouse_smoke === true && (
													<div
														style={{
															display: "flex",
															alignItems: "center",
															justifyContent: "flex-end",
															gap: "10px",
															marginBottom: "8px",
															marginTop: "4px"
														}}
													>
														<span className="is-smoker-label" style={{ float: "none" }}>
															Used nicotine or tobacco products in the last 12 months?
														</span>
														<label className="switch" style={{ marginLeft: 0 }}>
															<input
																type="checkbox"
																name="spouse-tobacco"
																checked={isSpouseTobacco}
																onChange={handleSpouseTobaccoToggle}
															/>
															<span className="slider round"></span>
														</label>
													</div>
												)}
											</div>

											<div style={{ paddingLeft: "8px" }}>
												<Grid
													container
													columnSpacing={2}
													rowSpacing={2}
													className="grid-container"
													sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start" }}
												>
													{!currentPlans?.length ? (
														<div>Loading...</div>
													) : (
														<>
															{Plan?.coverage_for?.options?.includes("Spouse Only") && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Coverage for
																		</div>
																		<Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value="Spouse Only"
																			disabled
																			sx={{
																				"& .MuiSelect-select.Mui-disabled": {
																					"-webkit-text-fill-color":
																						"inherit",
																					opacity: 1,
																					cursor: "default"
																				},
																				"& .Mui-disabled": { opacity: 1 }
																			}}
																		>
																			<MenuItem value="Spouse Only">
																				Spouse
																			</MenuItem>
																		</Select>
																	</div>
																</Grid>
															)}

															{Plan?.coverage_volume?.options?.length > 0 && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Coverage Volume
																		</div>
																		<Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value={
																				spousePlanInputs.coverage_volume || ""
																			}
																			onChange={(e: any) =>
																				handleSpouseCoverageChange({
																					coverage_volume: e.target.value
																				})
																			}
																		>
																			{coverageVolume.map((opt, idx) => (
																				<MenuItem key={idx} value={opt}>
																					{opt}
																				</MenuItem>
																			))}
																		</Select>
																	</div>
																</Grid>
															)}

															{Plan?.benefit_amount?.spouse?.options?.length > 0 && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Benefit amount
																		</div>
																		<Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value={
																				spousePlanInputs.benefit_amount || ""
																			}
																			onChange={(e: any) =>
																				handleSpouseCoverageChange({
																					benefit_amount: e.target.value
																				})
																			}
																		>
																			{spouseBenefitOptions.map(
																				(opt: any, idx: number) => (
																					<MenuItem key={idx} value={opt}>
																						{opt}
																					</MenuItem>
																				)
																			)}
																		</Select>
																	</div>
																</Grid>
															)}

															{spouseNeedsSI && (
																<SIStatusBadge
																	submitted={siSubmittedStatus.SPOUSE}
																	eligible={
																		siDataStore.find((s) => s.role === "spouse")
																			?.eligible
																	}
																	onEdit={() => {
																		setCurrentRelation("SPOUSE");
																		setSiModalOpen(true);
																	}}
																	label="Spouse SI"
																/>
															)}

															<Grid
																item
																xl={2}
																lg={2}
																md={2}
																sm={2}
																xs={12}
																sx={{
																	position: "absolute",
																	top: 0,
																	right: 0,
																	display: "flex",
																	justifyContent: "flex-end",
																	alignItems: "flex-start",
																	padding: "8px 8px",
																	pointerEvents: "none"
																}}
															>
																<div
																	className="details-form-row"
																	style={{ textAlign: "right" }}
																>
																	<div className="details-form-label required align-center">
																		Premium
																	</div>
																	<div className="show-premium">
																		${spousePremium.toFixed(2)}
																	</div>
																</div>
															</Grid>
														</>
													)}
												</Grid>
											</div>
										</div>
									</div>
								</>
							)}

						{(Plan?.coverage_for?.options.includes("Children Only") ||
							Plan?.coverage_for?.options?.includes("Spouse & Children")) &&
							eligibelDependentChild &&
							eligibelDependentChild.length > 0 &&
							Plan?.can_each_relationship_enroll_indipendently_in_this_plan && (
								<>
									{Plan?.employee_required === true &&
										!planInputs?.benefit_amount &&
										!planInputs?.coverage_volume && (
											<div
												style={{
													display: "flex",
													alignItems: "end",
													gap: 6,
													marginBottom: 6,
													justifyContent: "flex-end",
													width: "fit-content"
												}}
											>
												<Tooltip
													title="Complete Employee coverage selections first to unlock children benefits."
													placement="top"
													arrow
												>
													<InfoOutlinedIcon
														style={{
															fontSize: 18,
															color: "#1a1510",
															cursor: "pointer"
														}}
													/>
												</Tooltip>
												<span style={{ fontSize: 12, color: "#6b7280" }}>
													Children benefits
												</span>
											</div>
										)}
									<div
										style={{
											border: "1px solid #e5e7eb",
											borderRadius: "12px",
											marginBottom: "16px",
											backgroundColor: "#fff",
											overflow: "hidden",
											// Lock children until the employee OR the spouse has made a selection.
											// This unlocks the child for "Spouse & Children" when a spouse
											// benefit / coverage volume is chosen (no employee needed).
											opacity:
												Plan?.employee_required === true &&
												!planInputs?.benefit_amount &&
												!planInputs?.coverage_volume &&
												!spousePlanInputs?.benefit_amount &&
												!spousePlanInputs?.coverage_volume
													? 0.6
													: 1,
											pointerEvents:
												Plan?.employee_required === true &&
												!planInputs?.benefit_amount &&
												!planInputs?.coverage_volume &&
												!spousePlanInputs?.benefit_amount &&
												!spousePlanInputs?.coverage_volume
													? "none"
													: "auto"
										}}
									>
										<div className="plan-content" style={{ position: "relative" }}>
											{children.length > 0 &&
												(Plan?.coverage_for?.options?.includes("Children Only") ||
													Plan?.coverage_for?.options?.includes("Spouse & Children")) &&
												(planInputs?.coverage ||
													spousePlanInputs?.benefit_amount ||
													spousePlanInputs?.coverage_volume) && (
													<div
														className="plan-content"
														style={{ position: "relative", marginTop: "-40px" }}
													>
														<div className="theme-plan-section-margin" />

														<div
															className="header-container"
															style={{ marginLeft: "-30px" }}
														>
															{Plan?.benefit_amount?.child
																?.child_can_enroll_individually && (
																<div
																	style={{
																		display: "flex",
																		alignItems: "center",
																		gap: "10px",
																		marginBottom: "4px"
																	}}
																>
																	<Checkbox
																		checked={showChildSection}
																		onChange={(e) =>
																			setShowChildSection(e.target.checked)
																		}
																		color="primary"
																	/>
																	<div>
																		<div
																			className="theme-plan-header"
																			style={{ marginBottom: 2 }}
																		>
																			Children Benefits
																		</div>
																		<div
																			style={{
																				fontSize: 12,
																				color: "#6b7280",
																				fontWeight: 400
																			}}
																		>
																			Check to include children coverage
																		</div>
																	</div>
																</div>
															)}
															<>
																<div
																	className="theme-plan-header"
																	style={{ marginBottom: 2 }}
																>
																	{`Children Benefits (${eligibelDependentChild
																		.map(
																			(child) =>
																				`${child?.first_name} ${child?.last_name}`
																		)
																		.join(", ")})`}
																</div>
																<div
																	style={{
																		fontSize: 12,
																		color: "#6b7280",
																		fontWeight: 400
																	}}
																>
																	Select coverage options for your children
																</div>
															</>
														</div>
														{
															<Grid
																container
																columnSpacing={2}
																rowSpacing={2}
																className="grid-container"
																sx={{
																	display: "flex",
																	flexWrap: "wrap",
																	alignItems: "flex-start"
																}}
															>
																{!currentPlans?.length ? (
																	<div>Loading...</div>
																) : (
																	<>
																		{Plan?.coverage_for?.options?.length > 0 && (
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Coverage for
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							childPlanInputs.coverage ||
																							"Children Only"
																						}
																						disabled
																						sx={{
																							"& .MuiSelect-select.Mui-disabled":
																								{
																									"-webkit-text-fill-color":
																										"inherit",
																									opacity: 1,
																									cursor: "default"
																								},
																							"& .Mui-disabled": {
																								opacity: 1
																							}
																						}}
																					>
																						<MenuItem value="Children Only">
																							Children
																						</MenuItem>
																					</Select>
																				</div>
																			</Grid>
																		)}
																		{Plan?.coverage_volume?.options?.length > 0 && (
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Coverage Volume
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							childPlanInputs.coverage_volume ||
																							""
																						}
																						onChange={(e: any) =>
																							handleChildCoverageChange({
																								coverage_volume:
																									e.target.value
																							})
																						}
																					>
																						{coverageVolume.map(
																							(opt, idx) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																					</Select>
																				</div>
																			</Grid>
																		)}
																		{Plan?.benefit_amount?.child?.options?.length >
																			0 && (
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Benefit amount
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							childPlanInputs.benefit_amount ||
																							""
																						}
																						onChange={(e: any) =>
																							handleChildCoverageChange({
																								benefit_amount:
																									e.target.value
																							})
																						}
																					>
																						{childBenefitOptions.map(
																							(opt: any, idx: number) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																					</Select>
																				</div>
																			</Grid>
																		)}
																		{childNeedsSI && (
																			<SIStatusBadge
																				submitted={siSubmittedStatus.CHILD}
																				eligible={
																					siDataStore.find(
																						(s) => s.role === "child"
																					)?.eligible
																				}
																				onEdit={() => {
																					setCurrentRelation("CHILD");
																					setSiModalOpen(true);
																				}}
																				label="Child SI"
																			/>
																		)}
																		<Grid
																			item
																			xl={2}
																			lg={2}
																			md={2}
																			sm={2}
																			xs={12}
																			sx={{
																				position: "absolute",
																				top: 0,
																				right: 0,
																				display: "flex",
																				justifyContent: "flex-end",
																				alignItems: "flex-start",
																				padding: "8px 20px",
																				pointerEvents: "none"
																			}}
																		>
																			<div
																				className="details-form-row"
																				style={{ textAlign: "right" }}
																			>
																				<div className="details-form-label required align-center">
																					Premium
																				</div>
																				<div className="show-premium">
																					${childPremium.toFixed(2)}
																				</div>
																			</div>
																		</Grid>
																	</>
																)}
															</Grid>
														}
													</div>
												)}
										</div>
									</div>
								</>
							)}

						<SIQuestionsModal
							open={riderSiModalOpen}
							questions={
								riderCurrentRelation === "EMPLOYEE"
									? Plan?.rider?.benefit_amount?.si_questions ??
									  Plan?.rider?.benefit_amount?.employee?.si_questions ??
									  []
									: riderCurrentRelation === "SPOUSE"
									? Plan?.rider?.benefit_amount?.spouse?.si_questions ?? []
									: Plan?.rider?.benefit_amount?.child?.si_questions ?? []
							}
							relation={riderCurrentRelation || "EMPLOYEE"}
							selectedAmount={
								riderCurrentRelation === "EMPLOYEE"
									? Number(riderPlanInputs.benefit_amount ?? 0)
									: riderCurrentRelation === "SPOUSE"
									? Number(riderSpousePlanInputs.benefit_amount ?? 0)
									: Number(riderChildPlanInputs.benefit_amount ?? 0)
							}
							giLimit={riderGI_LIMITS[riderCurrentRelation ?? "EMPLOYEE"]}
							siLimit={
								riderCurrentRelation === "EMPLOYEE"
									? Plan?.rider?.benefit_amount?.simplified_issue_amount ?? 0
									: riderCurrentRelation === "SPOUSE"
									? Plan?.rider?.benefit_amount?.spouse?.simplified_issue_amount ?? 0
									: Plan?.rider?.benefit_amount?.child?.simplified_issue_amount ?? 0
							}
							onSubmit={(answers, hasAnyYes, eligible) => {
								const spouseDep = eligibleDependents.find((d) => d.relationship === "SPOUSE");
								const firstChild =
									eligibleDependents.find((d) =>
										["CHILD", "STEP CHILD", "CORT-ORDER CHILD"].includes(d.relationship)
									) ?? children[0];

								const memberForRole =
									riderCurrentRelation === "EMPLOYEE"
										? member
										: riderCurrentRelation === "SPOUSE"
										? spouseDep
										: firstChild;

								const faceAmount =
									riderCurrentRelation === "EMPLOYEE"
										? Number(riderPlanInputs.benefit_amount ?? 0)
										: riderCurrentRelation === "SPOUSE"
										? Number(riderSpousePlanInputs.benefit_amount ?? 0)
										: Number(riderChildPlanInputs.benefit_amount ?? 0);

								const giLimit = riderGI_LIMITS[riderCurrentRelation ?? "EMPLOYEE"];

								const newEntry: ApplicantStore = {
									role: riderCurrentRelation?.toLowerCase() as "employee" | "spouse" | "child",
									answers,
									eligible,
									reducedToGI: false,
									member_object_id: memberForRole?._id ?? "",
									member_SSN: memberForRole?.SSN ?? "",
									child_name:
										riderCurrentRelation === "CHILD"
											? `${firstChild?.first_name ?? ""} ${firstChild?.last_name ?? ""}`.trim()
											: undefined,
									face_amount: faceAmount,
									gi_limit: giLimit,
									exceeds_gi: faceAmount > giLimit
								};

								//  Update ref synchronously
								riderSiDataStoreRef.current = [
									...riderSiDataStoreRef.current.filter(
										(s) => s.role !== riderCurrentRelation?.toLowerCase()
									),
									newEntry
								];

								// ✅ Sync state for UI only
								setRiderSiDataStore([...riderSiDataStoreRef.current]);

								// ✅ Update submitted status synchronously
								riderSiSubmittedStatusRef.current = {
									...riderSiSubmittedStatusRef.current,
									[riderCurrentRelation ?? "EMPLOYEE"]: true
								};
								setRiderSiSubmittedStatus({ ...riderSiSubmittedStatusRef.current });

								// ✅ Close modal
								setRiderSiModalOpen(false);
							}}
							onClose={() => setRiderSiModalOpen(false)}
							onReduceToGI={() => {
								setRiderSiModalOpen(false);
								const giLimit = riderGI_LIMITS[riderCurrentRelation ?? "EMPLOYEE"];
								if (riderCurrentRelation === "EMPLOYEE")
									handleRiderCoverageChange({ benefit_amount: String(giLimit) });
								else if (riderCurrentRelation === "SPOUSE")
									handleRiderSpouseCoverageChange({ benefit_amount: String(giLimit) });
								else if (riderCurrentRelation === "CHILD")
									handleRiderChildCoverageChange({ benefit_amount: String(giLimit) });
							}}
						/>

						{/* ── Riders & Dependency Plans ── */}
						<Tooltip
							title={
								hasCancerEnrollment && Plan?.plan_name === "Accident"
									? "You are ineligible for Accident Disability Riders as you have already enrolled for Kemper Short Term Disability"
									: ""
							}
						>
							<>
								{Plan?.is_this_plan_has_riders && (
									<div>
										<div
											style={{
												border: "1px solid #e5e7eb",
												borderRadius: "12px",
												marginBottom: "16px",
												backgroundColor: "#fff",
												overflow: "hidden"
											}}
										>
											<div className="plan-content" style={{ position: "relative" }}>
												<div className="theme-plan-section-margin" />
												<div className="header-container">
													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "10px",
															marginBottom: "4px"
														}}
													>
														<div>
															<div
																className="theme-plan-header"
																style={{ marginBottom: 2 }}
															>
																{Plan?.rider?.name} Rider Benefits
															</div>
														</div>
													</div>

													<div
														style={{
															display: "flex",
															alignItems: "center",
															gap: "10px",
															marginBottom: "4px"
														}}
													>
														<Checkbox
															checked={!!planInputs.rider_present}
															onChange={(e) => {
																if (Plan?.rider?.is_required) return;
																handleCoverageSelectChange({
																	rider_present: e.target.checked
																});
															}}
															color="primary"
														/>
														<div>
															<div
																style={{
																	fontSize: 13,
																	fontWeight: 600,
																	color: "#111827"
																}}
															>
																Do you want to enroll in this Benefit?
															</div>
															{/* <div
																style={{
																	fontSize: 12,
																	color: "#6b7280",
																	fontWeight: 400
																}}
															>
																Check to include {Plan?.rider?.name} for yourself
															</div> */}
														</div>
													</div>

													{/* ── Only show when enrolled ── */}
													{Plan?.rider?.coverage_for?.options?.some((opt: string) =>
														[
															"Employee Only",
															"Employee & Spouse",
															"Employee & Children",
															"Employee & Family"
														].includes(opt)
													) && (
														<>
															{Plan?.rider?.is_premium_depends_on_smoke === true && (
																<span className="smoker-flag-set-area">
																	<span className="is-smoker-label">
																		Used nicotine or tobacco products in the last 12
																		months?
																	</span>
																	<label className="switch">
																		<input
																			type="checkbox"
																			name="rider-member-tobacco"
																			checked={isEmployeeTobacco}
																			onChange={handleEmployeeTobaccoToggle}
																		/>
																		<span className="slider round"></span>
																	</label>
																</span>
															)}
															<div
																className="member-name"
																style={{
																	marginBottom: "12px",
																	fontWeight: 700,
																	fontSize: "14px",
																	color: "#555"
																}}
															>
																{member?.first_name} {member?.last_name} (SELF)
															</div>
														</>
													)}
												</div>
												{Plan?.rider?.coverage_for?.options?.some((opt: string) =>
													[
														"Employee Only",
														"Employee & Spouse",
														"Employee & Children",
														"Employee & Family"
													].includes(opt)
												) && (
													<div>
														{Plan?.rider?.coverage_for?.options?.some((opt: string) =>
															[
																"Employee Only",
																"Employee & Spouse",
																"Employee & Children",
																"Employee & Family"
															].includes(opt)
														) && (
															<Grid
																container
																columnSpacing={2}
																rowSpacing={2}
																className="grid-container"
																sx={{
																	display: "flex",
																	flexWrap: "wrap",
																	alignItems: "flex-start"
																}}
															>
																{!currentPlans?.length ? (
																	<div>Loading...</div>
																) : (
																	<>
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Coverage for
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						riderPlanInputs.coverage || ""
																					}
																					onChange={(e: any) =>
																						handleRiderCoverageChange({
																							coverage: e.target.value
																						})
																					}
																				>
																					{Plan?.rider?.coverage_for?.options
																						.filter((opt: string) =>
																							[
																								"Employee Only",
																								"Employee & Spouse",
																								"Employee & Children",
																								"Employee & Family"
																							].includes(opt)
																						)
																						.map(
																							(
																								opt: string,
																								idx: number
																							) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																				</Select>
																			</div>
																		</Grid>
																		{Plan?.rider?.coverage_volume?.options?.length >
																			0 && (
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Coverage Volume
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							riderPlanInputs.coverage_volume ||
																							""
																						}
																						onChange={(e: any) =>
																							handleRiderCoverageChange({
																								coverage_volume:
																									e.target.value
																							})
																						}
																					>
																						{Plan?.rider?.coverage_volume?.options.map(
																							(
																								opt: string,
																								idx: number
																							) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																					</Select>
																				</div>
																			</Grid>
																		)}
																		{Plan?.rider?.benefit_amount?.options?.length >
																			0 && (
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Benefit amount
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							riderPlanInputs.benefit_amount ||
																							""
																						}
																						onChange={(e: any) =>
																							handleRiderCoverageChange({
																								benefit_amount:
																									e.target.value
																							})
																						}
																					>
																						{Plan?.rider?.benefit_amount?.options.map(
																							(opt: any, idx: number) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																					</Select>
																				</div>
																			</Grid>
																		)}
																		{riderEmployeeNeedsSI && (
																			<SIStatusBadge
																				submitted={
																					riderSiSubmittedStatus.EMPLOYEE
																				}
																				eligible={
																					riderSiDataStore.find(
																						(s) => s.role === "employee"
																					)?.eligible
																				}
																				onEdit={() => {
																					setRiderCurrentRelation("EMPLOYEE");
																					setRiderSiModalOpen(true);
																				}}
																				label="Rider Employee SI"
																			/>
																		)}
																		<Grid
																			item
																			xl={2}
																			lg={2}
																			md={2}
																			sm={2}
																			xs={12}
																			sx={{
																				position: "absolute",
																				top: 0,
																				right: 0,
																				display: "flex",
																				justifyContent: "flex-end",
																				alignItems: "flex-start",
																				padding: "8px 20px",
																				pointerEvents: "none"
																			}}
																		>
																			<div
																				className="details-form-row"
																				style={{ textAlign: "right" }}
																			>
																				<div className="details-form-label required align-center">
																					Premium
																				</div>
																				<div className="show-premium">
																					${riderEmployeePremium.toFixed(2)}
																				</div>
																			</div>
																		</Grid>
																	</>
																)}
															</Grid>
														)}
													</div>
												)}

												{/* ── Rider Spouse Section ── */}
												{eligibelDependentSpouse &&
													Plan?.rider?.coverage_for?.options?.some((opt: string) =>
														[
															"Employee & Spouse",
															"Employee & Family",
															"Spouse Only",
															"Spouse & Children"
														].includes(opt)
													) && (
														<div
															style={{
																border: "1px solid #e5e7eb",
																borderRadius: "12px",
																marginBottom: "16px",
																backgroundColor: "#fff",
																overflow: "hidden"
															}}
														>
															<div
																className="plan-content"
																style={{ position: "relative" }}
															>
																<div className="theme-plan-section-margin" />
																<div className="header-container">
																	<div
																		style={{
																			display: "flex",
																			alignItems: "center",
																			gap: "10px",
																			marginBottom: "4px"
																		}}
																	>
																		<div>
																			<div
																				className="theme-plan-header"
																				style={{ marginBottom: 2 }}
																			>
																				Spouse Benefits
																			</div>
																		</div>
																	</div>
																	<div
																		className="member-name"
																		style={{
																			marginBottom: "12px",
																			fontWeight: 700,
																			fontSize: "14px",
																			color: "#555"
																		}}
																	>
																		{spouse?.first_name} {spouse?.last_name}{" "}
																		(SPOUSE)
																	</div>
																	{Plan?.rider?.is_premium_depends_on_spouse_smoke ===
																		true && (
																		<span className="smoker-flag-set-area">
																			<span className="is-smoker-label">
																				Used nicotine or tobacco products in the
																				last 12 months?
																			</span>
																			<label className="switch">
																				<input
																					type="checkbox"
																					name="rider-spouse-tobacco"
																					checked={isSpouseTobacco}
																					onChange={handleSpouseTobaccoToggle}
																				/>
																				<span className="slider round"></span>
																			</label>
																		</span>
																	)}
																</div>
																<Grid
																	container
																	columnSpacing={2}
																	rowSpacing={2}
																	className="grid-container"
																	sx={{
																		display: "flex",
																		flexWrap: "wrap",
																		alignItems: "flex-start"
																	}}
																>
																	{!currentPlans?.length ? (
																		<div>Loading...</div>
																	) : (
																		<>
																			<Grid
																				item
																				xl={5}
																				lg={5}
																				md={5}
																				sm={5}
																				xs={12}
																				sx={{ flex: "1 1 45%" }}
																			>
																				<div className="details-form-row">
																					<div className="details-form-label required">
																						Coverage for
																					</div>
																					<Select
																						fullWidth
																						input={<CustomSelectInput />}
																						value={
																							riderSpousePlanInputs.coverage ||
																							"Spouse Only"
																						}
																						onChange={(e: any) =>
																							handleRiderSpouseCoverageChange(
																								{
																									coverage:
																										e.target.value
																								}
																							)
																						}
																						sx={{
																							"& .MuiSelect-select": {
																								"-webkit-text-fill-color":
																									"inherit",
																								opacity: 1,
																								cursor: "default",
																								pointerEvents: "none"
																							}
																						}}
																					>
																						{Plan?.rider?.coverage_for?.options
																							.filter(
																								(opt: string) =>
																									opt ===
																									"Spouse Only"
																							)
																							.map(
																								(
																									opt: string,
																									idx: number
																								) => (
																									<MenuItem
																										key={idx}
																										value={
																											"Spouse Only"
																										}
																									>
																										Spouse
																									</MenuItem>
																								)
																							)}
																					</Select>
																				</div>
																			</Grid>
																			{Plan?.rider?.coverage_volume?.options
																				?.length > 0 && (
																				<Grid
																					item
																					xl={5}
																					lg={5}
																					md={5}
																					sm={5}
																					xs={12}
																					sx={{ flex: "1 1 45%" }}
																				>
																					<div className="details-form-row">
																						<div className="details-form-label required">
																							Coverage Volume
																						</div>
																						<Select
																							fullWidth
																							input={
																								<CustomSelectInput />
																							}
																							value={
																								riderSpousePlanInputs.coverage_volume ||
																								""
																							}
																							onChange={(e: any) =>
																								handleRiderSpouseCoverageChange(
																									{
																										coverage_volume:
																											e.target
																												.value
																									}
																								)
																							}
																						>
																							{Plan?.rider?.coverage_volume?.options.map(
																								(
																									opt: string,
																									idx: number
																								) => (
																									<MenuItem
																										key={idx}
																										value={opt}
																									>
																										{opt}
																									</MenuItem>
																								)
																							)}
																						</Select>
																					</div>
																				</Grid>
																			)}
																			{Plan?.rider?.benefit_amount?.spouse
																				?.options?.length > 0 && (
																				<Grid
																					item
																					xl={5}
																					lg={5}
																					md={5}
																					sm={5}
																					xs={12}
																					sx={{ flex: "1 1 45%" }}
																				>
																					<div className="details-form-row">
																						<div className="details-form-label required">
																							Benefit amount
																						</div>
																						<Select
																							fullWidth
																							input={
																								<CustomSelectInput />
																							}
																							value={
																								riderSpousePlanInputs.benefit_amount ||
																								""
																							}
																							onChange={(e: any) =>
																								handleRiderSpouseCoverageChange(
																									{
																										benefit_amount:
																											e.target
																												.value
																									}
																								)
																							}
																						>
																							{Plan?.rider?.benefit_amount?.spouse?.options.map(
																								(
																									opt: any,
																									idx: number
																								) => (
																									<MenuItem
																										key={idx}
																										value={opt}
																									>
																										{opt}
																									</MenuItem>
																								)
																							)}
																						</Select>
																					</div>
																				</Grid>
																			)}
																			{riderSpouseNeedsSI && (
																				<SIStatusBadge
																					submitted={
																						riderSiSubmittedStatus.SPOUSE
																					}
																					eligible={
																						riderSiDataStore.find(
																							(s) => s.role === "spouse"
																						)?.eligible
																					}
																					onEdit={() => {
																						setRiderCurrentRelation(
																							"SPOUSE"
																						);
																						setRiderSiModalOpen(true);
																					}}
																					label="Rider Spouse SI"
																				/>
																			)}
																			<Grid
																				item
																				xl={2}
																				lg={2}
																				md={2}
																				sm={2}
																				xs={12}
																				sx={{
																					position: "absolute",
																					top: 0,
																					right: 0,
																					display: "flex",
																					justifyContent: "flex-end",
																					alignItems: "flex-start",
																					padding: "8px 20px",
																					pointerEvents: "none"
																				}}
																			>
																				<div
																					className="details-form-row"
																					style={{ textAlign: "right" }}
																				>
																					<div className="details-form-label required align-center">
																						Premium
																					</div>
																					<div className="show-premium">
																						${riderSpousePremium.toFixed(2)}
																					</div>
																				</div>
																			</Grid>
																		</>
																	)}
																</Grid>
															</div>
														</div>
													)}

												{eligibelDependentChild &&
													eligibelDependentChild?.length > 0 &&
													Plan?.rider?.coverage_for?.options?.some((opt: string) =>
														[
															"Employee & Children",
															"Employee & Family",
															"Spouse & Children",
															"Children Only"
														].includes(opt)
													) && (
														<div
															style={{
																border: "1px solid #e5e7eb",
																borderRadius: "12px",
																marginBottom: "16px",
																backgroundColor: "#fff",
																overflow: "hidden"
															}}
														>
															<div
																className="plan-content"
																style={{ position: "relative" }}
															>
																<div className="theme-plan-section-margin" />
																<div className="header-container">
																	{Plan?.rider?.benefit_amount.child
																		?.child_can_enroll_individually &&
																		(Plan.rider?.benefit_amount.spouse?.options
																			.length < 0 ||
																			Plan?.rider?.coverage_volume.options
																				.length < 0) && (
																			<div
																				style={{
																					display: "flex",
																					alignItems: "center",
																					gap: "10px",
																					marginBottom: "4px"
																				}}
																			>
																				<Checkbox
																					checked={showRiderChildSection}
																					onChange={(e) =>
																						setShowRiderChildSection(
																							e.target.checked
																						)
																					}
																					color="primary"
																				/>
																				<div>
																					<div
																						className="theme-plan-header"
																						style={{ marginBottom: 2 }}
																					>
																						Children Benefits
																					</div>
																					{/* <div
																				style={{
																					fontSize: 12,
																					color: "#6b7280",
																					fontWeight: 400
																				}}
																			>
																				Check to include children under this
																				rider
																			</div> */}
																				</div>
																			</div>
																		)}

																	{!(
																		Plan?.rider?.benefit_amount.child
																			?.child_can_enroll_individually &&
																		(Plan.rider?.benefit_amount.spouse?.options
																			.length < 0 ||
																			Plan?.rider?.coverage_volume.options
																				.length < 0)
																	) && (
																		<div
																			style={{
																				display: "flex",
																				alignItems: "center",
																				gap: "10px",
																				marginBottom: "4px"
																			}}
																		>
																			<div>
																				<div
																					className="theme-plan-header"
																					style={{ marginBottom: 2 }}
																				>
																					Children Benefits
																				</div>
																				{/* <div
																			style={{
																				fontSize: 12,
																				color: "#6b7280",
																				fontWeight: 400
																			}}
																		>
																			Select coverage options for children under
																			this rider
																		</div> */}
																			</div>
																		</div>
																	)}

																	<div className="children-selection-row">
																		{eligibelDependentChild.length > 0 &&
																			eligibelDependentChild?.map(
																				(child: any, index: number) => {
																					const childId =
																						child._id ||
																						child.id ||
																						`${child.first_name}_${index}`;
																					return (
																						<div
																							key={childId}
																							className={`child-selection-card ${
																								selectedRiderChildren.includes(
																									childId
																								)
																									? "selected"
																									: ""
																							}`}
																						>
																							<Checkbox
																								size="small"
																								checked={selectedRiderChildren.includes(
																									childId
																								)}
																								onChange={() =>
																									handleRiderChildToggle(
																										childId
																									)
																								}
																								sx={{
																									color: theme.primary_color,
																									"&.Mui-checked": {
																										color: theme.primary_color
																									},
																									padding: "4px"
																								}}
																							/>
																							<div className="child-selection-content">
																								<div className="child-selection-name">
																									{child.first_name}{" "}
																									{child.last_name}
																								</div>
																								<div className="child-selection-label">
																									CHILD
																								</div>
																							</div>
																						</div>
																					);
																				}
																			)}
																	</div>

																	{/* <div
																className="theme-plan-sub-header plan-text"
																style={{ borderLeftColor: theme.primary_color }}
															>
																Select coverage options for your children under this
																rider
															</div> */}
																</div>

																<div style={{ paddingLeft: "8px" }}>
																	<Grid
																		container
																		columnSpacing={2}
																		rowSpacing={2}
																		className="grid-container"
																		sx={{
																			display: "flex",
																			flexWrap: "wrap",
																			alignItems: "flex-start"
																		}}
																	>
																		{!currentPlans?.length ? (
																			<div>Loading...</div>
																		) : (
																			<>
																				<Grid
																					item
																					xl={5}
																					lg={5}
																					md={5}
																					sm={5}
																					xs={12}
																					sx={{ flex: "1 1 45%" }}
																				>
																					<div className="details-form-row">
																						<div className="details-form-label required">
																							Coverage for
																						</div>
																						<Select
																							fullWidth
																							input={
																								<CustomSelectInput />
																							}
																							value={
																								riderChildPlanInputs.coverage ||
																								"Children Only"
																							}
																							onChange={(e: any) =>
																								handleRiderChildCoverageChange(
																									{
																										coverage:
																											e.target
																												.value
																									}
																								)
																							}
																							sx={{
																								"& .MuiSelect-select": {
																									"-webkit-text-fill-color":
																										"inherit",
																									opacity: 1,
																									cursor: "default",
																									pointerEvents:
																										"none"
																								}
																							}}
																						>
																							{Plan?.rider?.coverage_for?.options
																								.filter(
																									(opt: string) =>
																										opt ===
																										"Children Only"
																								)
																								.map(
																									(
																										opt: string,
																										idx: number
																									) => (
																										<MenuItem
																											key={idx}
																											value={
																												"Children Only"
																											}
																										>
																											Children
																										</MenuItem>
																									)
																								)}
																						</Select>
																					</div>
																				</Grid>

																				{Plan?.rider?.coverage_volume?.options
																					?.length > 0 && (
																					<Grid
																						item
																						xl={5}
																						lg={5}
																						md={5}
																						sm={5}
																						xs={12}
																						sx={{ flex: "1 1 45%" }}
																					>
																						<div className="details-form-row">
																							<div className="details-form-label required">
																								Coverage Volume
																							</div>
																							<Select
																								fullWidth
																								input={
																									<CustomSelectInput />
																								}
																								value={
																									riderChildPlanInputs.coverage_volume ||
																									""
																								}
																								onChange={(e: any) =>
																									handleRiderChildCoverageChange(
																										{
																											coverage_volume:
																												e.target
																													.value
																										}
																									)
																								}
																							>
																								{Plan?.rider?.coverage_volume?.options.map(
																									(
																										opt: string,
																										idx: number
																									) => (
																										<MenuItem
																											key={idx}
																											value={opt}
																										>
																											{opt}
																										</MenuItem>
																									)
																								)}
																							</Select>
																						</div>
																					</Grid>
																				)}

																				{Plan?.rider?.benefit_amount?.child
																					?.options?.length > 0 && (
																					<Grid
																						item
																						xl={5}
																						lg={5}
																						md={5}
																						sm={5}
																						xs={12}
																						sx={{ flex: "1 1 45%" }}
																					>
																						<div className="details-form-row">
																							<div className="details-form-label required">
																								Benefit amount
																							</div>
																							<Select
																								fullWidth
																								input={
																									<CustomSelectInput />
																								}
																								value={
																									riderChildPlanInputs.benefit_amount ||
																									""
																								}
																								onChange={(e: any) =>
																									handleRiderChildCoverageChange(
																										{
																											benefit_amount:
																												e.target
																													.value
																										}
																									)
																								}
																							>
																								{Plan?.rider?.benefit_amount?.child?.options.map(
																									(
																										opt: any,
																										idx: number
																									) => (
																										<MenuItem
																											key={idx}
																											value={opt}
																										>
																											{opt}
																										</MenuItem>
																									)
																								)}
																							</Select>
																						</div>
																					</Grid>
																				)}

																				{riderChildNeedsSI && (
																					<SIStatusBadge
																						submitted={
																							riderSiSubmittedStatus.CHILD
																						}
																						eligible={
																							riderSiDataStore.find(
																								(s) =>
																									s.role === "child"
																							)?.eligible
																						}
																						onEdit={() => {
																							setRiderCurrentRelation(
																								"CHILD"
																							);
																							setRiderSiModalOpen(true);
																						}}
																						label="Rider Child SI"
																					/>
																				)}

																				<Grid
																					item
																					xl={2}
																					lg={2}
																					md={2}
																					sm={2}
																					xs={12}
																					sx={{
																						position: "absolute",
																						top: 0,
																						right: 0,
																						display: "flex",
																						justifyContent: "flex-end",
																						alignItems: "flex-start",
																						padding: "8px 8px",
																						pointerEvents: "none"
																					}}
																				>
																					<div
																						className="details-form-row"
																						style={{ textAlign: "right" }}
																					>
																						<div className="details-form-label required align-center">
																							Premium
																						</div>
																						<div className="show-premium">
																							$
																							{riderChildPremium.toFixed(
																								2
																							)}
																						</div>
																					</div>
																				</Grid>
																			</>
																		)}
																	</Grid>
																</div>
															</div>
														</div>
													)}
											</div>
										</div>
									</div>
								)}

								{/* ── Dependency Plans ── */}
								{(Plan?.standard_plan_dependency ?? [])
									.filter(Boolean)
									.map((dep: StandardPlanDependency) => {
										const depPlanName = dep.plan; // ← extract plan name from object
										if (!depPlanName) return null;

										const isSameCoverage =
											dep.same_coverage === true || dep.same_coverage === "true";

										const depPlan = currentPlans.find((p: any) => p.plan_name === depPlanName);
										if (!depPlan) return null;

										// If same_coverage, auto-derive coverage from parent plan inputs
										const resolvedEmployeeCoverage = isSameCoverage
											? dependencyPlanInputs[depPlanName]?.coverage || planInputs?.coverage
											: dependencyPlanInputs[depPlanName]?.coverage;

										const depInputs = {
											...(dependencyPlanInputs[depPlanName] ?? {}),
											...(isSameCoverage && resolvedEmployeeCoverage
												? { coverage: resolvedEmployeeCoverage }
												: {})
										};

										const depPremium = dependencyPremiums[depPlanName] ?? 0;
										const depSpousePremium = dependencyPremiums[`${depPlanName}_spouse`] ?? 0;
										const depChildPremium = dependencyPremiums[`${depPlanName}_child`] ?? 0;

										const depSpouse = eligibleDependents.find((d) => d.relationship === "SPOUSE");
										const depChildren = eligibleDependents.filter(
											(d) =>
												d.relationship === "CHILD" ||
												d.relationship === "STEP CHILD" ||
												d.relationship === "CORT-ORDER CHILD"
										);

										const canShowDepSpouse =
											!!depSpouse &&
											depPlan?.coverage_for?.options?.some((o: string) =>
												["Spouse Only", "Spouse & Children"].includes(o)
											);
										const canShowDepChild =
											depChildren.length > 0 &&
											depPlan?.coverage_for?.options?.some((o: string) =>
												["Children Only", "Spouse & Children"].includes(o)
											);

										const depSpouseChecked = depSpouseCheckedMap[depPlanName] ?? false;
										const depChildChecked = depChildCheckedMap[depPlanName] ?? false;

										// Coverage options for the employee dropdown
										const employeeCoverageOptions = isSameCoverage
											? [planInputs?.coverage].filter(Boolean)
											: planCode === "AI-ALL-NEW-2026"
											? [planInputs.coverage].filter(Boolean)
											: depPlan.coverage_for.options.filter((opt: string) =>
													[
														"Employee Only",
														"Employee & Spouse",
														"Employee & Children",
														"Employee & Family"
													].includes(opt)
											  );

										return (
											<React.Fragment key={depPlanName}>
												{/* ── Dep Employee ── */}
												<div
													style={{
														border: "1px solid #e5e7eb",
														borderRadius: "12px",
														marginBottom: "16px",
														backgroundColor: "#fff",
														overflow: "hidden"
													}}
												>
													<div className="plan-content" style={{ position: "relative" }}>
														<div className="theme-plan-section-margin" />
														<div className="header-container">
															<div
																style={{
																	display: "flex",
																	alignItems: "center",
																	gap: "10px",
																	marginBottom: "4px"
																}}
															>
																<div>
																	<div
																		className="theme-plan-header"
																		style={{ marginBottom: 2 }}
																	>
																		{depPlanName}
																	</div>
																	<div
																		style={{
																			fontSize: 12,
																			color: "#6b7280",
																			fontWeight: 400
																		}}
																	>
																		Coverage options for {depPlanName}
																		{isSameCoverage && (
																			<span
																				style={{
																					marginLeft: 6,
																					color: "#9ca3af",
																					fontStyle: "italic"
																				}}
																			>
																				(same as {Plan?.plan_name})
																			</span>
																		)}
																	</div>
																</div>
															</div>
														</div>
														<Grid
															container
															columnSpacing={2}
															rowSpacing={2}
															className="grid-container"
															sx={{
																display: "flex",
																flexWrap: "wrap",
																alignItems: "flex-start"
															}}
														>
															{depPlan?.coverage_for?.options?.length > 0 && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Coverage for
																		</div>
																		{/* <Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value={
																				isSameCoverage
																					? planInputs?.coverage || ""
																					: depInputs.coverage || ""
																			}
																			onChange={(e: any) => {
																				if (isSameCoverage) return; //
																				handleDependencyPlanChange(
																					depPlanName,
																					depPlan,
																					{ coverage: e.target.value }
																				);
																			}}
																			sx={{
																				...(isSameCoverage && {
																					"& .MuiSelect-select.Mui-disabled":
																						{
																							"-webkit-text-fill-color":
																								"inherit",
																							opacity: 1,
																							cursor: "default"
																						},
																					"& .Mui-disabled": { opacity: 1 },
																					pointerEvents: "none" // 
																				})
																			}}
																		>
																			{employeeCoverageOptions.map(
																				(opt: string, idx: number) => (
																					<MenuItem key={idx} value={opt}>
																						{opt}
																					</MenuItem>
																				)
																			)}
																		</Select> */}
																		{isSameCoverage ? (
																			<div
																				style={{
																					padding: "10px 14px",
																					border: "1px solid #e5e7eb",
																					borderRadius: "8px",
																					backgroundColor: "#f9fafb",
																					fontSize: 14,
																					color: "#111827",
																					fontWeight: 700,
																					WebkitTextFillColor: "#111827",
																					opacity: 1,
																					cursor: "default"
																				}}
																			>
																				{planInputs?.coverage || ""}
																			</div>
																		) : (
																			<Select
																				fullWidth
																				input={<CustomSelectInput />}
																				value={depInputs.coverage || ""}
																				onChange={(e: any) =>
																					handleDependencyPlanChange(
																						depPlanName,
																						depPlan,
																						{ coverage: e.target.value }
																					)
																				}
																			>
																				{employeeCoverageOptions.map(
																					(opt: string, idx: number) => (
																						<MenuItem key={idx} value={opt}>
																							{opt}
																						</MenuItem>
																					)
																				)}
																			</Select>
																		)}
																	</div>
																</Grid>
															)}
															{/* coverage_volume, benefit_amount, premium Grid items unchanged below */}
															{depPlan?.coverage_volume?.options?.length > 0 && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Coverage Volume
																		</div>
																		<Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value={depInputs.coverage_volume || ""}
																			onChange={(e: any) =>
																				handleDependencyPlanChange(
																					depPlanName,
																					depPlan,
																					{
																						coverage_volume: e.target.value
																					}
																				)
																			}
																		>
																			{depPlan.coverage_volume.options.map(
																				(opt: string, idx: number) => (
																					<MenuItem key={idx} value={opt}>
																						{opt}
																					</MenuItem>
																				)
																			)}
																		</Select>
																	</div>
																</Grid>
															)}
															{depPlan?.benefit_amount?.options?.length > 0 && (
																<Grid
																	item
																	xl={5}
																	lg={5}
																	md={5}
																	sm={5}
																	xs={12}
																	sx={{ flex: "1 1 45%" }}
																>
																	<div className="details-form-row">
																		<div className="details-form-label required">
																			Benefit amount
																		</div>
																		<Select
																			fullWidth
																			input={<CustomSelectInput />}
																			value={depInputs.benefit_amount || ""}
																			onChange={(e: any) =>
																				handleDependencyPlanChange(
																					depPlanName,
																					depPlan,
																					{
																						benefit_amount: e.target.value
																					}
																				)
																			}
																		>
																			{depPlan.benefit_amount.options.map(
																				(opt: any, idx: number) => (
																					<MenuItem key={idx} value={opt}>
																						{opt}
																					</MenuItem>
																				)
																			)}
																		</Select>
																	</div>
																</Grid>
															)}
															<Grid
																item
																xl={2}
																lg={2}
																md={2}
																sm={2}
																xs={12}
																sx={{
																	position: "absolute",
																	top: 0,
																	right: 0,
																	display: "flex",
																	justifyContent: "flex-end",
																	padding: "8px 20px",
																	pointerEvents: "none"
																}}
															>
																<div
																	className="details-form-row"
																	style={{ textAlign: "right" }}
																>
																	<div className="details-form-label required align-center">
																		Premium
																	</div>
																	<div className="show-premium">
																		${depPremium.toFixed(2)}
																	</div>
																</div>
															</Grid>
														</Grid>
													</div>
												</div>

												{/* ── Dep Spouse ── */}
												{canShowDepSpouse && (
													<div
														style={{
															border: "1px solid #e5e7eb",
															borderRadius: "12px",
															marginBottom: "16px",
															backgroundColor: "#fff",
															overflow: "hidden"
														}}
													>
														<div className="plan-content" style={{ position: "relative" }}>
															<div className="theme-plan-section-margin" />
															<div className="header-container">
																<div
																	style={{
																		display: "flex",
																		alignItems: "center",
																		gap: "10px",
																		marginBottom: "4px"
																	}}
																>
																	<Checkbox
																		checked={depSpouseChecked}
																		onChange={(e) =>
																			setDepSpouseCheckedMap((prev) => ({
																				...prev,
																				[depPlanName]: e.target.checked
																			}))
																		}
																		color="primary"
																	/>
																	<div>
																		<div
																			className="theme-plan-header"
																			style={{ marginBottom: 2 }}
																		>
																			{depPlanName} — Spouse Benefits
																		</div>
																		<div
																			style={{
																				fontSize: 12,
																				color: "#6b7280",
																				fontWeight: 400
																			}}
																		>
																			Check to include spouse coverage
																		</div>
																	</div>
																</div>
																{depSpouseChecked && (
																	<>
																		<div
																			className="member-name"
																			style={{
																				marginBottom: "12px",
																				fontWeight: 700,
																				fontSize: "14px",
																				color: "#555"
																			}}
																		>
																			{depSpouse?.first_name}{" "}
																			{depSpouse?.last_name} (SPOUSE)
																		</div>
																		{depPlan?.is_premium_depnends_on_spouse_smoke ===
																			true && (
																			<span className="smoker-flag-set-area">
																				<span className="is-smoker-label">
																					Used nicotine or tobacco products in
																					the last 12 months?
																				</span>
																				<label className="switch">
																					<input
																						type="checkbox"
																						checked={isSpouseTobacco}
																						onChange={
																							handleSpouseTobaccoToggle
																						}
																					/>
																					<span className="slider round"></span>
																				</label>
																			</span>
																		)}
																		<div
																			className="theme-plan-sub-header plan-text"
																			style={{
																				borderLeftColor: theme.primary_color
																			}}
																		>
																			Select coverage options for your spouse
																		</div>
																	</>
																)}
															</div>
															{depSpouseChecked && (
																<Grid
																	container
																	columnSpacing={2}
																	rowSpacing={2}
																	className="grid-container"
																	sx={{
																		display: "flex",
																		flexWrap: "wrap",
																		alignItems: "flex-start"
																	}}
																>
																	{depPlan?.coverage_for?.options?.length > 0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Coverage for
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.spouse_coverage || ""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								spouse_coverage:
																									e.target.value
																							},
																							"spouse"
																						)
																					}
																				>
																					{depPlan.coverage_for.options
																						.filter((opt: string) =>
																							["Spouse Only"].includes(
																								opt
																							)
																						)
																						.map(
																							(
																								opt: string,
																								idx: number
																							) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	{depPlan?.coverage_volume?.options?.length > 0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Coverage Volume
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.spouse_coverage_volume ||
																						""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								spouse_coverage_volume:
																									e.target.value
																							},
																							"spouse"
																						)
																					}
																				>
																					{depPlan.coverage_volume.options.map(
																						(opt: string, idx: number) => (
																							<MenuItem
																								key={idx}
																								value={opt}
																							>
																								{opt}
																							</MenuItem>
																						)
																					)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	{depPlan?.benefit_amount?.spouse?.options?.length >
																		0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Benefit amount
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.spouse_benefit_amount ||
																						""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								spouse_benefit_amount:
																									e.target.value
																							},
																							"spouse"
																						)
																					}
																				>
																					{depPlan.benefit_amount.spouse.options.map(
																						(opt: any, idx: number) => (
																							<MenuItem
																								key={idx}
																								value={opt}
																							>
																								{opt}
																							</MenuItem>
																						)
																					)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	<Grid
																		item
																		xl={2}
																		lg={2}
																		md={2}
																		sm={2}
																		xs={12}
																		sx={{
																			position: "absolute",
																			top: 0,
																			right: 0,
																			display: "flex",
																			justifyContent: "flex-end",
																			padding: "8px 20px",
																			pointerEvents: "none"
																		}}
																	>
																		<div
																			className="details-form-row"
																			style={{ textAlign: "right" }}
																		>
																			<div className="details-form-label required align-center">
																				Premium
																			</div>
																			<div className="show-premium">
																				${depSpousePremium.toFixed(2)}
																			</div>
																		</div>
																	</Grid>
																</Grid>
															)}
														</div>
													</div>
												)}

												{/* ── Dep Child ── */}
												{canShowDepChild && (
													<div
														style={{
															border: "1px solid #e5e7eb",
															borderRadius: "12px",
															marginBottom: "16px",
															backgroundColor: "#fff",
															overflow: "hidden"
														}}
													>
														<div className="plan-content" style={{ position: "relative" }}>
															<div className="theme-plan-section-margin" />
															<div className="header-container">
																<div
																	style={{
																		display: "flex",
																		alignItems: "center",
																		gap: "10px",
																		marginBottom: "4px"
																	}}
																>
																	<Checkbox
																		checked={depChildChecked}
																		onChange={(e) =>
																			setDepChildCheckedMap((prev) => ({
																				...prev,
																				[depPlanName]: e.target.checked
																			}))
																		}
																		color="primary"
																	/>
																	<div>
																		<div
																			className="theme-plan-header"
																			style={{ marginBottom: 2 }}
																		>
																			{depPlanName} — Children Benefits
																		</div>
																		<div
																			style={{
																				fontSize: 12,
																				color: "#6b7280",
																				fontWeight: 400
																			}}
																		>
																			Check to include children coverage
																		</div>
																	</div>
																</div>
																{depChildChecked && (
																	<>
																		<div
																			className="member-name"
																			style={{
																				marginBottom: "12px",
																				fontWeight: 700,
																				fontSize: "14px",
																				color: "#555"
																			}}
																		>
																			{depChildren[0]?.first_name}{" "}
																			{depChildren[0]?.last_name} (CHILDREN)
																		</div>
																		{/* <div
																		className="theme-plan-sub-header plan-text"
																		style={{ borderLeftColor: theme.primary_color }}
																	>
																		Select coverage options for your children
																	</div> */}
																	</>
																)}
															</div>
															{depChildChecked && (
																<Grid
																	container
																	columnSpacing={2}
																	rowSpacing={2}
																	className="grid-container"
																	sx={{
																		display: "flex",
																		flexWrap: "wrap",
																		alignItems: "flex-start"
																	}}
																>
																	{depPlan?.coverage_for?.options?.length > 0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Coverage for
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.child_coverage || ""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								child_coverage:
																									e.target.value
																							},
																							"child"
																						)
																					}
																				>
																					{depPlan.coverage_for.options
																						.filter((opt: string) =>
																							["Children Only"].includes(
																								opt
																							)
																						)
																						.map(
																							(
																								opt: string,
																								idx: number
																							) => (
																								<MenuItem
																									key={idx}
																									value={opt}
																								>
																									{opt}
																								</MenuItem>
																							)
																						)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	{depPlan?.coverage_volume?.options?.length > 0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Coverage Volume
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.child_coverage_volume ||
																						""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								child_coverage_volume:
																									e.target.value
																							},
																							"child"
																						)
																					}
																				>
																					{depPlan.coverage_volume.options.map(
																						(opt: string, idx: number) => (
																							<MenuItem
																								key={idx}
																								value={opt}
																							>
																								{opt}
																							</MenuItem>
																						)
																					)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	{depPlan?.benefit_amount?.child?.options?.length >
																		0 && (
																		<Grid
																			item
																			xl={5}
																			lg={5}
																			md={5}
																			sm={5}
																			xs={12}
																			sx={{ flex: "1 1 45%" }}
																		>
																			<div className="details-form-row">
																				<div className="details-form-label required">
																					Benefit amount
																				</div>
																				<Select
																					fullWidth
																					input={<CustomSelectInput />}
																					value={
																						depInputs.child_benefit_amount ||
																						""
																					}
																					onChange={(e: any) =>
																						handleDependencyPlanChange(
																							depPlanName,
																							depPlan,
																							{
																								child_benefit_amount:
																									e.target.value
																							},
																							"child"
																						)
																					}
																				>
																					{depPlan.benefit_amount.child.options.map(
																						(opt: any, idx: number) => (
																							<MenuItem
																								key={idx}
																								value={opt}
																							>
																								{opt}
																							</MenuItem>
																						)
																					)}
																				</Select>
																			</div>
																		</Grid>
																	)}
																	<Grid
																		item
																		xl={2}
																		lg={2}
																		md={2}
																		sm={2}
																		xs={12}
																		sx={{
																			position: "absolute",
																			top: 0,
																			right: 0,
																			display: "flex",
																			justifyContent: "flex-end",
																			padding: "8px 20px",
																			pointerEvents: "none"
																		}}
																	>
																		<div
																			className="details-form-row"
																			style={{ textAlign: "right" }}
																		>
																			<div className="details-form-label required align-center">
																				Premium
																			</div>
																			<div className="show-premium">
																				${depChildPremium.toFixed(2)}
																			</div>
																		</div>
																	</Grid>
																</Grid>
															)}
														</div>
													</div>
												)}
											</React.Fragment>
										);
									})}
							</>
						</Tooltip>

						{/* ── Total Premium ── */}
						<div className="theme-plan-inner-section-margin" />
						<Grid container style={{ width: "100%", marginRight: 0, marginTop: "8px" }}>
							<Grid
								item
								xs={12}
								style={{
									display: "flex",
									justifyContent: "flex-end",
									alignItems: "center",
									width: "100%"
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
										width: "100%",
										padding: "14px 14px",
										backgroundColor: "#f9fafb",
										borderRadius: 8,
										border: "1px solid #e5e7eb",
										marginTop: 0
									}}
								>
									<div style={{ display: "flex", flexDirection: "column" }}>
										<div style={{ fontSize: 15, fontWeight: 600, color: "#111827" }}>
											{`Total ${paycheck?.pay_frequency} premium`}
										</div>
										<div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
											Based on selected coverage
										</div>
									</div>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-end",
											justifyContent: "center"
										}}
									>
										<div
											style={{ fontSize: 13, fontWeight: 600, color: "#6b7280", marginBottom: 2 }}
										>
											Premium
										</div>
										<div
											className="show-premium"
											style={{ fontSize: 28, marginRight: 0, lineHeight: 1 }}
										>
											${totalPremium.toFixed(2)}
										</div>
									</div>
								</div>
							</Grid>

							<div className="accordion-container" style={{ width: "100%" }}>
								{Plan?.beneficiaries_required &&
									(planInputs?.benefit_amount ||
										planInputs.coverage_volume ||
										riderPlanInputs?.coverage_volume ||
										riderPlanInputs?.benefit_amount ||
										spousePlanInputs?.benefit_amount ||
										spousePlanInputs.coverage_volume ||
										riderSpousePlanInputs?.coverage_volume ||
										riderSpousePlanInputs?.benefit_amount) && (
										<Accordion
											expanded={expanded_panel === "panel_beneficiary"}
											onChange={(_, expanded) =>
												setExpandedPanel(expanded ? "panel_beneficiary" : false)
											}
										>
											<AccordionSummary
												aria-controls="panel1d-content"
												id="panel-header-beneficiary"
											>
												<Typography>Add Beneficiary</Typography>
											</AccordionSummary>
											<AccordionDetails>
												<Grid container justifyContent="center" alignItems="center">
													{member &&
														(planInputs?.benefit_amount ||
															planInputs.coverage_volume ||
															riderPlanInputs?.coverage_volume ||
															riderPlanInputs?.benefit_amount) && (
															<VEBBeneficiary
																primaryBeneficiary={beneficiaries.employeePrimary}
																setPrimaryBeneficiary={setBV2EmployeePrimaryBeneficiary}
																contingentBeneficiary={beneficiaries.employeeContingent}
																setContingentBeneficiary={
																	setBV2EmployeeContingentBeneficiary
																}
																member={member}
																employee={member}
																dependents={dependents}
																isAutoFilled={beneficiaries.employeePrimary.length > 0}
															/>
														)}
													{eligibelDependentSpouse &&
														(planInputs?.coverage === "Employee & Spouse" ||
															planInputs?.coverage === "Employee & Family" ||
															spousePlanInputs?.benefit_amount ||
															spousePlanInputs?.coverage_volume ||
															riderSpousePlanInputs?.coverage_volume ||
															riderSpousePlanInputs?.benefit_amount) && (
															<Grid item xl={12} lg={12} md={12}>
																<div className="theme-plan-section-margin" />
																<VEBBeneficiary
																	primaryBeneficiary={beneficiaries.spousePrimary}
																	setPrimaryBeneficiary={
																		setBV2SpousePrimaryBeneficiary
																	}
																	contingentBeneficiary={
																		beneficiaries.spouseContingent
																	}
																	setContingentBeneficiary={
																		setBV2SpouseContingentBeneficiary
																	}
																	member={eligibelDependentSpouse}
																	employee={member}
																	dependents={dependents}
																	isAutoFilled={
																		beneficiaries.spousePrimary.length > 0
																	}
																/>
															</Grid>
														)}
													{eligibelDependentChild &&
														(planInputs?.coverage === "Employee & Family" ||
															planInputs?.coverage === "Employee & Children" ||
															childPlanInputs?.benefit_amount ||
															childPlanInputs?.coverage_volume ||
															riderChildPlanInputs?.coverage_volume ||
															riderChildPlanInputs?.benefit_amount) && (
															<Grid item xl={12} lg={12} md={12}>
																<div className="theme-plan-section-margin" />
																<VEBBeneficiary
																	primaryBeneficiary={beneficiaries.childPrimary}
																	setPrimaryBeneficiary={
																		setBV2ChildPrimaryBeneficiary
																	}
																	contingentBeneficiary={
																		beneficiaries.childContingent
																	}
																	setContingentBeneficiary={
																		setBV2ChildContingentBeneficiary
																	}
																	isChild
																	member={member}
																	employee={member}
																	dependents={dependents}
																	isAutoFilled={beneficiaries.childPrimary.length > 0}
																/>
															</Grid>
														)}
												</Grid>
											</AccordionDetails>
										</Accordion>
									)}
							</div>
						</Grid>
						{Plan?.general_questions?.length > 0 && (
							<div style={{ padding: "20px" }}>
								<GEneralQuestionsModal
									questions={Plan?.general_questions}
									relation="EMPLOYEE"
									selectedAmount={0}
									giLimit={0}
									siLimit={0}
									onSubmit={(answers, hasAnyYes, eligible) => {
										giDataStoreRef.current = [
											...giDataStoreRef.current.filter((s) => s.role !== "employee"),
											{
												role: "employee",
												answers,
												eligible,
												reducedToGI: false,
												member_object_id: member?._id ?? "",
												member_SSN: member?.SSN ?? "",
												face_amount: 0,
												gi_limit: 0,
												exceeds_gi: false
											}
										];

										setGiDataStore([...giDataStoreRef.current]);

										giSubmittedStatusRef.current = true;
										setGiSubmittedStatus(true);

										if (!eligible) {
											alert("You are not eligible for this plan based on your answers.");
										}
									}}
								/>
							</div>
						)}

						<div
							className="theme-plan-option-content"
							style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}
						>
							<div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
								<Checkbox
									checked={isActivelyWorking}
									style={{ paddingLeft: 0 }}
									onChange={(e) => setIsActivelyWorking(e.target.checked)}
								/>
								<p className="theme-plan-checkbox-label" style={{ margin: 0 }}>
									<strong>Are you actively at work 20 or more hours per week?</strong>
								</p>
							</div>
							<div style={{ display: "flex", alignItems: "center" }} onClick={(e) => e.stopPropagation()}>
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={(e) => setHasReadTC(e.target.checked)}
								/>
								<p className="theme-plan-checkbox-label" style={{ margin: 0 }}>
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{
												color: theme.primary_color,
												cursor: "pointer",
												position: "relative",
												zIndex: 10
											}}
											onClick={(e) => {
												e.stopPropagation();
												e.preventDefault();
												handleOpenDisclaimerDialogClick();
											}}
										>
											Disclaimer
										</span>{" "}
										and agree to its terms
									</strong>
								</p>
							</div>
						</div>

						<div className="theme-plan-inner-section-margin-2" />
						<div style={{ marginTop: "20px" }}>
							<LazyPlanActions
								waiveButtonCallback={handleWaiveButtonClick}
								// Core plans submit through the core enrollment endpoint; VEB plans keep
								// their original handler untouched.
								activateButtonCallback={
									isCore ? handleActivateCoreButtonClick : handleActivateButtonClick
								}
							/>
						</div>
					</Paper>
				</div>
			</div>
		</>
	);
};

export default CommonForm;
